webpackJsonp([4,0],{

/***/ 3:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/**
	 * Created by jv on 04/01/2017.
	 */
	var config = __webpack_require__(495);
	
	var utils = {};
	var queryParams = void 0;
	
	(function (Utils) {
	  var MAX_UID = 1000000;
	
	  Utils.UUID = function () {
	    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
	      var r = Math.random() * 16 | 0,
	          v = c === "x" ? r : r & 0x3 | 0x8;
	      return v.toString(16);
	    });
	  };
	
	  Utils.generateUIDShort = function () {
	    return ("0000" + (Math.random() * Math.pow(36, 4) << 0).toString(36)).slice(-4);
	  };
	
	  Utils.generateElementId = function (prefix) {
	    do {
	      prefix += ~~(Math.random() * MAX_UID); // "~~" acts like a faster Math.floor() here
	    } while (document.getElementById(prefix));
	
	    return prefix;
	  };
	
	  Utils.redirect = function (link) {
	    window.location.href = link;
	  };
	
	  Utils.reloadPage = function (forceReload) {
	    window.location.reload(forceReload);
	  };
	
	  // %note: might be better to use https://www.npmjs.com/package/lodash for most of these utility functions
	  Utils.isUndefined = function (obj) {
	    return typeof obj === "undefined";
	  };
	
	  Utils.isDefined = function (obj) {
	    return !Utils.isUndefined(obj);
	  };
	
	  Utils.isNull = function (obj) {
	    return typeof obj === "undefined" || obj === null;
	  };
	
	  Utils.isNotNull = function (obj) {
	    return !Utils.isNull(obj);
	  };
	
	  Utils.isNullOrEmpty = function (str) {
	    return Utils.isNull(str) || str === "";
	  };
	
	  Utils.isString = function (value) {
	    return Utils.isNotNull(value) && typeof value === "string";
	  };
	
	  Utils.isBoolean = function (value) {
	    return value === true || value === false;
	  };
	
	  Utils.isNumber = function (value) {
	    return Utils.isNotNull(value) && !isNaN(value) && typeof value === "number";
	  };
	
	  Utils.isArray = function (obj) {
	    return Utils.isNotNull(obj) && Array.isArray(obj);
	  };
	
	  Utils.isObject = function (obj) {
	    return Utils.isNotNull(obj) && (typeof obj === "undefined" ? "undefined" : _typeof(obj)) === "object";
	  };
	
	  Utils.isMomentObject = function (obj) {
	    return Utils.isObject(obj) && obj.hasOwnProperty("_isAMomentObject") && obj._isAMomentObject === true;
	  };
	
	  Utils.isFunction = function (obj) {
	    return typeof obj === "function";
	  };
	
	  Utils.isValidEmail = function (email) {
	    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	    return re.test(email);
	  };
	
	  Utils.defaultFor = function (value, defaultValue, type) {
	    if (Utils.isNotNull(type) && (typeof value === "undefined" ? "undefined" : _typeof(value)) !== type) {
	      return defaultValue;
	    }
	
	    return Utils.isNotNull(value) ? value : defaultValue;
	  };
	
	  Utils.stringToInt = function (value) {
	    if (/^(\-|\+)?([0-9]+|Infinity)$/.test(value)) {
	      return Number(value);
	    }
	
	    return NaN;
	  };
	
	  Utils.stringToBoolean = function (value) {
	    return Utils.isNotNull(value) && (value === "true" || value === true) ? true : false;
	  };
	
	  Utils.parseFloat = function (value) {
	    var parsedValue = parseFloat(value);
	
	    if (Utils.isNumber(parsedValue)) {
	      return parsedValue;
	    }
	
	    return null;
	  };
	
	  Utils.stringifyJSON = function (obj, replacer, space) {
	    return JSON.stringify(obj, replacer, space);
	  };
	
	  Utils.parseJSON = function (str, safe, nullOnError) {
	    if (safe) {
	      try {
	        var objValue = JSON.parse(str);
	        return objValue;
	      } catch (e) {
	        return nullOnError ? null : str;
	      }
	    } else {
	      return JSON.parse(str);
	    }
	  };
	
	  Utils.rgbToHex = function (r, g, b) {
	    if (r > 255 || g > 255 || b > 255) {
	      throw "Invalid color component";
	    }
	
	    var hex = (r << 16 | g << 8 | b).toString(16);
	    return "#" + ("000000" + hex).slice(-6);
	  };
	
	  Utils.hexToRgb = function (hex) {
	    // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
	    var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
	    hex = hex.replace(shorthandRegex, function (m, r, g, b) {
	      return r + r + g + g + b + b;
	    });
	
	    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
	    return result ? {
	      r: parseInt(result[1], 16),
	      g: parseInt(result[2], 16),
	      b: parseInt(result[3], 16)
	    } : null;
	  };
	
	  Utils.hexToCmyk = function (hex) {
	    var computedC = void 0;
	    var computedM = void 0;
	    var computedY = void 0;
	    var computedK = void 0;
	
	    hex = hex.replace("#", "");
	
	    if (hex.length !== 6) {
	      return null;
	    }
	    if (/[0-9a-f]{6}/i.test(hex) !== true) {
	      return null;
	    }
	
	    var r = parseInt(hex.substring(0, 2), 16);
	    var g = parseInt(hex.substring(2, 4), 16);
	    var b = parseInt(hex.substring(4, 6), 16);
	
	    // BLACK
	    if (r === 0 && g === 0 && b === 0) {
	      return {
	        c: 0,
	        m: 0,
	        y: 0,
	        k: 1
	      };
	    }
	
	    computedC = 1 - r / 255;
	    computedM = 1 - g / 255;
	    computedY = 1 - b / 255;
	
	    var minCMY = Math.min(computedC, Math.min(computedM, computedY));
	
	    computedC = (computedC - minCMY) / (1 - minCMY);
	    computedM = (computedM - minCMY) / (1 - minCMY);
	    computedY = (computedY - minCMY) / (1 - minCMY);
	    computedK = minCMY;
	
	    return {
	      c: computedC,
	      m: computedM,
	      y: computedY,
	      k: computedK
	    };
	  };
	
	  Utils.roundNumber = function (number, decimals) {
	    if (Utils.isNumber(number)) {
	      var rounder = Math.pow(10, decimals);
	      return Math.round(number * rounder) / rounder;
	    }
	
	    return NaN;
	  };
	
	  Utils.format = function (format) {
	    var args = Array.prototype.slice.call(arguments, 1);
	    return format.replace(/{(\d+)}/g, function (match, number) {
	      return utils.isDefined(args[number]) ? args[number] : match;
	    });
	  };
	
	  Utils.formatMoney = function (value, currency) {
	    if (currency.beforePrice) {
	      return currency.escapedSymbol + "" + utils.formatNumber(utils.roundNumber(value, 2), { decimalLength: 2 });
	    }
	
	    return utils.formatNumber(utils.roundNumber(value, 2), { decimalLength: 2 }) + "" + currency.symbol;
	  };
	
	  Utils.formatNumber = function (value, options) {
	    if (!utils.isNumber(value)) return null;
	
	    options = utils.isNotNull(options) ? options : {};
	
	    var decimalLength = ~~options.decimalLength,
	        groupLength = utils.isNumber(options.groupLength) ? options.groupLength : 3,
	        groupDelimiter = options.groupDelimiter || ",",
	        decimalDelimiter = options.decimalDelimiter;
	
	    var re = "\\d(?=(\\d{" + groupLength + "})+" + (decimalLength > 0 ? "\\D" : "$") + ")",
	        num = value.toFixed(Math.max(0, decimalLength));
	
	    return (decimalDelimiter ? num.replace(".", decimalDelimiter) : num).replace(new RegExp(re, "g"), "$&" + groupDelimiter);
	  };
	
	  Utils.getRandomIntInclusive = function (min, max) {
	    min = Math.ceil(min);
	    max = Math.floor(max);
	    return Math.floor(Math.random() * (max - min + 1)) + min;
	  };
	
	  Utils.getContrastYIQ = function (hexColor) {
	    hexColor = hexColor.replace("#", "");
	
	    var r = parseInt(hexColor.substr(0, 2), 16);
	    var g = parseInt(hexColor.substr(2, 2), 16);
	    var b = parseInt(hexColor.substr(4, 2), 16);
	    var yiq = (r * 299 + g * 587 + b * 114) / 1000;
	
	    return yiq;
	  };
	
	  Utils.getContrastColor = function (color, options) {
	    options = Utils.isNotNull(options) ? options : {};
	
	    var yiqColor = Utils.getContrastYIQ(color);
	
	    var threshold = Utils.isNumber(options.threshold) ? options.threshold : 256 / 2;
	    var belowThresholdColor = Utils.isNotNull(options.belowThresholdColor) ? options.belowThresholdColor : "#ffffff";
	    var aboveThresholdColor = Utils.isNotNull(options.aboveThresholdColor) ? options.aboveThresholdColor : "#000000";
	
	    return yiqColor < threshold ? belowThresholdColor : aboveThresholdColor;
	  };
	
	  Utils.invertColor = function (hexColor) {
	    hexColor = hexColor.replace("#", ""); // remove #
	    hexColor = parseInt(hexColor, 16); // convert to integer
	    hexColor = 0xFFFFFF ^ hexColor; // invert three bytes
	    hexColor = hexColor.toString(16); // convert to hex
	    hexColor = ("000000" + hexColor).slice(-6); // pad with leading zeros
	    hexColor = "#" + hexColor; // prepend #
	
	    return hexColor;
	  };
	
	  Utils.arraysAreEqual = function (arr1, arr2) {
	    if (arr1 === arr2) return true;
	    if (utils.isNull(arr1) || utils.isNull(arr2)) return false;
	    if (arr1.length !== arr2.length) return false;
	
	    for (var i = 0; i < arr1.length; i++) {
	      if (arr1[i] !== arr2[i]) return false;
	    }
	
	    return true;
	  };
	
	  Utils.resetFormElement = function (el) {
	    $(el).wrap("<form></form>").closest("form").get(0).reset();
	    $(el).unwrap();
	  };
	
	  Utils.setButtonLoading = function ($element, flag) {
	    if (utils.isNull($element) || !$element.length) return;
	
	    $element.prop("disabled", flag);
	
	    if (flag) {
	      $element.addClass("btn-loading");
	    } else {
	      $element.removeClass("btn-loading");
	    }
	  };
	
	  Utils.getServiceUrl = function (path) {
	    return config.serviceBaseURL + path;
	  };
	
	  Utils.luhnCheck = function (str) {
	    return str.split("").reduceRight(function (prev, curr, idx) {
	      if ((idx + 1) % 2 !== 0) {
	        curr = (curr * 2).toString().split("").reduce(function (p, c) {
	          return +p + +c;
	        });
	      }
	      return +prev + +curr;
	    }) % 10 === 0;
	  };
	
	  Utils.resolveProperty = function (path, obj) {
	    return path.split(".").reduce(function (prev, curr) {
	      return prev ? prev[curr] : null;
	    }, obj || self);
	  };
	
	  Utils.setPropertyValue = function (path, obj, value, createMissing) {
	    return path.split(".").reduce(function (prev, curr, index, arr) {
	      if (createMissing && utils.isNotNull(prev) && !prev.hasOwnProperty(curr)) {
	        if (index < arr.length - 1) {
	          prev[curr] = {};
	        }
	      }
	
	      // Note: maybe add check to see if prev is an object and also check to see
	
	      if (index === arr.length - 1) {
	        prev[curr] = value;
	      }
	
	      return prev ? prev[curr] : null;
	    }, obj || self);
	  };
	
	  Utils.getQueryParam = function (name) {
	    return queryParams[name];
	  };
	
	  Utils.getUrlPath = function () {
	    return window.location.pathname;
	  };
	
	  Utils.getPathSection = function (index) {
	    var path = window.location.pathname;
	    var pathSections = path.split("/");
	
	    for (var i = 0; i < pathSections.length; i++) {
	      var pathSection = pathSections[i];
	
	      if (Utils.isNullOrEmpty(pathSection)) {
	        index++;
	        continue;
	      }
	
	      if (i + 1 === index) {
	        return pathSection;
	      }
	    }
	
	    return null;
	  };
	
	  Utils.getPathSectionLength = function () {
	    var path = window.location.pathname;
	    var pathSections = path.split("/");
	
	    return pathSections.length;
	  };
	
	  Utils.btoa = function (stringToEncode) {
	    return Utils.isNotNull(stringToEncode) ? window.btoa(encodeURIComponent(stringToEncode)) : null;
	  };
	
	  Utils.atob = function (stringToDecode) {
	    return Utils.isNotNull(stringToDecode) ? decodeURIComponent(window.atob(stringToDecode)) : null;
	  };
	
	  var entityMap = {
	    "&": "&amp;",
	    "<": "&lt;",
	    ">": "&gt;",
	    '"': "&quot;", // eslint-disable-line
	    "'": "&#39;",
	    "/": "&#x2F;"
	  };
	
	  Utils.escapeHtml = function (string) {
	    return String(string).replace(/[&<>"'\/]/g, function (s) {
	      return entityMap[s];
	    });
	  };
	
	  Utils.debounce = function (func, wait, immediate, context) {
	    var timeout = void 0;
	    return function () {
	      context = context || this;
	      var args = arguments;
	      var later = function later() {
	        timeout = null;
	        if (!immediate) func.apply(context, args);
	      };
	
	      var callNow = immediate && !timeout;
	      clearTimeout(timeout);
	      timeout = setTimeout(later, wait);
	      if (callNow) func.apply(context, args);
	    };
	  };
	})(utils);
	
	// Load query parameters once
	(window.onpopstate = function () {
	  var match = void 0,
	      pl = /\+/g,
	      // Regex for replacing addition symbol with a space
	  search = /([^&=]+)=?([^&]*)/g,
	      decode = function decode(s) {
	    return decodeURIComponent(s.replace(pl, " "));
	  },
	      query = window.location.search.substring(1);
	
	  queryParams = {};
	  while (match = search.exec(query)) {
	    var name = decode(match[1]);
	    var value = decode(match[2]);
	
	    if (queryParams.hasOwnProperty(name)) {
	      if (!utils.isArray(queryParams[name])) {
	        // Make it an array
	        queryParams[name] = [queryParams[name]];
	      }
	
	      queryParams[name].push(value);
	    } else {
	      queryParams[name] = value;
	    }
	  }
	})();
	
	module.exports = utils;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),

/***/ 5:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	/**
	 * Created by jv on 25/07/2017.
	 */
	var utils = __webpack_require__(3);
	
	var hasLogged = false;
	
	module.exports = function (debug) {
	  var Logger = {};
	
	  // function init(force)
	  // {
	  //   if(debug || __DEVELOPMENT__ || force)
	  //   {
	  //     for(var m in console)
	  //     {
	  //       if(utils.isFunction(console[m]))
	  //       {
	  //         Logger[m] = console[m].bind(window.console);
	  //       }
	  //     }
	  //
	  //     Logger.cssLog = function(...args)
	  //     {
	  //       if(!hasLogged)
	  //       {
	  //         Logger.info("If you want to preserve the correct file name and line number stuff then you can add the logger.js script to the blackbox (chrome)\nThis basically removes the file from debugging, read: https://developer.chrome.com/devtools/docs/blackboxing");
	  //         hasLogged = true;
	  //       }
	  //
	  //       args = Logger.cssify.apply(null, args);
	  //       return Logger.log.apply(null, args);
	  //     }
	  //   }
	  //   else
	  //   {
	  //     for(var m in console)
	  //     {
	  //       if(utils.isFunction(console[m]))
	  //       {
	  //         Logger[m] = () => {};
	  //       }
	  //     }
	  //
	  //     Logger.cssLog = () => {};
	  //   }
	  // }
	  //
	  // init();
	
	  function isDebug() {
	    if (!window.console || !window.console.info || !window.console.debug || !window.console.error || !window.console.log || !window.console.warn || !window.console.trace) {
	      return false;
	    }
	
	    return debug || (false) || window.__PRODUCTION_LOGGING__;
	  }
	
	  function firstLogCheck() {
	    if (!hasLogged) {
	      console.log("If you want to preserve the correct file name and line number stuff then you can add the logger.js script to the blackbox (chrome)\nThis basically removes the file from debugging, read: https://developer.chrome.com/devtools/docs/blackboxing");
	      hasLogged = true;
	    }
	  }
	
	  Logger.trace = function () {
	    if (isDebug()) {
	      firstLogCheck();
	
	      try {
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	          args[_key] = arguments[_key];
	        }
	
	        console.trace.apply(null, args);
	      } catch (e) {
	        console.error(e);
	      }
	    }
	  };
	
	  Logger.debug = function () {
	    if (isDebug()) {
	      firstLogCheck();
	
	      try {
	        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	          args[_key2] = arguments[_key2];
	        }
	
	        console.debug.apply(null, args);
	      } catch (e) {
	        console.error(e);
	      }
	    }
	  };
	
	  Logger.log = function () {
	    if (isDebug()) {
	      firstLogCheck();
	
	      try {
	        for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	          args[_key3] = arguments[_key3];
	        }
	
	        console.log.apply(null, args);
	      } catch (e) {
	        console.error(e);
	      }
	    }
	  };
	
	  Logger.info = function () {
	    if (isDebug()) {
	      firstLogCheck();
	
	      try {
	        for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
	          args[_key4] = arguments[_key4];
	        }
	
	        console.info.apply(null, args);
	      } catch (e) {
	        console.error(e);
	      }
	    }
	  };
	
	  Logger.cssLog = function () {
	    for (var _len5 = arguments.length, args = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
	      args[_key5] = arguments[_key5];
	    }
	
	    if (isDebug()) {
	      firstLogCheck();
	      args = Logger.cssify.apply(null, args);
	
	      try {
	        console.log.apply(null, args);
	      } catch (e) {
	        console.error(e);
	      }
	    }
	  };
	
	  Logger.warn = function () {
	    if (isDebug()) {
	      firstLogCheck();
	
	      try {
	        for (var _len6 = arguments.length, args = Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
	          args[_key6] = arguments[_key6];
	        }
	
	        console.warn.apply(null, args);
	      } catch (e) {
	        console.error(e);
	      }
	    }
	  };
	
	  Logger.error = function () {
	    if (isDebug()) {
	      firstLogCheck();
	
	      try {
	        for (var _len7 = arguments.length, args = Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
	          args[_key7] = arguments[_key7];
	        }
	
	        console.error.apply(null, args);
	      } catch (e) {
	        console.error(e);
	      }
	    }
	  };
	
	  Logger.cssify = function () {
	    for (var _len8 = arguments.length, args = Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
	      args[_key8] = arguments[_key8];
	    }
	
	    if (args.length > 1) {
	      var css = args[args.length - 1];
	      args.splice(args.length - 1, 1);
	
	      var cssString = "";
	
	      for (var key in css) {
	        if (css.hasOwnProperty(key)) {
	          cssString += key + ": " + css[key] + ";";
	        }
	      }
	
	      if (utils.isString(args[0])) {
	        if ((args[0].match(/%c/g) || []).length === 0) {
	          // Css applies to the whole text so just insert the css at the second (first is the text) and last place
	          args[0] = "%c" + args[0] + "%c";
	
	          args.splice(1, 0, cssString);
	          //Resets the css
	          args.push("");
	        } else if (args.length === 1) {
	          //If there's only text with no arguments, same as before, insert css at second and last place
	          args.push(cssString);
	          //Resets the css
	          args.push("");
	        } else {
	          // Determine where the css arguments need to go in the array
	          /*
	             %s - String.
	             %d - Number (integer or floating point value).
	             %i - Integer.
	             %f - Floating point value.
	             %j - JSON. Replaced with the string '[Circular]' if the argument contains circular references.
	             %o - JavaScript Object
	           */
	
	          // position BEFORE the first %c
	          var startPos = args[0].indexOf("%c");
	          // position AFTER the last %c
	          var endPos = args[0].lastIndexOf("%c") + 2;
	
	          if (startPos !== -1 && endPos !== -1 && startPos !== endPos) {
	            var leftSubString = args[0].substring(0, startPos);
	            var rightSubString = args[0].substr(endPos);
	            // Find all format occurrences
	            var firstInsert = (leftSubString.match(/(%s|%d|%i|%f|%j|%o)/g) || []).length;
	            var secondInsert = (rightSubString.match(/(%s|%d|%i|%f|%j|%o)/g) || []).length;
	
	            // Account for the text that's in the first position
	            args.splice(firstInsert + 1, 0, cssString);
	            //Resets the css
	            args.splice(args.length - secondInsert, 0, "");
	          }
	        }
	      }
	
	      return args;
	    }
	  };
	
	  // http://www.flatuicolorpicker.com/
	  /*
	    SUMMER SKY
	    1E8BC3
	    30, 139, 195
	   */
	  Logger.infoCss = {
	    "background-color": "#1E8BC3",
	    "color": "#ffffff"
	  };
	
	  /*
	    EUCALYPTUS
	    26A65B
	    38, 166, 91
	   */
	  Logger.successCss = {
	    "background-color": "#26A65B",
	    "color": "#ffffff"
	  };
	
	  /*
	    SANDSTORM
	    F9BF3B
	    249, 191, 59
	   */
	  Logger.warningCss = {
	    "background-color": "#F9BF3B",
	    "color": "#000000"
	  };
	
	  /*
	    FLAMINGO
	    EF4836
	    239, 72, 54
	   */
	  Logger.errorCss = {
	    "background-color": "#EF4836",
	    "color": "#ffffff"
	  };
	
	  return Logger;
	};
	
	/*
	Examples:

	logger.info("Hi");
	logger.warn("Warning");
	logger.error("Error");
	logger.cssLog("Hi %s", "Jan", logger.successCss);
	logger.cssLog("Hi %cthere Jan%c", logger.warningCss);
	logger.cssLog("Hi there %s, my name is %c%s and I am%c %d", "Jan", "Someone", 23, logger.errorCss);
	*/

/***/ }),

/***/ 6:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/**
	 * User: jv
	 * Date: 12/05/16
	 * Time: 12:56
	 */
	var utils = __webpack_require__(3);
	var log = __webpack_require__(5)();
	var CONSTANTS = __webpack_require__(54);
	var localeReq = __webpack_require__(11);
	
	var LanguageManager = {};
	
	(function (LanguageManager) {
	  var locale = null;
	  var localeMap = null;
	
	  LanguageManager.init = function () {
	    locale = localStorage.getItem("locale");
	
	    var tmpLocale = utils.getQueryParam("locale");
	    if (!utils.isNullOrEmpty(tmpLocale)) {
	      locale = tmpLocale;
	      localStorage.setItem("locale", locale);
	    }
	
	    if (utils.isNullOrEmpty(locale) || !localeExists(locale)) {
	      locale = CONSTANTS.DEFAULT_LOCALE;
	    }
	
	    $("html").addClass(locale);
	
	    _init();
	  };
	
	  function _init() {
	    getLocaleMap();
	    applyLocale();
	    $(".page-wrapper").show();
	
	    if (utils.isFunction(LanguageManager.onInit)) {
	      LanguageManager.onInit();
	    }
	
	    if (utils.isFunction(LanguageManager.onInitGlobal)) {
	      LanguageManager.onInitGlobal();
	    }
	  }
	
	  LanguageManager.onInit = null;
	
	  LanguageManager.onInitGlobal = null;
	
	  LanguageManager.changeLocale = function (newLocale) {
	    if (localeExists(newLocale)) {
	      $("html").removeClass(locale).addClass(newLocale);
	      locale = newLocale;
	      localStorage.setItem("locale", locale);
	      LanguageManager.localize();
	    } else {
	      throw "Locale does not exist";
	    }
	  };
	
	  LanguageManager.getCurrentLocale = function () {
	    return locale;
	  };
	
	  LanguageManager.localize = function () {
	    if (!localeMapIsDefined() || locale !== localeMap.locale) {
	      getLocaleMap();
	      applyLocale();
	    } else {
	      applyLocale();
	    }
	  };
	
	  function getLocaleMap() {
	    try {
	      log.info("Trying to fetch locale '%s'", locale);
	
	      var localeRequire = "./" + locale + ".json";
	
	      log.info("'%s' is in %o ? %s", localeRequire, localeReq.keys(), $.inArray(localeRequire, localeReq.keys()) !== -1);
	
	      if ($.inArray(localeRequire, localeReq.keys()) !== -1) {
	        var tmpLocaleMap = localeReq(localeRequire);
	
	        log.info("Successfully fetched locale map for locale [%s]: %o", locale, tmpLocaleMap);
	
	        localeMap = tmpLocaleMap;
	      } else if (locale !== "nl-BE" && $.inArray("./nl-BE.json", localeReq.keys()) !== -1) {
	        $("html").removeClass(locale).addClass("nl-BE");
	        locale = "nl-BE";
	        localStorage.setItem("locale", locale);
	        getLocaleMap(callback);
	      } else {
	        log.error("Couldn't find locale [%s] in known locale list: %o", locale, localeReq.keys());
	        alert("Localisation could not be loaded, contact your site administrator.");
	      }
	    } catch (e) {
	      console.error(e);
	    }
	  }
	
	  function localeExists(pLocale) {
	    var localeRequire = "./" + pLocale + ".json";
	
	    return $.inArray(localeRequire, localeReq.keys()) !== -1;
	  }
	
	  LanguageManager.applyLocale = function (selector) {
	    if (localeMapIsDefined() && locale === localeMap.locale) {
	      // Add back to include the selector itself
	      applyLocale($(selector).find("[data-localize]").addBack(selector).filter("[data-localize]"));
	    }
	  };
	
	  function applyLocale($element) {
	    $element = utils.isNotNull($element) ? $element : $("[data-localize]");
	
	    $element.each(function () {
	      var element = $(this);
	      var key = $(this).data("localize");
	
	      if ((typeof localeMap === "undefined" ? "undefined" : _typeof(localeMap)) === "object" && localeMap.localization.hasOwnProperty(key)) {
	        changeTextOrPlaceholder(element, localeMap.localization[key]);
	      } else {
	        changeTextOrPlaceholder(element, key);
	      }
	    });
	  }
	
	  function changeTextOrPlaceholder(element, text) {
	    if (element.is("input") || element.is("textarea")) {
	      //element.attr("placeholder", text.toLowerCase());
	      element.attr("placeholder", text);
	    } else {
	      replaceNodeText(element, text);
	    }
	  }
	
	  function replaceNodeText(element, text) {
	    element.html(text);
	  }
	
	  LanguageManager.getValueForKey = function (key) {
	    if (localeMapIsDefined() && localeMap.localization.hasOwnProperty(key)) {
	      return localeMap.localization[key];
	    } else {
	      return key;
	    }
	  };
	
	  function localeMapIsDefined() {
	    return utils.isObject(localeMap) && localeMap.hasOwnProperty("locale") && localeMap.hasOwnProperty("localization");
	  }
	})(LanguageManager);
	
	module.exports = LanguageManager;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),

/***/ 10:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	var _languageManager = __webpack_require__(6);
	
	var _languageManager2 = _interopRequireDefault(_languageManager);
	
	var _utils = __webpack_require__(3);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _modal = __webpack_require__(353);
	
	var _modal2 = _interopRequireDefault(_modal);
	
	var _creditsDialog = __webpack_require__(345);
	
	var _creditsDialog2 = _interopRequireDefault(_creditsDialog);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Created by jv on 10/03/2017.
	 */
	// Styles
	__webpack_require__(725);
	__webpack_require__(392);
	__webpack_require__(724);
	
	// js
	//require("script-loader!Sources/misc/google-analytics");
	__webpack_require__(518);
	// Polyfill promises
	__webpack_require__(722);
	__webpack_require__(505);
	// These libs aren't nice and put themselves in window instead of being able to be required into a variable
	// prepend the JS files with 'script-loader?' to require them like they were added with ordinary <script> tags
	// https://webpack.github.io/docs/shimming-modules.html
	__webpack_require__(862); // Is used to check if browser is outdated
	__webpack_require__(448); // requires the cookieconsent library like it was a script tag in the html
	__webpack_require__(860);
	
	var CookieConsentController = __webpack_require__(500);
	
	// Dark mode favicon
	var faviconDark = __webpack_require__(902);
	
	// Global app styles (after external libs)
	__webpack_require__(755);
	
	var log = __webpack_require__(5)();
	
	
	var Shared = {};
	
	(function (Shared) {
	  var creditsDialog = void 0;
	  Shared.shouldSetUpCreditsDialog = true;
	
	  Shared.init = function () {
	    if (Shared.isOutdated()) {
	      log.info("Browser is outdated, redirecting to /outdated");
	      _utils2.default.redirect("/outdated");
	    }
	
	    var userData = Shared.getUserData();
	
	    if (_utils2.default.isNotNull(userData)) {
	      log.info("User: %o", userData);
	    }
	
	    if (false) {} else {
	      if (_utils2.default.isNotNull(userData)) {}
	      // ga("set", "userId", userData.userKey);
	      // ga("set", "dimension1", userData.userKey);
	
	
	      // ga("send", "pageview");
	    }
	
	    setUpMatchMedia();
	
	    // Set default nav link highlight (try to find it based on current path
	    Shared.setNavHighlight();
	
	    setUpFragmentImages();
	
	    _languageManager2.default.init();
	  };
	
	  _languageManager2.default.onInitGlobal = function () {
	    // Needs to be done after localization has been applied
	    setUpProfileTooltip();
	    if (Shared.shouldSetUpCreditsDialog) setUpCreditsDialog();
	
	    try {
	      var isCms = $("body").hasClass("cms");
	
	      /*
	      cookieconsent.initialise({
	        palette: {
	          popup: {
	            background: "#222222",
	            text: "#ffffff"
	          },
	          button: {
	            background: isCms ? "#57B67D" : "#679CD3",
	            text: "#ffffff"
	          }
	        },
	        theme: "classic",
	        content: {
	          message: LanguageManager.getValueForKey("cookies.message"),
	          dismiss: LanguageManager.getValueForKey("cookies.button.text"),
	          link: LanguageManager.getValueForKey("cookies.link.text"),
	          href: LanguageManager.getValueForKey("cookies.link")
	        }
	      });
	        */
	
	      CookieConsentController.initialize();
	    } catch (e) {
	      console.error(e);
	    }
	  };
	
	  Shared.setNavHighlight = function (href) {
	    href = _utils2.default.isNotNull(href) ? href : _utils2.default.getUrlPath();
	
	    $("header .navbar-nav .nav-item a.nav-link").each(function (index, el) {
	      var $el = $(el);
	      var navLink = $el.attr("href"),
	          alternatives = $el.data("link-alternatives");
	
	      if (href === navLink || _utils2.default.isNotNull(alternatives) && alternatives.split(";").includes(href)) {
	        $el.addClass("active");
	      }
	    });
	
	    $("header .navbar-nav .nav-item a.nav-link[href='" + href + "']").addClass("active");
	  };
	
	  Shared.isOutdated = function () {
	    return !Modernizr.filereader;
	  };
	
	  Shared.getUserData = function () {
	    var userData = $("#logged-in-user-data").attr("data-user");
	    if (_utils2.default.isNotNull(userData)) {
	      userData = decodeURIComponent(userData);
	
	      if (_utils2.default.isNotNull(userData)) {
	        userData = _utils2.default.parseJSON(userData, true);
	      }
	    }
	    return userData;
	  };
	
	  Shared.isLoggedIn = function () {
	    return _utils2.default.isNotNull(Shared.getUserData());
	  };
	
	  function setUpFragmentImages() {
	    var headerLogoGT = __webpack_require__(450);
	
	    $("#header-circonopoly-brand").append("<img src='" + headerLogoGT + "' alt='Grow Talent'/>");
	
	    var headerLogo = __webpack_require__(451);
	    // let footerLogo = require("Images/footer/cartamundi-logo.png");
	
	    $("#header-circonopoly-brand").append("<img src='" + headerLogo + "' alt='Circonopoly'/>");
	    // $("#footer-main-logo").append("<img src='" + footerLogo + "'/>");
	  }
	
	  function setUpMatchMedia() {
	    // Matches the favicon to the current preferred color scheme
	
	    if (!_utils2.default.isFunction(window.matchMedia)) {
	      return;
	    }
	
	    var faviconDarkLink = document.createElement("link");
	    faviconDarkLink.setAttribute("rel", "favicon icon");
	    faviconDarkLink.setAttribute("type", "image/png");
	    faviconDarkLink.setAttribute("media", "(prefers-color-scheme:dark)");
	    faviconDarkLink.setAttribute("href", faviconDark);
	    document.head.appendChild(faviconDarkLink);
	
	    var links = collectLinks();
	
	    var current = document.createElement("link");
	    current.setAttribute("rel", "shortcut icon");
	    document.head.appendChild(current);
	
	    function faviconApplyLoop() {
	      links.forEach(function (link) {
	        if (window.matchMedia(link.media).matches) {
	          current.setAttribute("type", link.getAttribute("type"));
	          current.setAttribute("href", link.getAttribute("href"));
	        }
	      });
	    }
	
	    faviconApplyLoop();
	    links.forEach(function (link) {
	      document.head.removeChild(link);
	    });
	
	    var lightMediaMatch = window.matchMedia("(prefers-color-scheme:light)");
	    var darkMediaMatch = window.matchMedia("(prefers-color-scheme:dark)");
	
	    if (_utils2.default.isFunction(lightMediaMatch.addEventListener)) {
	      /*
	        This is basically an alias for EventTarget.addEventListener(), for backwards compatibility purposes.
	        Older browsers should use addListener instead of addEventListener since MediaQueryList only inherits from EventTarget in newer browsers.
	      */
	
	      lightMediaMatch.addEventListener("change", function (e) {
	        if (!e.matches) return;
	        faviconApplyLoop();
	      });
	
	      darkMediaMatch.addEventListener("change", function (e) {
	        if (!e.matches) return;
	        faviconApplyLoop();
	      });
	    } else {
	      // noinspection JSDeprecatedSymbols
	      lightMediaMatch.addListener(function (e) {
	        if (!e.matches) return;
	        faviconApplyLoop();
	      });
	
	      // noinspection JSDeprecatedSymbols
	      darkMediaMatch.addListener(function (e) {
	        if (!e.matches) return;
	        faviconApplyLoop();
	      });
	    }
	  }
	
	  function collectLinks() {
	    return Array.prototype.slice.apply(document.head.querySelectorAll("link[rel*='icon']"));
	  }
	
	  function setUpProfileTooltip() {
	    var $trigger = $("[data-nav-trigger='tooltip']");
	    var $popoverContent = $trigger.next();
	    $popoverContent = $($popoverContent.prop("outerHTML")).css("display", "").prop("outerHTML");
	
	    $trigger.popover({
	      content: $popoverContent,
	      html: true,
	      template: "<div class='popover popover-c-blue user-profile-popover' role='tooltip'><div class='popover-arrow'></div><div class='popover-body'></div></div>"
	    });
	
	    /*$trigger.on("hide.bs.popover", (e) =>
	    {
	      let $this = $(e.currentTarget);
	      let $popover = $(".user-profile-popover");
	      if(($popover.length && $popover.is(":hover")) || ($this.length && $this.is(":hover")))
	      {
	        log.info("HOVERING");
	        e.preventDefault();
	      }
	    });*/
	  }
	
	  function setUpCreditsDialog() {
	    if (_utils2.default.isNotNull(creditsDialog)) {
	      creditsDialog.destroy();
	    }
	
	    creditsDialog = new _creditsDialog2.default({
	      onCancel: function onCancel() {
	        creditsDialog.hide();
	      }
	    });
	
	    creditsDialog.create();
	
	    $("#header-circonopoly-brand").off("click").on("click", function (e) {
	      e.preventDefault();
	      e.stopPropagation();
	
	      if (_utils2.default.isNotNull(creditsDialog)) {
	        creditsDialog.show(true);
	      }
	    });
	  }
	
	  Shared.showNavProfileDropdown = function () {
	    $("#nav-index-breadcrumb").hide();
	    $("#nav-profile-dropdown").show();
	  };
	
	  Shared.showNavIndexBreadcrumb = function (activeIndex, labelType, hidden) {
	    $("#nav-profile-dropdown").hide();
	
	    var $roundsBreadcrumb = $("#nav-index-breadcrumb");
	
	    if (hidden) {
	      $roundsBreadcrumb.find(".round-breadcrumb__wrapper").hide();
	    } else {
	      $roundsBreadcrumb.find(".round-breadcrumb__wrapper").show();
	
	      var labelKey = labelType === "quiz" ? "serious_game.rounds_breadcrumb.labels.quiz" : "serious_game.rounds_breadcrumb.labels.business_model";
	      $roundsBreadcrumb.find(".breadcrumb__label").text(_languageManager2.default.getValueForKey(labelKey));
	
	      $roundsBreadcrumb.find(".round-breadcrumb__item").each(function (index, el) {
	        var $el = $(el).removeClass("active");
	
	        // index is zero based (round 1 == index 0)
	        if (activeIndex === index + 1) {
	          $el.addClass("active");
	        }
	      });
	    }
	
	    $roundsBreadcrumb.show();
	  };
	
	  Shared.Dialog = _modal2.default;
	
	  return Shared;
	})(Shared);
	
	module.exports = Shared;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),

/***/ 24:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Created by jv on 20/07/2017.
	 */
	var utils = __webpack_require__(3);
	var Tooltip = __webpack_require__(494);
	var log = __webpack_require__(5)();
	
	module.exports = function () {
	  function FormValidator(options) {
	    _classCallCheck(this, FormValidator);
	
	    if (utils.isNull(options)) {
	      throw "options must be defined";
	    }
	
	    this.selector = $(options.selector);
	    // Rules either come from javascript in this property or from data attributes
	    // eg. data-fv-required="true" data-fv-min-length="6" data-fv-max-length="30" data-fv-same-as="something"
	    // if both are present then rules from javascript take priority
	    this.rules = options.rules;
	
	    this.errorClassName = utils.isNullOrEmpty(options.errorClassName) ? "is-invalid" : options.errorClassName;
	
	    this.validateOnChange = utils.isBoolean(options.validateOnChange) ? options.validateOnChange : false;
	    this.onValidateElement = options.onValidateElement;
	
	    this.hasChangedValues = false;
	
	    this.init();
	  }
	
	  _createClass(FormValidator, [{
	    key: "init",
	    value: function init() {
	      var that = this;
	
	      that.selector.find("input, textarea").on("input", function (e) {
	        var $el = $(this);
	        $el.removeClass(that.errorClassName);
	        if (utils.isNotNull(that.rules.tooltip)) {
	          Tooltip.dispose({ selector: $el }); // %NOTE: maybe better to enable/disable instead of create/destroy?
	        }
	      });
	
	      that.selector.find("select").on("change", function (e) {
	        var $el = $(this);
	        $el.removeClass(that.errorClassName);
	        if (utils.isNotNull(that.rules.tooltip)) {
	          Tooltip.dispose({ selector: $el }); // %NOTE: maybe better to enable/disable instead of create/destroy?
	        }
	      });
	
	      that.selector.find("input, textarea, select").on("change", function (e) {
	        var $el = $(this);
	        var name = $el.data("fv-name") || $el.attr("id");
	
	        var elRules = null;
	
	        if (utils.isNotNull(name) && utils.isNotNull(that.rules) && that.rules.hasOwnProperty(name)) {
	          elRules = that.rules[name];
	        }
	
	        var validateOnChange = that.validateOnChange;
	
	        if (utils.isNotNull(elRules)) {
	          validateOnChange = that.validateOnChange && elRules.validateOnChange !== false || elRules.validateOnChange;
	        }
	
	        if (validateOnChange) {
	          var isValid = FormValidator.validateElement($el, that.errorClassName, elRules);
	
	          if (utils.isFunction(that.onValidateElement)) {
	            that.onValidateElement($el, isValid);
	          }
	        }
	
	        that.hasChangedValues = true;
	      });
	    }
	  }, {
	    key: "clearForm",
	    value: function clearForm() {
	      this.selector.find("input, select, textarea").each(function (index, el) {
	        var $el = $(el);
	        var name = $el.data("fv-name") || $el.attr("id");
	        var tagName = $el.prop("tagName").toLowerCase();
	        var type = tagName === "input" ? $el.attr("type") : tagName;
	
	        if ($el.data("fv-ignore") === true || type === "hidden" || utils.isNullOrEmpty(name)) {
	          return true;
	        }
	
	        $el.val("");
	      });
	    }
	  }, {
	    key: "setValueForKey",
	    value: function setValueForKey(key, value, options) {
	      options = utils.isNotNull(options) ? options : {};
	
	      var $el = this.selector.find("[data-fv-name='" + key + "']");
	
	      if (utils.isNull($el) || !$el.length) {
	        $el = this.selector.find("#" + key);
	      }
	
	      if (utils.isNotNull($el) && $el.length) {
	        var tagName = $el.prop("tagName").toLowerCase();
	        var type = tagName === "input" ? $el.attr("type") : tagName;
	
	        if ($el.length > 0 && utils.isNotNull($el[0].selectize)) {
	          $el[0].selectize.setValue(value, true);
	        } else if (type === "checkbox") {
	          $el.prop("checked", value);
	        } else {
	
	          $el.val(value);
	        }
	
	        if (options.markAsChanged) {
	          this.hasChangedValues = true;
	        }
	
	        if (options.triggerChangeEvent) {
	          $el.trigger("change");
	        }
	
	        return $el;
	      } else {
	        return null;
	      }
	    }
	  }, {
	    key: "setValid",
	    value: function setValid(key, flag) {
	      var $el = this.selector.find("[data-fv-name='" + key + "']");
	
	      if (utils.isNull($el) || !$el.length) {
	        $el = this.selector.find("#" + key);
	      }
	
	      if (utils.isNotNull($el) && $el.length) {
	        if (utils.isNull(flag)) {
	          $el.removeClass("is-invalid").removeClass("is-valid");
	        }
	
	        if (flag) {
	          $el.removeClass("is-invalid").addClass("is-valid");
	        } else {
	          $el.removeClass("is-valid").addClass("is-invalid");
	        }
	      }
	    }
	  }, {
	    key: "validate",
	    value: function validate() {
	      var that = this;
	      var isValid = true;
	
	      this.selector.find("input, textarea, select").each(function (index, el) {
	        var $el = $(el);
	
	        var name = $el.data("fv-name") || $el.attr("id");
	
	        var elRules = null;
	
	        if (utils.isNotNull(name) && utils.isNotNull(that.rules) && that.rules.hasOwnProperty(name)) {
	          elRules = that.rules[name];
	        }
	
	        var formElValid = FormValidator.validateElement($el, that.errorClassName, elRules);
	
	        // log.info("%s is %s for rules %o", name, (formElValid ? "valid" : "not valid"), elRules);
	        if (utils.isFunction(that.onValidateElement)) {
	          that.onValidateElement($el, formElValid);
	        }
	
	        isValid = isValid && formElValid;
	      });
	
	      return isValid;
	    }
	  }, {
	    key: "getFormData",
	    value: function getFormData() {
	      var formData = {};
	
	      this.selector.find("input, select, textarea").each(function (index, el) {
	        var $el = $(el);
	        var name = $el.data("fv-name") || $el.attr("id");
	        var tagName = $el.prop("tagName").toLowerCase();
	        var type = tagName === "input" ? $el.attr("type") : tagName;
	
	        if ($el.data("fv-ignore") === true || type === "hidden") {
	          return true;
	        } else if (type === "checkbox") {
	          formData[name] = $el.prop("checked");
	        } else {
	          formData[name] = $el.val();
	        }
	      });
	
	      return formData;
	    }
	  }], [{
	    key: "validateElement",
	    value: function validateElement(selector, errorClassName, rules) {
	      var $el = $(selector).removeClass(errorClassName);
	      var name = $el.data("fv-name") || $el.attr("id");
	      rules = utils.isNotNull(rules) ? rules : {};
	
	      if (utils.isNotNull(rules.tooltip)) {
	        Tooltip.dispose({ selector: $el });
	      }
	
	      var isValid = true;
	
	      var tagName = $el.prop("tagName").toLowerCase();
	      var type = tagName === "input" ? $el.attr("type") : tagName;
	      var value = $el.val();
	      var required = utils.isBoolean(rules.required) ? rules.required : $el.data("fv-required") || false;
	      var minLength = utils.isDefined(rules.minLength) ? rules.minLength : $el.data("fv-min-length");
	      var maxLength = utils.isDefined(rules.maxLength) ? rules.maxLength : $el.data("fv-max-length");
	      var minVal = utils.isDefined(rules.minVal) ? rules.minVal : $el.data("fv-min-val");
	      var maxVal = utils.isDefined(rules.maxVal) ? rules.maxVal : $el.data("fv-max-val");
	      var sameAs = utils.isDefined(rules.sameAs) ? rules.sameAs : $el.data("fv-same-as");
	      var validateFunc = rules.validator;
	      var trim = rules.trim === true;
	
	      if ($el.data("fv-ignore") === true || type === "hidden") {
	        return isValid;
	      }
	
	      var formElInfo = {
	        tagName: tagName,
	        type: type,
	        value: value,
	        required: required,
	        minLength: minLength,
	        maxLength: maxLength,
	        minVal: minVal,
	        maxVal: maxVal,
	        sameAs: sameAs,
	        validator: validateFunc,
	        trim: trim
	      };
	
	      log.cssLog("%c%s%c form element info: %o", name, formElInfo, log.infoCss);
	
	      if (utils.isNotNull(value) && trim) value = value.trim();
	
	      if (utils.isNullOrEmpty(value)) {
	        if (required) {
	          log.cssLog("%s is not valid because the value is required and value is [%s]", name, value, log.errorCss);
	          isValid = false;
	        }
	      } else {
	        if (type === "number") {
	          value = utils.stringToInt(value);
	        }
	
	        if (isValid && type === "number" && !utils.isNumber(value)) {
	          log.cssLog("%s is not valid because type is number and [%s] is not a number", name, value, log.errorCss);
	          isValid = false;
	        }
	
	        if (tagName === "input" || tagName === "textarea") {
	          if (type === "number") {
	            if (isValid && utils.isNumber(minVal)) {
	              if (value < minVal) {
	                log.cssLog("%s is not valid because value [%s] is less than the min-val (%s)", name, value, minVal, log.errorCss);
	                isValid = false;
	              }
	            }
	
	            if (isValid && utils.isNumber(maxVal)) {
	              if (value > maxVal) {
	                log.cssLog("%s is not valid because value [%s] is more than the max-val (%s)", name, value, maxVal, log.errorCss);
	                isValid = false;
	              }
	            }
	          } else {
	            if (isValid && utils.isNumber(minLength)) {
	              if (value.length < minLength) {
	                log.cssLog("%s is not valid because the length [%s] of value [%s] is less than the min-length (%s)", name, value.length, value, minLength, log.errorCss);
	                isValid = false;
	              }
	            }
	
	            if (isValid && utils.isNumber(maxLength)) {
	              if (value.length > maxLength) {
	                log.cssLog("%s is not valid because the length [%s] of value [%s] is greater than the max-length (%s)", name, value.length, value, maxLength, log.errorCss);
	                isValid = false;
	              }
	            }
	          }
	        }
	
	        if (isValid && type === "email" && !utils.isValidEmail(value)) {
	          log.cssLog("%s is not valid because type is email and [%s] is not a valid email", name, value, log.errorCss);
	          isValid = false;
	        }
	
	        if (isValid && utils.isNotNull(sameAs)) {
	          var sameAsEl = $("[data-fv-name='" + sameAs + "']");
	          var sameAsValue = void 0;
	
	          if (utils.isNotNull(sameAs) && sameAs.length) {
	            sameAsValue = sameAsEl.val();
	          } else {
	            sameAs = $(sameAs);
	
	            if (utils.isNotNull(sameAs) && sameAs.length) {
	              sameAsValue = sameAsEl.val();
	            }
	          }
	
	          if (value !== sameAsValue) {
	            log.cssLog("%s is not valid because value [%s] is not the same as value [%s] from %s", name, value, sameAsValue, sameAs, log.errorCss);
	            isValid = false;
	          }
	        }
	      }
	
	      if (isValid && utils.isFunction(validateFunc)) {
	        if (!validateFunc(value)) {
	          log.cssLog("%s is not valid because custom validator function did not return true for value [%s]", name, value, log.errorCss);
	          isValid = false;
	        }
	      }
	
	      if (isValid) {
	        log.cssLog("%s is valid with value [%s] for form element %o", name, value, formElInfo, log.successCss);
	      } else {
	        if (!$el.hasClass(errorClassName)) {
	          $el.addClass(errorClassName);
	        }
	
	        if (utils.isNotNull(rules.tooltip)) // %NOTE: maybe better to enable/disable instead of create/destroy?
	          {
	            Tooltip.create({
	              selector: $el,
	              content: rules.tooltip,
	              placement: utils.isNullOrEmpty(rules.tooltipPlacement) ? "top" : rules.tooltipPlacement
	            });
	          }
	      }
	
	      return isValid;
	    }
	  }]);
	
	  return FormValidator;
	}();
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),

/***/ 33:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Created by jv on 2019-09-10 (13:39).
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */
	
	
	var _utils = __webpack_require__(3);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _languageManager = __webpack_require__(6);
	
	var _languageManager2 = _interopRequireDefault(_languageManager);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var log = __webpack_require__(5)();
	
	
	__webpack_require__(750);
	
	var GameView = function () {
	  function GameView(options) {
	    _classCallCheck(this, GameView);
	
	    this.key = options.key;
	    this.$container = $(options.container);
	    this.html = options.html;
	    this.$element = null;
	
	    this.gameSessionController = options.gameSessionController;
	
	    this.hasRendered = false;
	  }
	
	  _createClass(GameView, [{
	    key: "render",
	    value: function render() {
	      this.hasRendered = false;
	
	      this.$element = $(this.html);
	      this.$container.append(this.$element);
	      _languageManager2.default.applyLocale(this.$element);
	    }
	  }, {
	    key: "show",
	    value: function show() {
	      if (_utils2.default.isNotNull(this.$element) && this.$element.length) {
	        this.$element.show();
	      }
	    }
	  }, {
	    key: "hide",
	    value: function hide() {
	      if (_utils2.default.isNotNull(this.$element) && this.$element.length) {
	        this.$element.hide();
	      }
	    }
	  }, {
	    key: "destroy",
	    value: function destroy() {
	      if (_utils2.default.isNotNull(this.$element) && this.$element.length) {
	        this.$element.remove();
	      }
	    }
	  }, {
	    key: "onRender",
	    value: function onRender() {
	      this.hasRendered = true;
	    }
	  }, {
	    key: "_setUpEventListeners",
	    value: function _setUpEventListeners() {}
	  }, {
	    key: "showBackdrop",
	    value: function showBackdrop() {
	      this.$element.addClass("gv-backdrop");
	    }
	  }, {
	    key: "removeBackdrop",
	    value: function removeBackdrop() {
	      this.$element.removeClass("gv-backdrop");
	    }
	  }]);
	
	  return GameView;
	}();
	
	module.exports = GameView;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),

/***/ 50:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _jsCookie = __webpack_require__(425);
	
	var _jsCookie2 = _interopRequireDefault(_jsCookie);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Created by jv on 13/01/2017.
	 */
	var utils = __webpack_require__(3);
	var log = __webpack_require__(5)();
	
	// This gives errors in the browser, don't know why :(
	
	
	var storageController = {};
	
	(function (StorageController) {
	  StorageController.keys = {
	    LOGGED_IN_USER: "logged_in_user",
	    ORDER: "order",
	    ACTIVE_CARD_GAME: "active_card_game",
	    ROUND_TIMERS: "round_timers",
	    COOKIEPOLIYCY_ANALYTICS_CONSENT: "cookiepolicy_analytics_consent"
	
	  };
	
	  function shouldEncode(key) {
	    // Basically obfuscates the data from these keys
	    // return $.inArray(key, [ StorageController.keys.LOGGED_IN_USER, StorageController.keys.ORDER, StorageController.keys.ROUND_TIMERS ]) !== -1;
	    return [StorageController.keys.LOGGED_IN_USER, StorageController.keys.ORDER, StorageController.keys.ROUND_TIMERS].includes(key);
	  }
	
	  StorageController.clearAll = function () {
	    StorageController.clearSession();
	    StorageController.clearLocal();
	  };
	
	  StorageController.clearSession = function () {
	    sessionStorage.clear();
	  };
	
	  StorageController.clearLocal = function () {
	    localStorage.clear();
	  };
	
	  StorageController.removeFromSession = function (key) {
	    StorageController.saveToSession(key);
	  };
	
	  StorageController.saveToSession = function (key, obj) {
	    if (storageKeyIsValid(key)) {
	      // if obj is null then remove
	      if (utils.isUndefined(obj)) {
	        sessionStorage.removeItem(key);
	      } else {
	        if (utils.isObject(obj)) {
	          if (utils.isFunction(obj.getSerializable)) {
	            obj = obj.getSerializable();
	          }
	
	          obj = utils.stringifyJSON(obj);
	        }
	
	        if (shouldEncode(key)) {
	          obj = utils.btoa(obj);
	        }
	
	        sessionStorage.setItem(key, obj);
	      }
	    } else {
	      console.error("Invalid storage key [%s]", key);
	    }
	  };
	
	  StorageController.getFromSession = function (key, json) {
	    if (storageKeyIsValid(key)) {
	      var tmpValue = sessionStorage.getItem(key);
	
	      if (shouldEncode(key)) {
	        try {
	          tmpValue = utils.atob(tmpValue);
	        } catch (e) {
	          log.error("Failed to decode value '%s'", tmpValue);
	        }
	      }
	
	      if (json) {
	        return utils.parseJSON(tmpValue, true);
	      }
	
	      return tmpValue;
	    } else {
	      console.error("Invalid storage key [%s]", key);
	    }
	
	    return null;
	  };
	
	  StorageController.removeFromLocal = function (key) {
	    StorageController.saveToLocal(key);
	  };
	
	  StorageController.saveToLocal = function (key, obj) {
	    if (storageKeyIsValid(key)) {
	      if (utils.isUndefined(obj)) {
	        localStorage.removeItem(key);
	      } else {
	        if (utils.isObject(obj)) {
	          if (utils.isFunction(obj.getSerializable)) {
	            obj = obj.getSerializable();
	          }
	
	          obj = utils.stringifyJSON(obj);
	        }
	
	        if (shouldEncode(key)) {
	          obj = utils.btoa(obj);
	        }
	
	        localStorage.setItem(key, obj);
	      }
	    } else {
	      console.error("Invalid storage key [%s]", key);
	    }
	  };
	
	  StorageController.getFromLocal = function (key, json) {
	    if (storageKeyIsValid(key)) {
	      var tmpValue = localStorage.getItem(key);
	
	      if (shouldEncode(key)) {
	        try {
	          tmpValue = utils.atob(tmpValue);
	        } catch (e) {
	          log.error("Failed to decode value '%s'", tmpValue);
	        }
	      }
	
	      if (json) {
	        return utils.parseJSON(tmpValue, true);
	      }
	
	      return tmpValue;
	    } else {
	      console.error("Invalid storage key [%s]", key);
	    }
	
	    return null;
	  };
	
	  StorageController.saveCookie = function (name, value, daysUntilExpire) {
	    var options = {};
	    if (utils.isNumber(daysUntilExpire)) {
	      options.expires = daysUntilExpire;
	    }
	
	    _jsCookie2.default.set(name, value, { expires: daysUntilExpire });
	  };
	
	  StorageController.getCookie = function (name) {
	    return _jsCookie2.default.get(name);
	  };
	
	  StorageController.removeCookie = function (name) {
	    _jsCookie2.default.remove(name);
	  };
	
	  function storageKeyIsValid(key) {
	    for (var objKey in StorageController.keys) {
	      if (StorageController.keys.hasOwnProperty(objKey) && StorageController.keys[objKey] === key) {
	        return true;
	      }
	    }
	
	    return false;
	  }
	})(storageController);
	
	module.exports = storageController;

/***/ }),

/***/ 51:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Created by jv on 16/03/2017.
	 */
	var utils = __webpack_require__(3);
	
	var knownErrors = ["401", // unauthorized
	
	"E91489", "E73550"];
	
	module.exports = function () {
	  function AppError(options) {
	    _classCallCheck(this, AppError);
	
	    options = utils.isNotNull(options) ? options : {};
	
	    this.code = options.appErrorCode || options.code;
	    this.message = options.message;
	
	    this.data = options.data;
	    this.exception = options.exception;
	  }
	
	  _createClass(AppError, [{
	    key: "readableErrorTitle",
	    get: function get() {
	      if ($.inArray(this.code, knownErrors) !== -1) {
	        return "errors.services." + this.code + ".title";
	      }
	
	      return "errors.services.general.title";
	    }
	  }, {
	    key: "readableErrorMessage",
	    get: function get() {
	      if ($.inArray(this.code, knownErrors) !== -1) {
	        return "errors.services." + this.code + ".message";
	      }
	
	      return "errors.services.general.message";
	    }
	  }]);
	
	  return AppError;
	}();
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),

/***/ 54:
/***/ (function(module, exports) {

	"use strict";
	
	/**
	 * Created by jv on 14/06/2017.
	 */
	module.exports = {
	  DEFAULT_LOCALE: "nl-BE",
	
	  API_DATE_FORMAT: "YYYY-MM-DDTHH:mm:ss.SSSZZ",
	  READABLE_DATE_FORMAT: "DD-MM-YYYY",
	
	  // 50mb
	  // MAX_UPLOAD_FILE_SIZE: 52428800,
	  // 100mb
	  // MAX_UPLOAD_FILE_SIZE: 104857600,
	  // 250mb
	  MAX_UPLOAD_FILE_SIZE: 262144000,
	
	  BM_TRANSITION_SPEED: 300,
	
	  MOVEMENTS: {
	    HORIZONTAL: "horizontal",
	    VERTICAL: "vertical",
	    DIAGONAL: "diagonal"
	  },
	
	  DIRECTIONS: {
	    UP: "up",
	    DOWN: "down",
	    LEFT: "left",
	    RIGHT: "right"
	  },
	
	  BUSINESS_MODEL_ACTIONS: {
	    ACTIVATE: "activate",
	    DEACTIVATE: "deactivate"
	  }
	};

/***/ }),

/***/ 186:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	var _utils = __webpack_require__(3);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _appError = __webpack_require__(51);
	
	var _appError2 = _interopRequireDefault(_appError);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Created by jv on 16/01/2017.
	 */
	var log = __webpack_require__(5)();
	
	
	var request = {};
	
	(function (Request) {
	  Request.CONTENT_TYPES = {
	    APPLICATION_FORM_URLENCODED: "application/x-www-form-urlencoded",
	    TEXT_PLAIN: "text/plain",
	    APPLICATION_JSON: "application/json"
	  };
	
	  Request.DATA_TYPES = {
	    TEXT: "text",
	    JSON: "json",
	    XML: "xml"
	  };
	
	  Request.get = function (options) {
	    options.type = "GET";
	    return doRequest(options);
	  };
	
	  Request.post = function (options) {
	    options.type = "POST";
	    return doRequest(options);
	  };
	
	  Request.put = function (options) {
	    options.type = "PUT";
	    return doRequest(options);
	  };
	
	  Request.delete = function (options) {
	    options.type = "DELETE";
	    return doRequest(options);
	  };
	
	  function doRequest(options) {
	    var startTime = Date.now();
	    logRequestInfo(startTime, options);
	
	    // Download / Upload progress
	    if (_utils2.default.isFunction(options.onProgress) || _utils2.default.isFunction(options.onUploadProgress)) {
	      options.xhr = function () {
	        var xhr = new window.XMLHttpRequest();
	
	        if (_utils2.default.isFunction(options.onUploadProgress)) {
	          xhr.upload.addEventListener("progress", function (evt) {
	            if (evt.lengthComputable) {
	              var percentComplete = evt.loaded / evt.total;
	              options.onUploadProgress(percentComplete);
	            }
	          }, false);
	        }
	
	        if (_utils2.default.isFunction(options.onProgress)) {
	          xhr.addEventListener("progress", function (evt) {
	            if (evt.lengthComputable) {
	              var percentComplete = evt.loaded / evt.total;
	              options.onProgress(percentComplete);
	            }
	          }, false);
	        }
	
	        return xhr;
	      };
	    }
	
	    if (options.type !== "GET" && options.contentType === Request.CONTENT_TYPES.APPLICATION_JSON && (_utils2.default.isObject(options.data) || _utils2.default.isArray(options.data))) {
	      options.data = _utils2.default.stringifyJSON(options.data);
	    }
	
	    return new Promise(function (resolve, reject) {
	      // Request (order matters! in this case: always -> done / fail)
	      $.ajax(options).always(function (data, textStatus) {
	        logRequestComplete(startTime, options, textStatus, data);
	      }).done(function (data) {
	        if (_utils2.default.isNotNull(data) && data.hasOwnProperty("responseJSON") && data.responseJSON.result === "error") {
	          dataToError(data, reject);
	          return;
	        }
	
	        resolve(data);
	      }).fail(function (data) {
	        dataToError(data, reject);
	      });
	    });
	  }
	
	  function logRequestInfo(startTime, requestOptions) {
	    var startColor = "#5076ff";
	    var headerCss = _utils2.default.format("background-color: #222;color: {0};border-top: 1px solid {1};", startColor, startColor);
	    var footerCss = _utils2.default.format("border-bottom: 1px solid {0}", startColor);
	    log.info("%cRequest started%c\nUrl: %s\nMethod: %s\nContent-type: %s\nDataType: %s\n%cData: %o%c", headerCss, "", requestOptions.url, requestOptions.type, requestOptions.contentType, requestOptions.dataType, footerCss, requestOptions.data, "");
	  }
	
	  function logRequestComplete(startTime, requestOptions, textStatus, result) {
	    if (false) {
	      var executeTime = Date.now() - startTime;
	      executeTime = executeTime / 1000 + "s";
	
	      var completeColor = "#bada55";
	      var headerCss = _utils2.default.format("background-color: #222;color: {0};border-top: 1px solid {1};", completeColor, completeColor);
	      var footerCss = _utils2.default.format("border-bottom: 1px solid {0}", completeColor);
	
	      log.info("%cRequest complete%c\nUrl: %s\nMethod: %s\nStatus: %s\nExecute time: %s\n%cResult: %o%c",
	      /*empty string to reset css*/
	      headerCss, "", requestOptions.url, requestOptions.type, textStatus, executeTime, footerCss, result, "");
	    }
	  }
	
	  function dataToError(data, callback) {
	    if (_utils2.default.isFunction(callback)) {
	      if (_utils2.default.isNotNull(data) && data.hasOwnProperty("responseJSON") && _utils2.default.isNotNull(data.responseJSON) && data.responseJSON.result === "error") {
	        callback(new _appError2.default({
	          code: data.responseJSON.data.appErrorCode,
	          message: data.responseJSON.data.message,
	          data: data
	        }));
	      } else if (data.status === 401) {
	        callback(new _appError2.default({
	          code: "401",
	          message: _utils2.default.isNotNull(data.responseJSON) ? data.responseJSON.data : data.responseText,
	          data: data
	        }));
	      } else {
	        callback(new _appError2.default({
	          code: null,
	          message: null,
	          data: data
	        }));
	      }
	    }
	  }
	})(request);
	
	module.exports = request;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),

/***/ 212:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _languageManager = __webpack_require__(6);
	
	var _languageManager2 = _interopRequireDefault(_languageManager);
	
	var _constants = __webpack_require__(54);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Created by jv on 2019-08-21 (11:47).
	 */
	var businessModelImages = __webpack_require__(224);
	// const sectorIcons = require.context("!raw-loader!Images/business-model/sector-icons", false, /\.svg$/);
	
	var sectorIcons = __webpack_require__(225);
	
	var animationDuration = 2000;
	
	var sectorSettings = {
	  size: {
	    width: 171,
	    height: 171
	  },
	
	  radius: {
	    rx: 15,
	    ry: 15
	  },
	
	  backgroundColor: "#E9EEF2",
	  backgroundColorActive: "#FFFFFF",
	
	  strokeColor: "#B2D4F1",
	  strokeColorPreviewActive: "#59B57D",
	  strokeColorPreviewInactive: "#BC3837"
	};
	
	var powerGridSettings = {
	  cabinetSize: {
	    width: 68,
	    height: 68
	  },
	
	  innerWidth: 21,
	  outerWidth: 25,
	
	  backgroundColor: "transparent",
	  backgroundColorActive: "transparent",
	  strokeColor: "#ABBAC7",
	  strokeColorActive: "#679CD3",
	  strokeColorPreviewActive: "#59B57D",
	  strokeColorPreviewInactive: "#BC3837",
	
	  cabinetIcon: businessModelImages("./electricity-big.svg"),
	  pylonIcon: businessModelImages("./electricity-pylon.svg"),
	  activeIcon: businessModelImages("./electricity-small.svg"),
	
	  pylonSize: {
	    width: 35,
	    height: 41
	  },
	
	  activeIconSize: {
	    width: 37,
	    height: 37
	  }
	};
	
	var roadSettings = {
	  dividerWidth: 3,
	  innerWidth: 31,
	  outerWidth: 35,
	
	  backgroundColor: "#E9EEF2",
	  backgroundColorActive: "#FFFFFF",
	
	  strokeColor: "#ABBAC7",
	  roadColor: "#E9EEF2",
	  roadColorActive: "#FFFFFF",
	
	  dividerColor: "#ABBAC7",
	  dividerColorActive: "#679CD3",
	  dividerColorPreviewActive: "#59B57D",
	  dividerColorPreviewInactive: "#BC3837",
	
	  dividerDashArray: [3, 10],
	  dividerDashArrayActive: null,
	
	  crossingIcon: businessModelImages("./crossing.svg"),
	  activeArrow: businessModelImages("./arrow.svg")
	};
	
	var faqSettings = {
	  radius: 37,
	  backgroundColor: "#ffffff",
	  innerStrokeColor: "#000000",
	  innerStrokeRadius: 29,
	  innerStrokeWidth: 4,
	
	  text: {
	    fontFamily: "Rubik", // %TODO: wss ander font ???
	    fontSize: 24,
	    alignment: "center",
	    color: "#000000"
	  },
	
	  markedColor: "#57B67D"
	};
	
	var sectors = {
	  "limited_resources": {
	    // Name is function because we don't yet know what the localization will be until we request it
	    name: function name() {
	      return _languageManager2.default.getValueForKey("business_model.sectors.labels.limited_resources");
	    },
	    position: {
	      x: 125,
	      y: 125,
	      z: 0
	    },
	    icon: sectorIcons("./limited_resources_grey.svg"),
	    iconActive: sectorIcons("./limited_resources_white.svg")
	  },
	
	  "unlimited_resources": {
	    name: function name() {
	      return _languageManager2.default.getValueForKey("business_model.sectors.labels.unlimited_resources");
	    },
	    position: {
	      x: 125,
	      y: 775,
	      z: 0
	    },
	    icon: sectorIcons("./unlimited_resources_grey.svg"),
	    iconActive: sectorIcons("./unlimited_resources_white.svg")
	  },
	
	  "waste_valorization": {
	    position: {
	      x: 415,
	      y: 175,
	      z: 0
	    },
	    icon: sectorIcons("./factory_grey.svg"),
	    iconActive: sectorIcons("./factory_white.svg")
	  },
	
	  "company": {
	    name: function name() {
	      return _languageManager2.default.getValueForKey("business_model.sectors.labels.your_company");
	    },
	    position: {
	      x: 415,
	      y: 585,
	      z: 0
	    },
	    icon: sectorIcons("./company_grey.svg"),
	    iconActive: sectorIcons("./company_white.svg")
	  },
	
	  "recycling_processing": {
	    position: {
	      x: 620,
	      y: 125,
	      z: 0
	    },
	    startsEmpty: true,
	    icon: sectorIcons("./plus.svg"),
	    iconActive: sectorIcons("./factory2_white.svg")
	  },
	
	  "extra_product": {
	    position: {
	      x: 620,
	      y: 700,
	      z: 0
	    },
	    startsEmpty: true,
	    icon: sectorIcons("./plus.svg"),
	    // TODO get from server
	    iconActive: sectorIcons("./company_white.svg")
	  },
	
	  "own_channel": {
	    name: function name() {
	      return _languageManager2.default.getValueForKey("business_model.sectors.labels.own_channel");
	    },
	    position: {
	      x: 850,
	      y: 255,
	      z: 0
	    },
	    icon: sectorIcons("./own_channel_grey.svg"),
	    iconActive: sectorIcons("./own_channel_white.svg")
	  },
	
	  "stores": {
	    name: function name() {
	      return _languageManager2.default.getValueForKey("business_model.sectors.labels.stores");
	    },
	    position: {
	      x: 805,
	      y: 460,
	      z: 0
	    },
	    icon: sectorIcons("./stores_grey.svg"),
	    iconActive: sectorIcons("./stores_white.svg")
	  },
	
	  "product_service_system": {
	    name: function name() {
	      return _languageManager2.default.getValueForKey("business_model.sectors.labels.product_service_system");
	    },
	    position: {
	      x: 850,
	      y: 660,
	      z: 0
	    },
	    icon: sectorIcons("./product_service_system.svg"),
	    iconActive: sectorIcons("./product_service_system.svg")
	  },
	
	  "repair_service": {
	    name: function name() {
	      return _languageManager2.default.getValueForKey("business_model.sectors.labels.repair_service");
	    },
	    position: {
	      x: 1200,
	      y: 255,
	      z: 0
	    },
	    icon: sectorIcons("./repair_service_grey.svg"),
	    iconActive: sectorIcons("./repair_service_white.svg")
	  },
	
	  "users": {
	    name: function name() {
	      return _languageManager2.default.getValueForKey("business_model.sectors.labels.users");
	    },
	    position: {
	      x: 1200,
	      y: 460,
	      z: 0
	    },
	    icon: sectorIcons("./users_grey.svg"),
	    iconActive: sectorIcons("./users_white.svg")
	  },
	
	  "reusability": {
	    position: {
	      x: 1115,
	      y: 645,
	      z: 0
	    },
	    startsEmpty: true,
	    icon: sectorIcons("./plus.svg"),
	    iconActive: sectorIcons("./reusability.svg")
	  },
	
	  "recycling": {
	    name: function name() {
	      return _languageManager2.default.getValueForKey("business_model.sectors.labels.recycling");
	    },
	    position: {
	      x: 1440,
	      y: 145,
	      z: 0
	    },
	    icon: sectorIcons("./recycling_grey.svg"),
	    iconActive: sectorIcons("./recycling_white.svg")
	  },
	
	  "collection": {
	    name: function name() {
	      return _languageManager2.default.getValueForKey("business_model.sectors.labels.collection");
	    },
	    position: {
	      x: 1440,
	      y: 460,
	      z: 0
	    },
	    icon: sectorIcons("./collection_grey.svg"),
	    iconActive: sectorIcons("./collection_white.svg")
	  },
	
	  "composting": {
	    name: function name() {
	      return _languageManager2.default.getValueForKey("business_model.sectors.labels.composting");
	    },
	    position: {
	      x: 1440,
	      y: 790,
	      z: 0
	    },
	    icon: sectorIcons("./composting_grey.svg"),
	    iconActive: sectorIcons("./composting_white.svg")
	  },
	
	  "waste": {
	    name: function name() {
	      return _languageManager2.default.getValueForKey("business_model.sectors.labels.waste");
	    },
	    position: {
	      x: 1660,
	      y: 460,
	      z: 0
	    },
	    icon: sectorIcons("./waste_grey.svg"),
	    iconActive: sectorIcons("./waste_white.svg")
	  }
	};
	
	var incomeIcon = {
	  position: {
	    x: sectors["company"].position.x + sectorSettings.size.width,
	    y: sectors["company"].position.y,
	    originX: "center",
	    originY: "center"
	  },
	  radius: 37,
	  backgroundColor: "#ffffff",
	  innerStrokeColor: "#FCC753",
	  innerStrokeRadius: 29,
	  innerStrokeWidth: 4,
	
	  text: {
	    fontFamily: "Rubik",
	    fontSize: 24,
	    alignment: "center",
	    color: "#000000"
	  },
	
	  themes: {
	    "negative": {
	      backgroundColor: "#ffffff",
	      innerStrokeColor: "#BC3837",
	      text: {
	        color: "#000000"
	      }
	    },
	    "positive": {
	      backgroundColor: "#ffffff",
	      innerStrokeColor: "#59B57D",
	      text: {
	        color: "#000000"
	      }
	    }
	  }
	};
	
	var powerCabinets = {
	  "power-cabinet-1": {
	    position: {
	      x: sectors["limited_resources"].position.x + sectorSettings.size.width / 2,
	      y: sectors["unlimited_resources"].position.y - (sectors["unlimited_resources"].position.y - (sectors["limited_resources"].position.y + sectorSettings.size.height)) / 2,
	      z: 0
	    }
	  }
	};
	
	var powerLines = [{
	  key: "power-line-1",
	  connects: ["limited_resources", "power-cabinet-1"],
	
	  intersections: [],
	
	  connections: [
	  // limited_resources -> power_cabinet
	  {
	    start: "limited_resources",
	    startType: "sector",
	
	    bidirectional: false,
	
	    startPosition: {
	      x: sectors["limited_resources"].position.x + sectorSettings.size.width / 2,
	      y: sectors["limited_resources"].position.y + sectorSettings.size.height
	    },
	
	    navigation: [],
	
	    endPosition: {
	      x: powerCabinets["power-cabinet-1"].position.x,
	      y: powerCabinets["power-cabinet-1"].position.y
	    }
	  }],
	
	  pylons: [{
	    x: sectors["limited_resources"].position.x + sectorSettings.size.width / 2,
	    y: sectors["limited_resources"].position.y + sectorSettings.size.height + (powerCabinets["power-cabinet-1"].position.y - powerGridSettings.cabinetSize.height / 2 - (sectors["limited_resources"].position.y + sectorSettings.size.height)) / 2
	  }],
	
	  activeIcons: [{
	    x: sectors["limited_resources"].position.x + sectorSettings.size.width / 2 - powerGridSettings.outerWidth / 2,
	    y: sectors["limited_resources"].position.y + sectorSettings.size.height + 50
	  }, {
	    x: sectors["limited_resources"].position.x + sectorSettings.size.width / 2 + powerGridSettings.outerWidth / 2,
	    y: powerCabinets["power-cabinet-1"].position.y - powerGridSettings.cabinetSize.height / 2 - 50
	  }]
	}, {
	  key: "power-line-2",
	  connects: ["unlimited_resources", "power-cabinet-1"],
	
	  intersections: [],
	
	  connections: [
	  // unlimited_resources -> power_cabinet
	  {
	    start: "unlimited_resources",
	    startType: "sector",
	
	    bidirectional: false,
	
	    startPosition: {
	      x: sectors["unlimited_resources"].position.x + sectorSettings.size.width / 2,
	      y: sectors["unlimited_resources"].position.y
	    },
	
	    navigation: [],
	
	    endPosition: {
	      x: powerCabinets["power-cabinet-1"].position.x,
	      y: powerCabinets["power-cabinet-1"].position.y
	    }
	  }],
	
	  pylons: [{
	    x: sectors["unlimited_resources"].position.x + sectorSettings.size.width / 2,
	    y: sectors["unlimited_resources"].position.y - (sectors["unlimited_resources"].position.y - powerCabinets["power-cabinet-1"].position.y - powerGridSettings.cabinetSize.height / 2) / 2
	  }],
	
	  activeIcons: [{
	    x: sectors["unlimited_resources"].position.x + sectorSettings.size.width / 2 - powerGridSettings.outerWidth / 2,
	    y: sectors["unlimited_resources"].position.y - 50
	  }, {
	    x: sectors["limited_resources"].position.x + sectorSettings.size.width / 2 + powerGridSettings.outerWidth / 2,
	    y: powerCabinets["power-cabinet-1"].position.y + powerGridSettings.cabinetSize.height / 2 + 50
	  }]
	}, {
	  key: "power-line-3",
	  connects: ["power-cabinet-1", "company"],
	
	  intersections: [],
	
	  connections: [
	  // power-cabinet-1 -> company
	  {
	    start: "power-cabinet-1",
	    startType: "sector",
	
	    bidirectional: false,
	
	    startPosition: {
	      x: powerCabinets["power-cabinet-1"].position.x,
	      y: powerCabinets["power-cabinet-1"].position.y
	    },
	
	    navigation: [{
	      x: sectors["company"].position.x + sectorSettings.size.width / 7,
	      type: "absolute"
	    }],
	
	    endPosition: {
	      x: sectors["company"].position.x + sectorSettings.size.width / 7,
	      y: sectors["company"].position.y
	    }
	  }],
	
	  pylons: [{
	    x: sectors["company"].position.x + sectorSettings.size.width / 7,
	    y: powerCabinets["power-cabinet-1"].position.y + powerGridSettings.innerWidth
	  }],
	
	  activeIcons: [{
	    x: powerCabinets["power-cabinet-1"].position.x + 80,
	    y: powerCabinets["power-cabinet-1"].position.y - powerGridSettings.outerWidth / 2
	  }, {
	    x: powerCabinets["power-cabinet-1"].position.x + 180,
	    y: powerCabinets["power-cabinet-1"].position.y + powerGridSettings.outerWidth / 2
	  }]
	}];
	
	var intersections = {
	  "road1-int1": {
	    road: "road1",
	    position: {
	      x: 350,
	      y: sectors["company"].position.y + sectorSettings.size.height / 2
	    },
	    connectionSides: [_constants2.default.DIRECTIONS.UP, _constants2.default.DIRECTIONS.RIGHT, _constants2.default.DIRECTIONS.DOWN]
	  },
	  "road1-int2": {
	    road: "road1",
	    position: {
	      x: 350,
	      y: sectors["unlimited_resources"].position.y + sectorSettings.size.height / 2
	    },
	    connectionSides: [_constants2.default.DIRECTIONS.UP, _constants2.default.DIRECTIONS.LEFT, _constants2.default.DIRECTIONS.DOWN]
	  },
	
	  "road3-int1": {
	    road: "road3",
	    position: {
	      x: sectors["users"].position.x + sectorSettings.size.width / 4 * 3,
	      y: sectors["reusability"].position.y + sectorSettings.size.height / 3
	    },
	    connectionSides: [_constants2.default.DIRECTIONS.UP, _constants2.default.DIRECTIONS.LEFT, _constants2.default.DIRECTIONS.DOWN]
	  },
	
	  "road5-int1": {
	    position: {
	      x: sectors["extra_product"].position.x + sectorSettings.size.width / 3,
	      y: sectors["company"].position.y + sectorSettings.size.height / 2
	    },
	    connectionSides: [_constants2.default.DIRECTIONS.LEFT, _constants2.default.DIRECTIONS.RIGHT, _constants2.default.DIRECTIONS.DOWN]
	  },
	  "road5-int2": {
	    position: {
	      x: sectors["extra_product"].position.x + sectorSettings.size.width / 5 * 4,
	      y: sectors["company"].position.y + sectorSettings.size.height / 2
	    },
	    connectionSides: [_constants2.default.DIRECTIONS.UP, _constants2.default.DIRECTIONS.RIGHT, _constants2.default.DIRECTIONS.LEFT]
	  },
	  "road5-int3": {
	    position: {
	      x: sectors["extra_product"].position.x + sectorSettings.size.width / 5 * 4,
	      y: sectors["stores"].position.y + sectorSettings.size.height / 2
	    },
	    connectionSides: [_constants2.default.DIRECTIONS.UP, _constants2.default.DIRECTIONS.RIGHT, _constants2.default.DIRECTIONS.DOWN]
	  },
	
	  "road6-int1": {
	    position: {
	      x: sectors["own_channel"].position.x + sectorSettings.size.width + 50,
	      y: sectors["stores"].position.y + sectorSettings.size.height / 2
	    },
	    connectionSides: [_constants2.default.DIRECTIONS.UP, _constants2.default.DIRECTIONS.RIGHT, _constants2.default.DIRECTIONS.DOWN, _constants2.default.DIRECTIONS.LEFT]
	  }
	};
	
	var roads = [{
	  key: "road1",
	  connects: ["limited_resources", "unlimited_resources", "company", "composting", "road1-int1", "road1-int2"],
	
	  connections: [
	  // limited_resources -> road1-int1
	  {
	    start: "limited_resources",
	    startType: "sector",
	    end: "road1-int1",
	    endType: "intersection",
	
	    bidirectional: false,
	
	    startPosition: {
	      x: sectors["limited_resources"].position.x + sectorSettings.size.width,
	      y: sectors["limited_resources"].position.y + sectorSettings.size.height / 2
	    },
	
	    navigation: [{
	      // x/y null = use same value as current position (only for absolute)
	      x: intersections["road1-int1"].position.x,
	      type: "absolute"
	    }],
	
	    endPosition: {
	      x: intersections["road1-int1"].position.x,
	      y: intersections["road1-int1"].position.y
	    },
	
	    arrowGroup: "road1-a1"
	  },
	
	  // unlimited_resources -> road1-int2
	  {
	    start: "unlimited_resources",
	    startType: "sector",
	    end: "road1-int2",
	    endType: "intersection",
	
	    bidirectional: false,
	
	    startPosition: {
	      x: sectors["unlimited_resources"].position.x + sectorSettings.size.width,
	      y: sectors["unlimited_resources"].position.y + sectorSettings.size.height / 2
	    },
	
	    navigation: [],
	
	    endPosition: {
	      x: intersections["road1-int2"].position.x,
	      y: intersections["road1-int2"].position.y
	    },
	
	    arrowGroup: "road1-a2"
	  },
	
	  // composting -> road1-int2
	  {
	    start: "composting",
	    startType: "sector",
	    end: "road1-int2",
	    endType: "intersection",
	
	    bidirectional: false,
	
	    startPosition: {
	      x: sectors["composting"].position.x,
	      y: sectors["composting"].position.y + sectorSettings.size.height / 3 * 2
	    },
	
	    navigation: [{
	      x: -450,
	      y: +0
	    }, {
	      x: +0,
	      y: +50
	    }, {
	      x: intersections["road1-int2"].position.x,
	      type: "absolute"
	    }],
	
	    endPosition: {
	      x: intersections["road1-int2"].position.x,
	      y: intersections["road1-int2"].position.y
	    },
	
	    arrowGroup: "road1-a3"
	  },
	
	  // road1-int2 -> road1-int1
	  {
	    start: "road1-int2",
	    startType: "intersection",
	    end: "road1-int1",
	    endType: "intersection",
	
	    bidirectional: false,
	
	    startPosition: {
	      x: intersections["road1-int2"].position.x,
	      y: intersections["road1-int2"].position.y
	    },
	
	    navigation: [],
	
	    endPosition: {
	      x: intersections["road1-int1"].position.x,
	      y: intersections["road1-int1"].position.y
	    },
	
	    arrowGroup: "road1-a4"
	  },
	
	  // road1-int1 -> company
	  {
	    start: "road1-int1",
	    startType: "intersection",
	    end: "company",
	    endType: "sector",
	
	    bidirectional: false,
	
	    startPosition: {
	      x: intersections["road1-int1"].position.x,
	      y: intersections["road1-int1"].position.y
	    },
	
	    navigation: [],
	
	    endPosition: {
	      x: sectors["company"].position.x,
	      y: sectors["company"].position.y + sectorSettings.size.height / 2
	    },
	
	    arrowGroup: "road1-a5"
	  }],
	
	  crossings: [{
	    x: intersections["road1-int1"].position.x,
	    y: 375,
	    rotation: 0
	  }, {
	    x: intersections["road1-int1"].position.x,
	    y: 750,
	    rotation: 0
	  }, {
	    x: 600,
	    y: sectors["composting"].position.y + sectorSettings.size.height / 3 * 2 + 50,
	    rotation: 90
	  }, {
	    x: 1175,
	    y: sectors["composting"].position.y + sectorSettings.size.height / 3 * 2,
	    rotation: 90
	  }],
	
	  arrows: [
	  // road1-a1
	  {
	    x: sectors["limited_resources"].position.x + sectorSettings.size.width + 20,
	    y: sectors["limited_resources"].position.y + sectorSettings.size.height / 2,
	    rotation: 0,
	    group: "road1-a1"
	  }, {
	    x: intersections["road1-int1"].position.x,
	    y: 250,
	    rotation: 90,
	    group: "road1-a1"
	  }, {
	    x: intersections["road1-int1"].position.x,
	    y: 350,
	    rotation: 90,
	    group: "road1-a1"
	  }, {
	    x: intersections["road1-int1"].position.x,
	    y: 450,
	    rotation: 90,
	    group: "road1-a1"
	  }, {
	    x: intersections["road1-int1"].position.x,
	    y: 550,
	    rotation: 90,
	    group: "road1-a1"
	  },
	
	  // road1-a2
	  {
	    x: 320,
	    y: intersections["road1-int2"].position.y,
	    rotation: 0,
	    group: "road1-a2"
	  },
	
	  // road1-a3
	  {
	    x: 1400,
	    y: sectors["composting"].position.y + sectorSettings.size.height / 3 * 2,
	    rotation: 180,
	    group: "road1-a3"
	  }, {
	    x: 1275,
	    y: sectors["composting"].position.y + sectorSettings.size.height / 3 * 2,
	    rotation: 180,
	    group: "road1-a3"
	  }, {
	    x: 1150,
	    y: sectors["composting"].position.y + sectorSettings.size.height / 3 * 2,
	    rotation: 180,
	    group: "road1-a3"
	  }, {
	    x: 1025,
	    y: sectors["composting"].position.y + sectorSettings.size.height / 3 * 2,
	    rotation: 180,
	    group: "road1-a3"
	  }, {
	    x: 900,
	    y: sectors["composting"].position.y + sectorSettings.size.height / 3 * 2 + 50,
	    rotation: 180,
	    group: "road1-a3"
	  }, {
	    x: 800,
	    y: sectors["composting"].position.y + sectorSettings.size.height / 3 * 2 + 50,
	    rotation: 180,
	    group: "road1-a3"
	  }, {
	    x: 700,
	    y: sectors["composting"].position.y + sectorSettings.size.height / 3 * 2 + 50,
	    rotation: 180,
	    group: "road1-a3"
	  }, {
	    x: 600,
	    y: sectors["composting"].position.y + sectorSettings.size.height / 3 * 2 + 50,
	    rotation: 180,
	    group: "road1-a3"
	  }, {
	    x: 500,
	    y: sectors["composting"].position.y + sectorSettings.size.height / 3 * 2 + 50,
	    rotation: 180,
	    group: "road1-a3"
	  }, {
	    x: 400,
	    y: sectors["composting"].position.y + sectorSettings.size.height / 3 * 2 + 50,
	    rotation: 180,
	    group: "road1-a3"
	  }, {
	    x: intersections["road1-int2"].position.x,
	    y: 900,
	    rotation: 270,
	    group: "road1-a3"
	  },
	
	  // road1-a4
	  {
	    x: intersections["road1-int1"].position.x,
	    y: 825,
	    rotation: 270,
	    group: "road1-a4"
	  }, {
	    x: intersections["road1-int1"].position.x,
	    y: 725,
	    rotation: 270,
	    group: "road1-a4"
	  },
	
	  // road1-a5
	  {
	    x: intersections["road1-int1"].position.x + 40,
	    y: intersections["road1-int1"].position.y,
	    rotation: 0,
	    group: "road1-a5"
	  }]
	}, {
	  key: "road2",
	  connects: ["company", "waste_valorization"],
	
	  intersections: [],
	
	  connections: [
	  // company -> waste_valorization
	  {
	    start: "company",
	    startType: "sector",
	    end: "waste_valorization",
	    endType: "sector",
	
	    bidirectional: false,
	
	    startPosition: {
	      x: sectors["company"].position.x + sectorSettings.size.width / 5 * 2,
	      y: sectors["company"].position.y
	    },
	
	    navigation: [],
	
	    endPosition: {
	      x: sectors["waste_valorization"].position.x + sectorSettings.size.width / 5 * 2,
	      y: sectors["waste_valorization"].position.y + sectorSettings.size.height
	    },
	
	    arrowGroup: "road2-a1"
	  }],
	
	  crossings: [{
	    x: sectors["waste_valorization"].position.x + sectorSettings.size.width / 5 * 2,
	    y: 390,
	    rotation: 0
	  }],
	
	  arrows: [
	  // road2-a1
	  {
	    x: sectors["company"].position.x + sectorSettings.size.width / 5 * 2,
	    y: 575,
	    rotation: 270,
	    group: "road2-a1"
	  }, {
	    x: sectors["company"].position.x + sectorSettings.size.width / 5 * 2,
	    y: 475,
	    rotation: 270,
	    group: "road2-a1"
	  }, {
	    x: sectors["company"].position.x + sectorSettings.size.width / 5 * 2,
	    y: 375,
	    rotation: 270,
	    group: "road2-a1"
	  }]
	}, {
	  key: "road3",
	  connects: ["users", "reusability", "company", "road3-int1"],
	
	  connections: [
	  // users -> road3-int1
	  {
	    start: "users",
	    startType: "sector",
	    end: "road3-int1",
	    endType: "intersection",
	
	    bidirectional: false,
	
	    startPosition: {
	      x: sectors["users"].position.x + sectorSettings.size.width / 4 * 3,
	      y: sectors["users"].position.y + sectorSettings.size.height
	    },
	
	    navigation: [],
	
	    endPosition: {
	      x: intersections["road3-int1"].position.x,
	      y: intersections["road3-int1"].position.y
	    },
	
	    arrowGroup: "road3-a1"
	  },
	
	  // road3-int1 -> reusability
	  {
	    start: "road3-int1",
	    startType: "intersection",
	    end: "reusability",
	    endType: "sector",
	
	    bidirectional: false,
	
	    startPosition: {
	      x: intersections["road3-int1"].position.x,
	      y: intersections["road3-int1"].position.y
	    },
	
	    navigation: [],
	
	    endPosition: {
	      x: sectors["reusability"].position.x + sectorSettings.size.width,
	      y: sectors["reusability"].position.y + sectorSettings.size.height / 3
	    },
	
	    arrowGroup: "road3-a2"
	  },
	
	  // road3-int1 -> company
	  {
	    start: "road3-int1",
	    startType: "intersection",
	    end: "company",
	    endType: "sector",
	
	    bidirectional: false,
	
	    startPosition: {
	      x: intersections["road3-int1"].position.x,
	      y: intersections["road3-int1"].position.y
	    },
	
	    navigation: [{
	      x: +0,
	      y: +155
	    }, {
	      x: sectors["product_service_system"].position.x + sectorSettings.size.width / 2,
	      type: "absolute"
	    }, {
	      x: +0,
	      y: +50
	    }, {
	      x: sectors["company"].position.x + sectorSettings.size.width / 3,
	      type: "absolute"
	    }],
	
	    endPosition: {
	      x: sectors["company"].position.x + sectorSettings.size.width / 3,
	      y: sectors["company"].position.y + sectorSettings.size.height
	    },
	
	    arrowGroup: "road3-a3"
	  }],
	
	  crossings: [{
	    x: 600,
	    y: intersections["road3-int1"].position.y + 155 + 50,
	    rotation: 90
	  }, {
	    x: 1190,
	    y: intersections["road3-int1"].position.y + 155,
	    rotation: 90
	  }],
	
	  arrows: [
	  // road3-a1
	  {
	    x: sectors["users"].position.x + sectorSettings.size.width / 4 * 3,
	    y: 675,
	    rotation: 90,
	    group: "road3-a1"
	  },
	
	  // road3-a2
	  {
	    x: 1300,
	    y: intersections["road3-int1"].position.y,
	    rotation: 180,
	    group: "road3-a2"
	  },
	
	  // road3-a3
	  {
	    x: intersections["road3-int1"].position.x,
	    y: 775,
	    rotation: 90,
	    group: "road3-a3"
	  }, {
	    x: 1300,
	    y: intersections["road3-int1"].position.y + 155,
	    rotation: 180,
	    group: "road3-a3"
	  }, {
	    x: 1200,
	    y: intersections["road3-int1"].position.y + 155,
	    rotation: 180,
	    group: "road3-a3"
	  }, {
	    x: 1100,
	    y: intersections["road3-int1"].position.y + 155,
	    rotation: 180,
	    group: "road3-a3"
	  }, {
	    x: 1000,
	    y: intersections["road3-int1"].position.y + 155,
	    rotation: 180,
	    group: "road3-a3"
	  }, {
	    x: 850,
	    y: intersections["road3-int1"].position.y + 205,
	    rotation: 180,
	    group: "road3-a3"
	  }, {
	    x: 750,
	    y: intersections["road3-int1"].position.y + 205,
	    rotation: 180,
	    group: "road3-a3"
	  }, {
	    x: 650,
	    y: intersections["road3-int1"].position.y + 205,
	    rotation: 180,
	    group: "road3-a3"
	  }, {
	    x: 550,
	    y: intersections["road3-int1"].position.y + 205,
	    rotation: 180,
	    group: "road3-a3"
	  }, {
	    x: sectors["company"].position.x + sectorSettings.size.width / 3,
	    y: 825,
	    rotation: 270,
	    group: "road3-a3"
	  }]
	}, {
	  key: "road4",
	  connects: ["company", "extra_product"],
	
	  intersections: [],
	
	  connections: [
	  // company -> extra_product
	  {
	    start: "company",
	    startType: "sector",
	    end: "extra_product",
	    endType: "sector",
	
	    bidirectional: false,
	
	    startPosition: {
	      x: sectors["company"].position.x + sectorSettings.size.width / 3 * 2,
	      y: sectors["company"].position.y + sectorSettings.size.height
	    },
	
	    navigation: [{
	      y: sectors["extra_product"].position.y + sectorSettings.size.height / 2,
	      type: "absolute"
	    }],
	
	    endPosition: {
	      x: sectors["extra_product"].position.x,
	      y: sectors["extra_product"].position.y + sectorSettings.size.height / 2
	    },
	
	    arrowGroup: "road4-a1"
	  }],
	
	  crossings: [{
	    x: 580,
	    y: sectors["extra_product"].position.y + sectorSettings.size.height / 2,
	    rotation: 90
	  }],
	
	  arrows: [
	  // road4-a1
	  {
	    x: 575,
	    y: sectors["extra_product"].position.y + sectorSettings.size.height / 2,
	    rotation: 0,
	    group: "road4-a1"
	  }]
	}, {
	  key: "road5",
	  connects: ["company", "extra_product", "own_channel", "stores", "product_service_system", "road5-int1", "road5-int2", "road5-int3"],
	
	  connections: [
	  // company -> road5-int1
	  {
	    start: "company",
	    startType: "sector",
	    end: "road5-int1",
	    endType: "intersection",
	
	    bidirectional: false,
	
	    startPosition: {
	      x: sectors["company"].position.x + sectorSettings.size.width,
	      y: sectors["company"].position.y + sectorSettings.size.height / 2
	    },
	
	    navigation: [],
	
	    endPosition: {
	      x: intersections["road5-int1"].position.x,
	      y: intersections["road5-int1"].position.y
	    },
	
	    arrowGroup: "road5-a1"
	  },
	
	  // extra_product -> road5-int1
	  {
	    start: "extra_product",
	    startType: "sector",
	    end: "road5-int1",
	    endType: "intersection",
	
	    bidirectional: false,
	
	    startPosition: {
	      x: sectors["extra_product"].position.x + sectorSettings.size.width / 3,
	      y: sectors["extra_product"].position.y
	    },
	
	    navigation: [],
	
	    endPosition: {
	      x: intersections["road5-int1"].position.x,
	      y: intersections["road5-int1"].position.y
	    }
	  },
	
	  // road5-int1 -> road5-int2
	  {
	    start: "road5-int1",
	    startType: "intersection",
	    end: "road5-int2",
	    endType: "intersection",
	
	    bidirectional: false,
	
	    startPosition: {
	      x: intersections["road5-int1"].position.x,
	      y: intersections["road5-int1"].position.y
	    },
	
	    navigation: [],
	
	    endPosition: {
	      x: intersections["road5-int2"].position.x,
	      y: intersections["road5-int2"].position.y
	    },
	
	    arrowGroup: "road5-a3"
	  },
	
	  // road5-int2 -> product_service_system
	  {
	    start: "road5-int2",
	    startType: "intersection",
	    end: "product_service_system",
	    endType: "sector",
	
	    bidirectional: false,
	
	    startPosition: {
	      x: intersections["road5-int2"].position.x,
	      y: intersections["road5-int2"].position.y
	    },
	
	    navigation: [{
	      x: +60,
	      y: +0
	    }, {
	      y: sectors["product_service_system"].position.y + sectorSettings.size.height / 2,
	      type: "absolute"
	    }],
	
	    endPosition: {
	      x: sectors["product_service_system"].position.x,
	      y: sectors["product_service_system"].position.y + sectorSettings.size.height / 2
	    },
	
	    arrowGroup: "road5-a4"
	  },
	
	  // road5-int2 -> road5-int3
	  {
	    start: "road5-int2",
	    startType: "intersection",
	    end: "road5-int3",
	    endType: "intersection",
	
	    bidirectional: false,
	
	    startPosition: {
	      x: intersections["road5-int2"].position.x,
	      y: intersections["road5-int2"].position.y
	    },
	
	    navigation: [],
	
	    endPosition: {
	      x: intersections["road5-int3"].position.x,
	      y: intersections["road5-int3"].position.y
	    },
	
	    arrowGroup: "road5-a5"
	  },
	
	  // road5-int3 -> stores
	  {
	    start: "road5-int3",
	    startType: "intersection",
	    end: "stores",
	    endType: "sector",
	
	    bidirectional: false,
	
	    startPosition: {
	      x: intersections["road5-int3"].position.x,
	      y: intersections["road5-int3"].position.y
	    },
	
	    navigation: [],
	
	    endPosition: {
	      x: sectors["stores"].position.x,
	      y: sectors["stores"].position.y + sectorSettings.size.height / 2
	    },
	
	    arrowGroup: "road5-a6"
	  },
	
	  // road5-int3 -> own_channel
	  {
	    start: "road5-int3",
	    startType: "intersection",
	    end: "own_channel",
	    endType: "sector",
	
	    bidirectional: false,
	
	    startPosition: {
	      x: intersections["road5-int3"].position.x,
	      y: intersections["road5-int3"].position.y
	    },
	
	    navigation: [{
	      y: sectors["own_channel"].position.y + sectorSettings.size.height / 2,
	      type: "absolute"
	    }],
	
	    endPosition: {
	      x: sectors["own_channel"].position.x,
	      y: sectors["own_channel"].position.y + sectorSettings.size.height / 2
	    },
	
	    arrowGroup: "road5-a7"
	  }],
	
	  crossings: [{
	    x: 620,
	    y: intersections["road5-int1"].position.y,
	    rotation: 90
	  }, {
	    x: intersections["road5-int2"].position.x + 60,
	    y: 710,
	    rotation: 0
	  }, {
	    x: intersections["road5-int3"].position.x,
	    y: 450,
	    rotation: 0
	  }],
	
	  arrows: [
	  // road5-a1
	  {
	    x: 625,
	    y: intersections["road5-int1"].position.y,
	    rotation: 0,
	    group: "road5-a1"
	  },
	
	  // road5-a3
	  {
	    x: 725,
	    y: intersections["road5-int1"].position.y,
	    rotation: 0,
	    group: "road5-a3"
	  },
	
	  // road5-a4
	  {
	    x: 800,
	    y: intersections["road5-int1"].position.y,
	    rotation: 0,
	    group: "road5-a4"
	  }, {
	    x: intersections["road5-int2"].position.x + 60,
	    y: 725,
	    rotation: 90,
	    group: "road5-a4"
	  },
	
	  // road5-a5
	  {
	    x: intersections["road5-int2"].position.x,
	    y: 600,
	    rotation: 270,
	    group: "road5-a5"
	  },
	
	  // road5-a6
	  {
	    x: 785,
	    y: intersections["road5-int3"].position.y,
	    rotation: 0,
	    group: "road5-a6"
	  },
	
	  // road5-a7
	  {
	    x: intersections["road5-int3"].position.x,
	    y: 475,
	    rotation: 270,
	    group: "road5-a7"
	  }, {
	    x: intersections["road5-int3"].position.x,
	    y: 375,
	    rotation: 270,
	    group: "road5-a7"
	  }, {
	    x: 825,
	    y: sectors["own_channel"].position.y + sectorSettings.size.height / 2,
	    rotation: 0,
	    group: "road5-a7"
	  }]
	}, {
	  key: "road6",
	  connects: ["own_channel", "stores", "product_service_system", "users", "road6-int1"],
	
	  connections: [
	  // own_channel -> road6-int1
	  {
	    start: "own_channel",
	    startType: "sector",
	    end: "road6-int1",
	    endType: "intersection",
	
	    bidirectional: false,
	
	    startPosition: {
	      x: sectors["own_channel"].position.x + sectorSettings.size.width,
	      y: sectors["own_channel"].position.y + sectorSettings.size.height / 2
	    },
	
	    navigation: [{
	      x: intersections["road6-int1"].position.x,
	      type: "absolute"
	    }],
	
	    endPosition: {
	      x: intersections["road6-int1"].position.x,
	      y: intersections["road6-int1"].position.y
	    },
	
	    arrowGroup: "road6-a1"
	  },
	
	  // stores -> road6-int1
	  {
	    start: "stores",
	    startType: "sector",
	    end: "road6-int1",
	    endType: "intersection",
	
	    bidirectional: false,
	
	    startPosition: {
	      x: sectors["stores"].position.x + sectorSettings.size.width,
	      y: sectors["stores"].position.y + sectorSettings.size.height / 2
	    },
	
	    navigation: [],
	
	    endPosition: {
	      x: intersections["road6-int1"].position.x,
	      y: intersections["road6-int1"].position.y
	    },
	
	    arrowGroup: "road6-a2"
	  },
	
	  // product_service_system -> road6-int1
	  {
	    start: "product_service_system",
	    startType: "sector",
	    end: "road6-int1",
	    endType: "intersection",
	
	    bidirectional: false,
	
	    startPosition: {
	      x: sectors["product_service_system"].position.x + sectorSettings.size.width,
	      y: sectors["product_service_system"].position.y + sectorSettings.size.height / 2
	    },
	
	    navigation: [{
	      x: intersections["road6-int1"].position.x,
	      type: "absolute"
	    }],
	
	    endPosition: {
	      x: intersections["road6-int1"].position.x,
	      y: intersections["road6-int1"].position.y
	    },
	
	    arrowGroup: "road6-a3"
	  },
	
	  // road6-int1 -> users
	  {
	    start: "road6-int1",
	    startType: "intersection",
	    end: "users",
	    endType: "sector",
	
	    bidirectional: false,
	
	    startPosition: {
	      x: intersections["road6-int1"].position.x,
	      y: intersections["road6-int1"].position.y
	    },
	
	    navigation: [],
	
	    endPosition: {
	      x: sectors["users"].position.x,
	      y: sectors["users"].position.y + sectorSettings.size.height / 2
	    },
	
	    arrowGroup: "road6-a4"
	  }],
	
	  crossings: [{
	    x: sectors["stores"].position.x + sectorSettings.size.width + 40,
	    y: sectors["stores"].position.y + sectorSettings.size.height / 2,
	    rotation: 90
	  }, {
	    x: intersections["road6-int1"].position.x,
	    y: 625,
	    rotation: 0
	  }],
	
	  arrows: [
	  // road6-a1
	  {
	    x: intersections["road6-int1"].position.x,
	    y: 400,
	    rotation: 90,
	    group: "road6-a1"
	  }, {
	    x: intersections["road6-int1"].position.x,
	    y: 500,
	    rotation: 90,
	    group: "road6-a1"
	  },
	
	  // road6-a2
	  {
	    x: 1010,
	    y: intersections["road6-int1"].position.y,
	    rotation: 0,
	    group: "road6-a2"
	  },
	
	  // road6-a3
	  {
	    x: 1050,
	    y: sectors["product_service_system"].position.y + sectorSettings.size.height / 2,
	    rotation: 0,
	    group: "road6-a3"
	  }, {
	    x: intersections["road6-int1"].position.x,
	    y: 700,
	    rotation: 270,
	    group: "road6-a3"
	  }, {
	    x: intersections["road6-int1"].position.x,
	    y: 600,
	    rotation: 270,
	    group: "road6-a3"
	  },
	
	  // road6-a4
	  {
	    x: 1150,
	    y: intersections["road6-int1"].position.y,
	    rotation: 0,
	    group: "road6-a4"
	  }]
	}, {
	  key: "road7",
	  connects: ["reusability", "users"],
	
	  intersections: [],
	
	  connections: [
	  // reusability -> users
	  {
	    start: "reusability",
	    startType: "sector",
	    end: "users",
	    endType: "sector",
	
	    bidirectional: false,
	
	    startPosition: {
	      x: sectors["reusability"].position.x + sectorSettings.size.width / 4,
	      y: sectors["reusability"].position.y
	    },
	
	    navigation: [{
	      y: sectors["users"].position.y + sectorSettings.size.height / 5 * 4,
	      type: "absolute"
	    }],
	
	    endPosition: {
	      x: sectors["users"].position.x,
	      y: sectors["users"].position.y + sectorSettings.size.height / 5 * 4
	    },
	
	    arrowGroup: "road7-a1"
	  }],
	
	  crossings: [],
	
	  arrows: [
	  // road7-a1
	  {
	    x: sectors["reusability"].position.x + sectorSettings.size.width / 4,
	    y: 625,
	    rotation: 270,
	    group: "road7-a1"
	  }]
	}, {
	  key: "road8",
	  connects: ["users", "repair_service"],
	
	  intersections: [],
	
	  connections: [
	  // users -> repair_service
	  {
	    start: "users",
	    startType: "sector",
	    end: "repair_service",
	    endType: "sector",
	
	    bidirectional: true,
	
	    startPosition: {
	      x: sectors["users"].position.x + sectorSettings.size.width / 2,
	      y: sectors["users"].position.y
	    },
	
	    navigation: [],
	
	    endPosition: {
	      x: sectors["repair_service"].position.x + sectorSettings.size.width / 2,
	      y: sectors["repair_service"].position.y + sectorSettings.size.height
	    }
	  }],
	
	  crossings: [{
	    x: sectors["users"].position.x + sectorSettings.size.width / 2,
	    y: sectors["repair_service"].position.y + sectorSettings.size.height + (sectors["users"].position.y - sectors["repair_service"].position.y - sectorSettings.size.height) / 2,
	    rotation: 0
	  }]
	}, {
	  key: "road9",
	  connects: ["users", "collection"],
	
	  intersections: [],
	
	  connections: [
	  // users -> collection
	  {
	    start: "users",
	    startType: "sector",
	    end: "collection",
	    endType: "sector",
	
	    bidirectional: true,
	
	    startPosition: {
	      x: sectors["users"].position.x + sectorSettings.size.width,
	      y: sectors["users"].position.y + sectorSettings.size.height / 2
	    },
	
	    navigation: [],
	
	    endPosition: {
	      x: sectors["collection"].position.x,
	      y: sectors["collection"].position.y + sectorSettings.size.height / 2
	    },
	
	    arrowGroup: "road9-a1"
	  }],
	
	  crossings: [],
	
	  arrows: [
	  // road9-a1
	  {
	    x: 1400,
	    y: sectors["users"].position.y + sectorSettings.size.height / 2,
	    rotation: 0,
	    group: "road9-a1"
	  }]
	}, {
	  key: "road10",
	  connects: ["collection", "composting"],
	
	  intersections: [],
	
	  connections: [
	  // collection -> composting
	  {
	    start: "collection",
	    startType: "sector",
	    end: "composting",
	    endType: "sector",
	
	    bidirectional: true,
	
	    startPosition: {
	      x: sectors["collection"].position.x + sectorSettings.size.width / 2,
	      y: sectors["collection"].position.y + sectorSettings.size.height
	    },
	
	    navigation: [],
	
	    endPosition: {
	      x: sectors["composting"].position.x + sectorSettings.size.width / 2,
	      y: sectors["composting"].position.y
	    },
	
	    arrowGroup: "road10-a1"
	  }],
	
	  crossings: [{
	    x: sectors["collection"].position.x + sectorSettings.size.width / 2,
	    y: 700,
	    rotation: 0
	  }],
	
	  arrows: [
	  // road10-a1
	  {
	    x: sectors["collection"].position.x + sectorSettings.size.width / 2,
	    y: 650,
	    rotation: 90,
	    group: "road10-a1"
	  }, {
	    x: sectors["collection"].position.x + sectorSettings.size.width / 2,
	    y: 750,
	    rotation: 90,
	    group: "road10-a1"
	  }]
	}, {
	  key: "road11",
	  connects: ["collection", "waste"],
	
	  intersections: [],
	
	  connections: [
	  // collection -> waste
	  {
	    start: "collection",
	    startType: "sector",
	    end: "waste",
	    endType: "sector",
	
	    bidirectional: true,
	
	    startPosition: {
	      x: sectors["collection"].position.x + sectorSettings.size.width,
	      y: sectors["collection"].position.y + sectorSettings.size.height / 2
	    },
	
	    navigation: [],
	
	    endPosition: {
	      x: sectors["waste"].position.x,
	      y: sectors["waste"].position.y + sectorSettings.size.height / 2
	    },
	
	    arrowGroup: "road11-a1"
	  }],
	
	  crossings: [],
	
	  arrows: [
	  // road11-a1
	  {
	    x: 1630,
	    y: sectors["collection"].position.y + sectorSettings.size.height / 2,
	    rotation: 0,
	    group: "road11-a1"
	  }]
	}, {
	  key: "road12",
	  connects: ["waste", "recycling"],
	
	  intersections: [],
	
	  connections: [
	  // waste -> recycling
	  {
	    start: "waste",
	    startType: "sector",
	    end: "recycling",
	    endType: "sector",
	
	    bidirectional: true,
	
	    startPosition: {
	      x: sectors["waste"].position.x + sectorSettings.size.width / 2,
	      y: sectors["waste"].position.y
	    },
	
	    navigation: [{
	      y: sectors["recycling"].position.y + sectorSettings.size.height / 2,
	      type: "absolute"
	    }],
	
	    endPosition: {
	      x: sectors["recycling"].position.x + sectorSettings.size.width,
	      y: sectors["recycling"].position.y + sectorSettings.size.height / 2
	    },
	
	    arrowGroup: "road12-a1"
	  }],
	
	  crossings: [{
	    x: sectors["waste"].position.x + sectorSettings.size.width / 2,
	    y: 350,
	    rotation: 0
	  }],
	
	  arrows: [
	  // road12-a1
	  {
	    x: sectors["waste"].position.x + sectorSettings.size.width / 2,
	    y: 400,
	    rotation: 270,
	    group: "road12-a1"
	  }, {
	    x: sectors["waste"].position.x + sectorSettings.size.width / 2,
	    y: 300,
	    rotation: 270,
	    group: "road12-a1"
	  }, {
	    x: 1675,
	    y: sectors["recycling"].position.y + sectorSettings.size.height / 2,
	    rotation: 180,
	    group: "road12-a1"
	  }]
	}, {
	  key: "road13",
	  connects: ["recycling", "recycling_processing"],
	
	  intersections: [],
	
	  connections: [
	  // recycling -> recycling_processing
	  {
	    start: "recycling",
	    startType: "sector",
	    end: "recycling_processing",
	    endType: "sector",
	
	    bidirectional: true,
	
	    startPosition: {
	      x: sectors["recycling"].position.x + sectorSettings.size.width / 2,
	      y: sectors["recycling"].position.y
	    },
	
	    navigation: [{
	      x: +0,
	      y: -50
	    }, {
	      x: sectors["recycling_processing"].position.x + sectorSettings.size.width / 2,
	      type: "absolute"
	    }],
	
	    endPosition: {
	      x: sectors["recycling_processing"].position.x + sectorSettings.size.width / 2,
	      y: sectors["recycling_processing"].position.y
	    },
	
	    arrowGroup: "road13-a1"
	  }],
	
	  crossings: [{
	    x: 1350,
	    y: sectors["recycling"].position.y - 50,
	    rotation: 90
	  }, {
	    x: 850,
	    y: sectors["recycling"].position.y - 50,
	    rotation: 90
	  }],
	
	  arrows: [
	  // road13-a1
	  {
	    x: sectors["recycling"].position.x + sectorSettings.size.width / 2,
	    y: 125,
	    rotation: 270,
	    group: "road13-a1"
	  }, {
	    x: 1450,
	    y: sectors["recycling"].position.y - 50,
	    rotation: 180,
	    group: "road13-a1"
	  }, {
	    x: 1325,
	    y: sectors["recycling"].position.y - 50,
	    rotation: 180,
	    group: "road13-a1"
	  }, {
	    x: 1200,
	    y: sectors["recycling"].position.y - 50,
	    rotation: 180,
	    group: "road13-a1"
	  }, {
	    x: 1075,
	    y: sectors["recycling"].position.y - 50,
	    rotation: 180,
	    group: "road13-a1"
	  }, {
	    x: 950,
	    y: sectors["recycling"].position.y - 50,
	    rotation: 180,
	    group: "road13-a1"
	  }, {
	    x: 825,
	    y: sectors["recycling"].position.y - 50,
	    rotation: 180,
	    group: "road13-a1"
	  }]
	}, {
	  key: "road14",
	  connects: ["recycling_processing", "company"],
	
	  intersections: [],
	
	  connections: [
	  // recycling_processing -> company
	  {
	    start: "recycling_processing",
	    startType: "sector",
	    end: "company",
	    endType: "sector",
	
	    bidirectional: true,
	
	    startPosition: {
	      x: sectors["recycling_processing"].position.x + sectorSettings.size.width / 2,
	      y: sectors["recycling_processing"].position.y + sectorSettings.size.height
	    },
	
	    navigation: [{
	      x: +0,
	      y: +140
	    }, {
	      x: sectors["company"].position.x + sectorSettings.size.width / 3 * 2,
	      type: "absolute"
	    }],
	
	    endPosition: {
	      x: sectors["company"].position.x + sectorSettings.size.width / 3 * 2,
	      y: sectors["company"].position.y
	    },
	
	    arrowGroup: "road14-a1"
	  }],
	
	  crossings: [{
	    x: 625,
	    y: sectors["recycling_processing"].position.y + sectorSettings.size.height + 140,
	    rotation: 90
	  }],
	
	  arrows: [
	  // road14-a1
	  {
	    x: sectors["recycling_processing"].position.x + sectorSettings.size.width / 2,
	    y: 350,
	    rotation: 90,
	    group: "road14-a1"
	  }, {
	    x: 650,
	    y: sectors["recycling_processing"].position.y + sectorSettings.size.height + 140,
	    rotation: 180,
	    group: "road14-a1"
	  }, {
	    x: 550,
	    y: sectors["recycling_processing"].position.y + sectorSettings.size.height + 140,
	    rotation: 180,
	    group: "road14-a1"
	  }, {
	    x: sectors["company"].position.x + sectorSettings.size.width / 3 * 2,
	    y: 525,
	    rotation: 90,
	    group: "road14-a1"
	  }]
	}];
	
	// %NOTE: index en waitOn worden momenteel niet gebruikt // %TODO: herwerken zoals actions bij investementActions
	var startActions = [{
	  index: 0,
	  targetType: "sector",
	  target: "limited_resources",
	  action: _constants2.default.BUSINESS_MODEL_ACTIONS.ACTIVATE,
	  waitOn: null
	}, {
	  index: 1,
	  targetType: "road",
	  target: [{
	    startPoint: "limited_resources",
	    intersections: ["road1-int1"],
	    endPoint: "company"
	  }],
	  action: _constants2.default.BUSINESS_MODEL_ACTIONS.ACTIVATE,
	  waitOn: 0
	}, {
	  index: 2,
	  targetType: "sector",
	  target: "company",
	  action: _constants2.default.BUSINESS_MODEL_ACTIONS.ACTIVATE,
	  waitOn: 1
	}, {
	  index: 3,
	  targetType: "power-line",
	  target: [{
	    startPoint: "limited_resources",
	    endPoint: "power-cabinet-1"
	  }, {
	    startPoint: "power-cabinet-1",
	    endPoint: "company"
	  }],
	  action: _constants2.default.BUSINESS_MODEL_ACTIONS.ACTIVATE,
	  waitOn: 1
	}, {
	  index: 4,
	  targetType: "road",
	  target: [{
	    startPoint: "company",
	    intersections: ["road5-int1", "road5-int2", "road5-int3"],
	    endPoint: "stores"
	  }],
	  action: _constants2.default.BUSINESS_MODEL_ACTIONS.ACTIVATE,
	  waitOn: 2
	}, {
	  index: 5,
	  targetType: "sector",
	  target: "stores",
	  action: _constants2.default.BUSINESS_MODEL_ACTIONS.ACTIVATE,
	  waitOn: 4
	}, {
	  index: 6,
	  targetType: "road",
	  target: [{
	    startPoint: "stores",
	    intersections: ["road6-int1"],
	    endPoint: "users"
	  }],
	  action: _constants2.default.BUSINESS_MODEL_ACTIONS.ACTIVATE,
	  waitOn: 5
	}, {
	  index: 7,
	  targetType: "sector",
	  target: "users",
	  action: _constants2.default.BUSINESS_MODEL_ACTIONS.ACTIVATE,
	  waitOn: 6
	}, {
	  index: 8,
	  targetType: "road",
	  target: [{
	    startPoint: "users",
	    endPoint: "collection"
	  }],
	  action: _constants2.default.BUSINESS_MODEL_ACTIONS.ACTIVATE,
	  waitOn: 7
	}, {
	  index: 9,
	  targetType: "sector",
	  target: "collection",
	  action: _constants2.default.BUSINESS_MODEL_ACTIONS.ACTIVATE,
	  waitOn: 8
	}, {
	  index: 10,
	  targetType: "road",
	  target: [{
	    startPoint: "collection",
	    endPoint: "waste"
	  }],
	  action: _constants2.default.BUSINESS_MODEL_ACTIONS.ACTIVATE,
	  waitOn: 9
	}, {
	  index: 11,
	  targetType: "sector",
	  target: "waste",
	  action: _constants2.default.BUSINESS_MODEL_ACTIONS.ACTIVATE,
	  waitOn: 9
	}];
	
	var investmentActions = {
	  "biomaterials": {
	    actions: [{ type: "sector", active: true, wait: true, data: { name: "unlimited_resources" } }, {
	      requirement: "renewablematerials",
	      type: "icon",
	      active: true,
	      wait: true,
	      data: { name: "unlimited_resources", source: sectorIcons("./unlimited_resources_bio_white.svg") }
	    }]
	  },
	
	  "extraproduct": {
	    actions: [{
	      type: "road", active: true, wait: true, data: {
	        startPoint: "company",
	        endPoint: "extra_product"
	      }
	    }, { type: "sector", active: true, wait: true, data: { name: "extra_product" } }, {
	      type: "road", active: true, wait: true, data: {
	        startPoint: "extra_product",
	        endPoint: "road5-int1"
	      }
	    }]
	  },
	
	  "greenenergy": {
	    actions: [{ type: "sector", active: true, wait: true, data: { name: "unlimited_resources" } }, {
	      type: "power-line", active: true, wait: false, data: [{
	        startPoint: "unlimited_resources",
	        endPoint: "power-cabinet-1"
	      }]
	    }, {
	      type: "power-line", active: false, wait: false, data: [{
	        startPoint: "limited_resources",
	        endPoint: "power-cabinet-1"
	      }]
	    }]
	  },
	
	  "localproduction": {
	    actions: [{
	      type: "road", active: true, wait: true, data: {
	        startPoint: "company",
	        intersections: ["road5-int1", "road5-int2"],
	        endPoint: "product_service_system"
	      }
	    }, { type: "sector", active: true, wait: true, data: { name: "product_service_system" } }, {
	      type: "road", active: true, wait: true, data: {
	        startPoint: "product_service_system",
	        intersections: ["road6-int1"],
	        endPoint: "users"
	      }
	    }]
	  },
	
	  "paas": {
	    actions: [{
	      type: "road", active: true, wait: true, data: {
	        startPoint: "company",
	        intersections: ["road5-int1", "road5-int2"],
	        endPoint: "product_service_system"
	      }
	    }, { type: "sector", active: true, wait: true, data: { name: "product_service_system" } }, {
	      type: "road", active: true, wait: true, data: {
	        startPoint: "product_service_system",
	        intersections: ["road6-int1"],
	        endPoint: "users"
	      }
	    }]
	  },
	
	  "productredesign": {
	    actions: [{ type: "sector", active: true, wait: true, data: { name: "company" } }]
	  },
	
	  "renewablematerials": {
	    // TODO - iets met waste dat nie mag gedisabled worden (reststromen inkopen)
	    actions: [
	    // {requirement: "productredesign", type: "sector", active: false, wait: false, data: {name: "waste"}},
	    // {
	    //   requirement: "productredesign", type: "road", active: false, wait: false, data: {
	    //     startPoint: "collection",
	    //     endPoint: "waste"
	    //   }
	    // },
	    { requirement: "productredesign", type: "sector", active: false, wait: false, data: { name: "limited_resources" } }, {
	      requirement: "productredesign", type: "road", active: false, wait: false, data: {
	        startPoint: "limited_resources",
	        intersections: ["road1-int1"],
	        endPoint: "company"
	      }
	    }, {
	      type: "road", active: true, wait: true, data: {
	        startPoint: "collection",
	        endPoint: "composting"
	      }
	    }, { type: "sector", active: true, wait: true, data: { name: "composting" } }, {
	      type: "road", active: true, wait: true, data: {
	        startPoint: "composting",
	        intersections: ["road1-int2", "road1-int1"],
	        endPoint: "company"
	      }
	    }, { type: "sector", active: true, wait: true, data: { name: "unlimited_resources" } }, {
	      type: "road", active: true, wait: true, data: {
	        startPoint: "unlimited_resources",
	        intersections: ["road1-int2", "road1-int1"],
	        endPoint: "company"
	      }
	    }]
	  },
	
	  "repairservice": {
	    actions: [{
	      type: "road", active: true, wait: true, data: {
	        startPoint: "users",
	        endPoint: "repair_service"
	      }
	    }, { type: "sector", active: true, wait: true, data: { name: "repair_service" } }]
	  },
	
	  "residualflows": {
	    actions: [{
	      type: "road", active: true, wait: true, data: {
	        startPoint: "waste",
	        endPoint: "recycling"
	      }
	    }, { type: "sector", active: true, wait: true, data: { name: "recycling" } }, {
	      type: "road", active: true, wait: true, data: {
	        startPoint: "recycling",
	        endPoint: "recycling_processing"
	      }
	    }, { type: "sector", active: true, wait: true, data: { name: "recycling_processing" } }, {
	      type: "road", active: true, wait: true, data: {
	        startPoint: "recycling_processing",
	        endPoint: "company"
	      }
	    }]
	  },
	
	  "returnprogram": {
	    actions: [{
	      type: "road", active: true, wait: true, data: {
	        startPoint: "users",
	        intersections: ["road3-int1"],
	        endPoint: "company"
	      }
	    }]
	  },
	
	  "reuse": {
	    actions: [{
	      type: "road", active: true, wait: true, data: {
	        startPoint: "users",
	        intersections: ["road3-int1"],
	        endPoint: "reusability"
	      }
	    }, { type: "sector", active: true, wait: true, data: { name: "reusability" } }, { type: "text", active: true, wait: true, data: { name: "reusability", value: "Herbruik" } }, {
	      type: "road", active: true, wait: true, data: {
	        startPoint: "reusability",
	        endPoint: "users"
	      }
	    }]
	  },
	
	  // enkel power lines, geen sector active
	  "solarpanels": {
	    actions: [{
	      type: "power-line", active: true, wait: false, data: [{
	        startPoint: "unlimited_resources",
	        endPoint: "power-cabinet-1"
	      }]
	    }, {
	      type: "power-line", active: true, wait: false, data: [{
	        startPoint: "limited_resources",
	        endPoint: "power-cabinet-1"
	      }]
	    }]
	  },
	
	  "spareparts": {
	    actions: [{
	      type: "road", active: true, wait: true, data: {
	        startPoint: "road5-int3",
	        endPoint: "own_channel"
	      }
	    }, { type: "sector", active: true, wait: true, data: { name: "own_channel" } }, { type: "text", active: true, wait: true, data: { name: "reusability", value: "Herbruik" } }, {
	      type: "road", active: true, wait: true, data: {
	        startPoint: "own_channel",
	        intersections: ["road6-int1"],
	        endPoint: "users"
	      }
	    }, {
	      type: "road", active: true, wait: true, data: {
	        startPoint: "users",
	        intersections: ["road3-int1"],
	        endPoint: "reusability"
	      }
	    }, { type: "sector", active: true, wait: true, data: { name: "reusability" } }, {
	      type: "road", active: true, wait: true, data: {
	        startPoint: "reusability",
	        endPoint: "users"
	      }
	    }]
	  },
	
	  "subsidy": {
	    // No actions
	    actions: []
	  },
	
	  "wastevalorization": {
	    actions: [{
	      type: "road", active: true, wait: true, data: {
	        startPoint: "company",
	        endPoint: "waste_valorization"
	      }
	    }, { type: "sector", active: true, wait: true, data: { name: "waste_valorization" } }]
	  }
	};
	
	var faqIcons = [{
	  key: "faq-limited_resources",
	  position: {
	    x: sectors["limited_resources"].position.x + sectorSettings.size.width,
	    y: sectors["limited_resources"].position.y,
	    originX: "center",
	    originY: "center"
	  },
	  sector: sectors["limited_resources"]
	}, {
	  key: "faq-unlimited_resources",
	  position: {
	    x: sectors["unlimited_resources"].position.x + sectorSettings.size.width,
	    y: sectors["unlimited_resources"].position.y,
	    originX: "center",
	    originY: "center"
	  },
	  sector: sectors["unlimited_resources"]
	}, {
	  key: "faq-waste_valorization",
	  position: {
	    x: sectors["waste_valorization"].position.x + sectorSettings.size.width,
	    y: sectors["waste_valorization"].position.y,
	    originX: "center",
	    originY: "center"
	  },
	  sector: sectors["waste_valorization"]
	}, {
	  key: "faq-company",
	  position: {
	    x: sectors["company"].position.x + sectorSettings.size.width,
	    y: sectors["company"].position.y,
	    originX: "center",
	    originY: "center"
	  },
	  sector: sectors["company"]
	}, {
	  key: "faq-recycling_processing",
	  position: {
	    x: sectors["recycling_processing"].position.x + sectorSettings.size.width,
	    y: sectors["recycling_processing"].position.y,
	    originX: "center",
	    originY: "center"
	  },
	  sector: sectors["recycling_processing"]
	}, {
	  key: "faq-extra_product",
	  position: {
	    x: sectors["extra_product"].position.x + sectorSettings.size.width,
	    y: sectors["extra_product"].position.y,
	    originX: "center",
	    originY: "center"
	  },
	  sector: sectors["extra_product"]
	}, {
	  key: "faq-own_channel",
	  position: {
	    x: sectors["own_channel"].position.x + sectorSettings.size.width,
	    y: sectors["own_channel"].position.y,
	    originX: "center",
	    originY: "center"
	  },
	  sector: sectors["own_channel"]
	}, {
	  key: "faq-stores",
	  position: {
	    x: sectors["stores"].position.x + sectorSettings.size.width,
	    y: sectors["stores"].position.y,
	    originX: "center",
	    originY: "center"
	  },
	  sector: sectors["stores"]
	}, {
	  key: "faq-product_service_system",
	  position: {
	    x: sectors["product_service_system"].position.x + sectorSettings.size.width,
	    y: sectors["product_service_system"].position.y,
	    originX: "center",
	    originY: "center"
	  },
	  sector: sectors["product_service_system"]
	}, {
	  key: "faq-repair_service",
	  position: {
	    x: sectors["repair_service"].position.x + sectorSettings.size.width,
	    y: sectors["repair_service"].position.y,
	    originX: "center",
	    originY: "center"
	  },
	  sector: sectors["repair_service"]
	}, {
	  key: "faq-users",
	  position: {
	    x: sectors["users"].position.x + sectorSettings.size.width,
	    y: sectors["users"].position.y,
	    originX: "center",
	    originY: "center"
	  },
	  sector: sectors["users"]
	}, {
	  key: "faq-reusability",
	  position: {
	    x: sectors["reusability"].position.x + sectorSettings.size.width,
	    y: sectors["reusability"].position.y,
	    originX: "center",
	    originY: "center"
	  },
	  sector: sectors["reusability"]
	}, {
	  key: "faq-recycling",
	  position: {
	    x: sectors["recycling"].position.x + sectorSettings.size.width,
	    y: sectors["recycling"].position.y,
	    originX: "center",
	    originY: "center"
	  },
	  sector: sectors["recycling"]
	}, {
	  key: "faq-collection",
	  position: {
	    x: sectors["collection"].position.x + sectorSettings.size.width,
	    y: sectors["collection"].position.y,
	    originX: "center",
	    originY: "center"
	  },
	  sector: sectors["collection"]
	}, {
	  key: "faq-composting",
	  position: {
	    x: sectors["composting"].position.x + sectorSettings.size.width,
	    y: sectors["composting"].position.y,
	    originX: "center",
	    originY: "center"
	  },
	  sector: sectors["composting"]
	}, {
	  key: "faq-waste",
	  position: {
	    x: sectors["waste"].position.x + sectorSettings.size.width,
	    y: sectors["waste"].position.y,
	    originX: "center",
	    originY: "center"
	  },
	  sector: sectors["waste"]
	}, {
	  key: "faq-power_cabinet",
	  position: {
	    x: powerCabinets["power-cabinet-1"].position.x + powerGridSettings.cabinetSize.width / 2,
	    y: powerCabinets["power-cabinet-1"].position.y - powerGridSettings.cabinetSize.height / 2,
	    originX: "center",
	    originY: "center"
	  }
	}, {
	  key: "faq-road1_1",
	  position: {
	    x: 350,
	    y: 350,
	    originX: "center",
	    originY: "center"
	  }
	}, {
	  key: "faq-road1_2",
	  position: {
	    x: 650,
	    y: 950,
	    originX: "center",
	    originY: "center"
	  }
	}, {
	  key: "faq-road6_int1",
	  position: {
	    x: intersections["road6-int1"].position.x,
	    y: intersections["road6-int1"].position.y,
	    originX: "center",
	    originY: "center"
	  }
	}, {
	  key: "faq-road13_1",
	  position: {
	    x: 1100,
	    y: 100,
	    originX: "center",
	    originY: "center"
	  }
	}, {
	  key: "faq-road3_1",
	  position: {
	    x: 1150,
	    y: 860,
	    originX: "center",
	    originY: "center"
	  }
	}];
	
	var testLayout = {
	  // TODO background takes a little long to load, maybe change to image instead of svg?
	  background: businessModelImages("./background.svg"),
	  // background: businessModelImages("./background.png"),
	  backgroundColor: "#f4f7f9",
	
	  size: {
	    width: 1920,
	    height: 1080
	  },
	
	  sectors: sectors,
	  sectorSettings: sectorSettings,
	
	  incomeIcon: incomeIcon,
	
	  powerCabinets: powerCabinets,
	  powerLines: powerLines,
	  powerGridSettings: powerGridSettings,
	
	  intersections: intersections,
	  roads: roads,
	  roadSettings: roadSettings,
	
	  startActions: startActions,
	  investmentActions: investmentActions,
	
	  faqIcons: faqIcons,
	  faqSettings: faqSettings,
	
	  animationDuration: animationDuration
	};
	
	// TODO maybe add actions (ie, which sectors/power lines/roads should be activated/deactivated) when an investment is made
	// + test mode to test all investments
	
	exports.default = testLayout;

/***/ }),

/***/ 213:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	var _utils = __webpack_require__(3);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _userServices = __webpack_require__(214);
	
	var _userServices2 = _interopRequireDefault(_userServices);
	
	var _storageController = __webpack_require__(50);
	
	var _storageController2 = _interopRequireDefault(_storageController);
	
	var _appError = __webpack_require__(51);
	
	var _appError2 = _interopRequireDefault(_appError);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var log = __webpack_require__(5)();
	
	
	var LoginManager = {};
	
	(function (LoginManager) {
	  LoginManager.ERRORS = {
	    USERNAME_PASSWORD_INCORRECT: "username_password_incorrect",
	    INCOMPLETE_PROFILE: "incomplete_profile",
	    USER_NOT_VERIFIED: "user_not_verified",
	    NO_USER_DATA: "no_user_data",
	    UNEXPECTED: "unexpected"
	  };
	
	  LoginManager.usernameExists = function (username) {
	    return _userServices2.default.usernameExists(username);
	  };
	
	  LoginManager.logout = function () {
	    _userServices2.default.logout().finally(function () {
	      _storageController2.default.removeFromLocal(_storageController2.default.keys.LOGGED_IN_USER);
	    });
	  };
	
	  LoginManager.login = function (username, password) {
	    // LoginManager.logout(() =>
	    // {
	    //   _login(username, password, successCb, failCb);
	    // });
	
	    // We no longer logout since the server does that for us now
	    return _login(username, password);
	  };
	
	  function _login(username, password) {
	    $("html").addClass("waiting");
	
	    _storageController2.default.removeFromLocal(_storageController2.default.keys.LOGGED_IN_USER);
	
	    return _userServices2.default.authenticateUser(username, password)
	    // [catch] before [then] because [then] throws new errors which would otherwise be caught by this [catch]
	    .catch(function (data) {
	      // Fail
	      log.error("Failed to authenticate - %o", data);
	      $("html").removeClass("waiting");
	
	      throw new _appError2.default({
	        data: {
	          data: data,
	          errorType: LoginManager.ERRORS.UNEXPECTED
	        },
	        exception: new Error("Unexpected error occurred")
	      });
	    }).then(function (data) {
	      // Success
	      var xmlDoc = $($.parseXML(data));
	      var referrer = xmlDoc.find("access-control").attr("referer");
	      var xmlData = xmlDoc.find("access-control").find("data").text();
	
	      log.info("Login xml data: %s", xmlData);
	
	      $("html").removeClass("waiting");
	
	      if (isSuccess(xmlDoc)) {
	        var userData = _utils2.default.parseJSON(xmlData, true);
	
	        if (_utils2.default.isNullOrEmpty(userData)) {
	          log.error("User data is empty in login response");
	
	          throw new _appError2.default({
	            data: {
	              data: data,
	              errorType: LoginManager.ERRORS.NO_USER_DATA
	            },
	            exception: new Error("User data is empty in login response")
	          });
	        }
	
	        if (!userData.hasOwnProperty("authenticated") || userData.authenticated) {
	          // Success
	          return {
	            userData: userData,
	            referer: referrer
	          };
	        } else {
	          // login failed (wrong credentials)
	          throw new _appError2.default({
	            data: {
	              data: data,
	              errorType: LoginManager.ERRORS.USERNAME_PASSWORD_INCORRECT
	            },
	            exception: new Error("Tried to login with wrong credentials")
	          });
	        }
	      } else if (isError(xmlDoc)) {
	        var errorData = _utils2.default.parseJSON(xmlData, true);
	
	        if (_utils2.default.isNotNull(errorData)) {
	          if (errorData.incomplete) {
	            //incomplete profile
	            throw new _appError2.default({
	              data: {
	                data: data,
	                errorType: LoginManager.ERRORS.INCOMPLETE_PROFILE
	              },
	              exception: new Error("Tried to login while profile is incomplete")
	            });
	          } else if (_utils2.default.isNotNull(errorData.errorCode)) {
	            //incomplete profile
	            throw new _appError2.default({
	              code: errorData.errorCode,
	              data: {
	                data: data,
	                errorType: getErrorForCode(errorData.errorCode)
	              },
	              exception: new Error("Tried to login while profile is incomplete")
	            });
	          }
	        }
	
	        throw new _appError2.default({
	          data: {
	            data: data,
	            errorType: LoginManager.ERRORS.USERNAME_PASSWORD_INCORRECT
	          },
	          exception: new Error("Tried to login with wrong credentials")
	        });
	      } else {
	        // always fun to say: should not come here... :)
	        throw new _appError2.default({
	          data: {
	            data: data,
	            errorType: LoginManager.ERRORS.UNEXPECTED
	          },
	          exception: new Error("Unexpected error occurred")
	        });
	      }
	    });
	  }
	
	  function is(what, xml) {
	    return xml.find("access-control").attr("result") === what;
	  }
	
	  function isSuccess(xml) {
	    return is("success", xml);
	  }
	
	  function isError(xml) {
	    return is("error", xml);
	  }
	
	  function isNotLoggedIn(xml) {
	    return is("null", xml);
	  }
	
	  function getErrorForCode(code) {
	    if (code === "E45370") {
	      return LoginManager.ERRORS.UNEXPECTED;
	    } else if (code === "E55053") {
	      return LoginManager.ERRORS.USER_NOT_VERIFIED;
	    } else if (code === "E73550") {
	      return LoginManager.ERRORS.USERNAME_PASSWORD_INCORRECT;
	    }
	
	    return LoginManager.ERRORS.UNEXPECTED;
	  }
	})(LoginManager);
	
	module.exports = LoginManager;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),

/***/ 214:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	/**
	 * Created by jv on 19/07/2017.
	 */
	var utils = __webpack_require__(3);
	var request = __webpack_require__(186);
	
	var UserServices = {};
	
	(function (UserServices) {
	  UserServices.logout = function () {
	    return request.get({
	      url: "/logout",
	      cache: false
	    });
	  };
	
	  UserServices.usernameExists = function (username) {
	    return request.post({
	      // url: "/access/authenticate/password",
	      url: utils.getServiceUrl("/users/validate-username/" + encodeURIComponent(username)),
	      cache: false,
	      dataType: request.DATA_TYPES.JSON,
	      contentType: request.CONTENT_TYPES.APPLICATION_JSON
	    });
	  };
	
	  UserServices.authenticateUser = function (username, password) {
	    // AuthenticateUserServlet functions as a proxy for /access/authenticate/password so we can force logout when a new authentication is requested
	    return request.post({
	      // url: "/access/authenticate/password",
	      url: "/authenticate-user",
	      cache: false,
	      dataType: request.DATA_TYPES.TEXT,
	      contentType: request.CONTENT_TYPES.APPLICATION_FORM_URLENCODED,
	      data: {
	        username: utils.isDefined(username) ? username : null,
	        password: utils.isDefined(password) ? password : null
	      }
	    });
	  };
	
	  UserServices.requestPasswordReset = function (username) {
	    return request.post({
	      url: utils.getServiceUrl("/users/reset-password"),
	      cache: false,
	      // contentType: request.CONTENT_TYPES.APPLICATION_FORM_URLENCODED,
	      data: {
	        username: username
	      }
	    }).then(function (data) {
	      var rtrnData = null;
	
	      if (utils.isNotNull(data) && data.result === "success" && data.data) {
	        rtrnData = data.data;
	      }
	
	      return rtrnData;
	    });
	  };
	
	  UserServices.changePassword = function (data) {
	    return request.post({
	      url: utils.getServiceUrl("/users/change-password"),
	      cache: false,
	      // contentType: request.CONTENT_TYPES.APPLICATION_FORM_URLENCODED,
	      data: {
	        username: data.username,
	        "password-old": data.passwordOld,
	        "password-new": data.passwordNew,
	        ticket: data.ticket
	      }
	    }).then(function (data) {
	      var rtrnData = null;
	
	      if (utils.isNotNull(data) && data.result === "success" && data.data) {
	        rtrnData = data.data;
	      }
	
	      return rtrnData;
	    });
	  };
	
	  UserServices.getUser = function (key) {
	    return request.get({
	      url: utils.getServiceUrl("/users/" + key),
	      cache: false,
	      dataType: request.DATA_TYPES.JSON,
	      contentType: request.CONTENT_TYPES.APPLICATION_JSON
	    }).then(function (data) {
	      var user = null;
	
	      if (utils.isNotNull(data) && data.result === "success" && utils.isNotNull(data.data)) {
	        user = data.data;
	      }
	
	      return user;
	    });
	  };
	
	  UserServices.registerUser = function (userObj) {
	    return request.post({
	      url: utils.getServiceUrl("/users/register"),
	      cache: false,
	      dataType: request.DATA_TYPES.JSON,
	      contentType: request.CONTENT_TYPES.APPLICATION_JSON,
	      data: {
	        username: userObj.username,
	        password: userObj.password
	      }
	    }).then(function (data) {
	      var rtrnData = null;
	
	      if (utils.isNotNull(data) && data.result === "success" && data.data) {
	        rtrnData = data.data;
	      }
	
	      return rtrnData;
	    });
	  };
	
	  UserServices.editProfile = function (userKey, userObj) {
	    return request.put({
	      url: utils.getServiceUrl("/users/" + userKey + "/edit-profile"),
	      cache: false,
	      dataType: request.DATA_TYPES.JSON,
	      contentType: request.CONTENT_TYPES.APPLICATION_FORM_URLENCODED,
	      data: {
	        firstname: userObj.firstName,
	        "current-password": userObj.currentPassword,
	        "new-password": userObj.newPassword
	      }
	    }).then(function (data) {
	      var rtrnData = null;
	
	      if (utils.isNotNull(data) && data.result === "success" && data.data) {
	        rtrnData = data.data;
	      }
	
	      return rtrnData;
	    });
	  };
	})(UserServices);
	
	module.exports = UserServices;

/***/ }),

/***/ 226:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Created by jv on 2019-08-20 (13:34).
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */
	
	
	var _utils = __webpack_require__(3);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _appError = __webpack_require__(51);
	
	var _appError2 = _interopRequireDefault(_appError);
	
	var _default = __webpack_require__(212);
	
	var _default2 = _interopRequireDefault(_default);
	
	var _sector = __webpack_require__(469);
	
	var _sector2 = _interopRequireDefault(_sector);
	
	var _roadMap = __webpack_require__(468);
	
	var _roadMap2 = _interopRequireDefault(_roadMap);
	
	var _powerGrid = __webpack_require__(467);
	
	var _powerGrid2 = _interopRequireDefault(_powerGrid);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var log = __webpack_require__(5)();
	
	var fabric = __webpack_require__(783).fabric;
	
	var BusinessModel = function () {
	  function BusinessModel(options) {
	    _classCallCheck(this, BusinessModel);
	
	    if (_utils2.default.isNull(options)) throw new _appError2.default({ exception: new Error("Options for BusinessModel cannot be null") });
	
	    this.id = options.id || _utils2.default.generateElementId("business-model-canvas-");
	
	    this.containerElement = $(options.containerElement);
	    this.availableCanvasSize = options.availableCanvasSize;
	    this.onCanvasSizeChanged = options.onCanvasSizeChanged;
	
	    this.layoutData = _utils2.default.isNotNull(options.layoutData) ? options.layoutData : _default2.default;
	
	    this.sectorsGroup = null;
	    this.sectors = [];
	
	    this.income = _utils2.default.isNumber(options.income) ? options.income : 0;
	    this.incomeIconGroup = null;
	    this.incomeIconBackground = null;
	    this.incomeIconStroke = null;
	    this.incomeIconText = null;
	
	    this.faqIcons = [];
	    this.faqIconsVisible = _utils2.default.isNotNull(options.faqIconsVisible) ? options.faqIconsVisible : false;
	
	    this.canvasRendered = false;
	    this.onRenderComplete = options.onRenderComplete;
	    this.onFaqClick = options.onFaqClick;
	
	    this.debugGroup = null;
	
	    this.previewRoads = [];
	    this.previewSectors = [];
	    this.previewPowerlines = [];
	
	    this.activeInvestments = [];
	
	    this.shouldAbortAnimations = false;
	  }
	
	  _createClass(BusinessModel, [{
	    key: "render",
	    value: function render() {
	      var _this = this;
	
	      log.info("Rendering business model for layout %o", this.layoutData);
	
	      this.createCanvas();
	
	      this.debugGroup = new fabric.Group([], {
	        hasBorders: false,
	        hasControls: false,
	        selectable: false,
	        evented: false,
	        reference: false,
	        movable: false
	      });
	
	      this.canvas.add(this.debugGroup);
	
	      this.powerGrid = new _powerGrid2.default({
	        businessModel: this,
	        onRenderComplete: function onRenderComplete() {
	          return _this._checkRenderComplete();
	        }
	      });
	
	      this.powerGrid.render();
	
	      this.roadMap = new _roadMap2.default({
	        businessModel: this,
	        onRenderComplete: function onRenderComplete() {
	          return _this._checkRenderComplete();
	        }
	      });
	
	      this.roadMap.render();
	
	      this.sectorsGroup = new fabric.Group([], {
	        hasBorders: false,
	        hasControls: false,
	        selectable: false,
	        evented: false,
	        reference: false,
	        movable: false,
	
	        objectCaching: false
	      });
	
	      this.canvas.add(this.sectorsGroup);
	
	      for (var sectorKey in this.layoutData.sectors) {
	        if (this.layoutData.sectors.hasOwnProperty(sectorKey)) {
	          (function () {
	            _this.layoutData.sectors[sectorKey].key = sectorKey;
	
	            var sector = new _sector2.default({
	              businessModel: _this,
	              sectorData: _this.layoutData.sectors[sectorKey],
	              onRenderComplete: function onRenderComplete() {
	                _this.sectorsGroup.addWithUpdate(sector.sectorGroup);
	
	                _this._checkRenderComplete();
	              }
	            });
	
	            sector.render();
	            _this.sectors.push(sector);
	          })();
	        }
	      }
	
	      this.setUpIncomeIcon();
	
	      this.setUpFaqIcons();
	
	      this.setUpAutoResize();
	    }
	  }, {
	    key: "_checkRenderComplete",
	    value: function _checkRenderComplete() {
	      if (this.hasRendered()) {
	        this.incomeIconGroup.visible = true;
	
	        this.sectorsGroup.addWithUpdate();
	        this.sectorsGroup.setCoords();
	        this.sectorsGroup.bringToFront();
	
	        this.debugGroup.bringToFront();
	
	        this.setUpCanvasLayer();
	
	        this.canvas.renderAll();
	
	        if (_utils2.default.isFunction(this.onRenderComplete)) {
	          this.onRenderComplete.call(this);
	        }
	      }
	    }
	  }, {
	    key: "hasRendered",
	    value: function hasRendered() {
	      var renderCompleted = this.canvasRendered;
	
	      var sectorsRendered = true;
	
	      for (var i = 0; i < this.sectors.length; i++) {
	        sectorsRendered = sectorsRendered && this.sectors[i].hasRendered;
	        if (!sectorsRendered) break;
	      }
	
	      renderCompleted = renderCompleted && sectorsRendered;
	      renderCompleted = renderCompleted && _utils2.default.isNotNull(this.powerGrid) && this.powerGrid.hasRendered();
	      renderCompleted = renderCompleted && _utils2.default.isNotNull(this.roadMap) && this.roadMap.hasRendered();
	
	      return renderCompleted;
	    }
	  }, {
	    key: "createCanvas",
	    value: function createCanvas() {
	      var _this2 = this;
	
	      log.info("Creating canvas for business model [%s]", this.id);
	
	      if (_utils2.default.isNotNull(this.canvasEl)) {
	        this.containerElement[0].removeChild(this.canvasEl);
	        this.canvas = null;
	        this.canvasEl = null;
	      }
	
	      this.canvasEl = document.createElement("canvas");
	      this.canvasEl.id = this.id;
	
	      this.containerElement.append(this.canvasEl);
	
	      this.canvas = new fabric.Canvas(this.id, {
	        backgroundColor: this.layoutData.backgroundColor || "white",
	
	        width: this.layoutData.size.width,
	        height: this.layoutData.size.height,
	
	        imageSmoothingEnabled: false
	      });
	
	      this.canvas.selection = false;
	
	      if (!_utils2.default.isNullOrEmpty(this.layoutData.background)) {
	        this.setUpBackground().then(function () {
	          _this2.canvasRendered = true;
	          _this2._checkRenderComplete();
	        });
	      } else {
	        this.canvasRendered = true;
	      }
	
	      if (false) {
	        this.addGridToCanvas(50);
	      }
	    }
	  }, {
	    key: "setUpBackground",
	    value: function setUpBackground() {
	      var _this3 = this;
	
	      if (!_utils2.default.isNullOrEmpty(this.layoutData.background)) {
	        var options = {
	          top: 0,
	          left: 0,
	
	          evented: false,
	          selectable: false,
	          hasBorders: false,
	          hasControls: false,
	          reference: false
	        };
	
	        if (this.layoutData.background.endsWith("svg")) {
	          return this.loadSvg(this.layoutData.background, options).then(function (fabricObj) {
	            _this3.canvas.add(fabricObj);
	            _this3.canvas.sendToBack(fabricObj);
	
	            fabricObj.scaleToWidth(_this3.canvas.width);
	            fabricObj.setCoords();
	            _this3.canvas.renderAll();
	
	            return fabricObj;
	          }).catch(function (err) {
	            log.error("Failed to load background image - %o", err);
	          });
	        } else {
	          return this.loadImage(this.layoutData.background, options).then(function (fabricObj) {
	            _this3.canvas.add(fabricObj);
	            _this3.canvas.sendToBack(fabricObj);
	
	            fabricObj.scaleToWidth(_this3.canvas.width);
	            fabricObj.setCoords();
	            _this3.canvas.renderAll();
	
	            return fabricObj;
	          }).catch(function (err) {
	            log.error("Failed to load background image - %o", err);
	          });
	        }
	      }
	
	      return null;
	    }
	  }, {
	    key: "setUpIncomeIcon",
	    value: function setUpIncomeIcon() {
	      this.incomeIconBackground = new fabric.Circle({
	        radius: this.layoutData.incomeIcon.radius,
	        fill: this.layoutData.incomeIcon.backgroundColor,
	        left: this.layoutData.incomeIcon.position.x,
	        top: this.layoutData.incomeIcon.position.y,
	        originX: this.layoutData.incomeIcon.position.originX,
	        originY: this.layoutData.incomeIcon.position.originY
	      });
	
	      this.incomeIconBackground.setShadow({
	        color: "rgba(0, 0, 0, 0.3)",
	        blur: 3,
	        offsetX: 0,
	        offsetY: 0
	      });
	
	      this.incomeIconStroke = new fabric.Circle({
	        radius: this.layoutData.incomeIcon.innerStrokeRadius,
	        fill: "transparent",
	        stroke: this.layoutData.incomeIcon.innerStrokeColor,
	        strokeWidth: this.layoutData.incomeIcon.innerStrokeWidth,
	        left: this.layoutData.incomeIcon.position.x,
	        top: this.layoutData.incomeIcon.position.y,
	        originX: this.layoutData.incomeIcon.position.originX,
	        originY: this.layoutData.incomeIcon.position.originY
	      });
	
	      this.incomeIconText = new fabric.Textbox("", {
	        width: this.incomeIconBackground.radius * 2,
	        originX: "center",
	        originY: "center",
	        left: this.layoutData.incomeIcon.position.x,
	        top: this.layoutData.incomeIcon.position.y,
	
	        fontFamily: this.layoutData.incomeIcon.text.fontFamily,
	        fontSize: this.layoutData.incomeIcon.text.fontSize,
	        textAlign: this.layoutData.incomeIcon.text.alignment,
	        stroke: this.layoutData.incomeIcon.text.color
	      });
	
	      this._setIncomeIconText(this.income);
	
	      this.incomeIconGroup = new fabric.Group([this.incomeIconBackground, this.incomeIconStroke, this.incomeIconText], {
	        hasBorders: false,
	        hasControls: false,
	        selectable: false,
	        evented: false,
	        reference: false,
	        movable: false,
	        visible: false
	      });
	
	      this.canvas.add(this.incomeIconGroup);
	
	      this.setIncomeIconTheme(this.incomeIconTheme, false);
	    }
	  }, {
	    key: "setUpFaqIcons",
	    value: function setUpFaqIcons() {
	      for (var i = 0; i < this.layoutData.faqIcons.length; i++) {
	        this.createFaqIcon(this.layoutData.faqIcons[i]);
	      }
	    }
	  }, {
	    key: "createFaqIcon",
	    value: function createFaqIcon(faqIcon) {
	      var _this4 = this;
	
	      faqIcon = _extends({}, faqIcon, this.layoutData.faqSettings); // merging two objects
	
	      var faqIconBackground = new fabric.Circle({
	        radius: faqIcon.radius,
	        fill: faqIcon.backgroundColor,
	        left: faqIcon.position.x,
	        top: faqIcon.position.y,
	        originX: faqIcon.position.originX,
	        originY: faqIcon.position.originY
	      });
	
	      faqIconBackground.setShadow({
	        color: "rgba(0, 0, 0, 0.3)",
	        blur: 3,
	        offsetX: 0,
	        offsetY: 0
	      });
	
	      var faqIconStroke = new fabric.Circle({
	        radius: faqIcon.innerStrokeRadius,
	        fill: "transparent",
	        stroke: faqIcon.innerStrokeColor,
	        strokeWidth: faqIcon.innerStrokeWidth,
	        left: faqIcon.position.x,
	        top: faqIcon.position.y,
	        originX: faqIcon.position.originX,
	        originY: faqIcon.position.originY
	      });
	      faqIconStroke.circonopoly = {};
	      faqIconStroke.circonopoly.id = "stroke";
	      faqIconStroke.circonopoly.markedColor = faqIcon.markedColor;
	
	      var faqIconText = new fabric.Textbox("?", {
	        width: faqIconBackground.radius * 2,
	        originX: "center",
	        originY: "center",
	        left: faqIcon.position.x,
	        top: faqIcon.position.y,
	        // text: "?",
	
	        fontFamily: faqIcon.text.fontFamily,
	        fontSize: faqIcon.text.fontSize,
	        textAlign: faqIcon.text.alignment,
	        stroke: faqIcon.text.color
	      });
	      faqIconText.circonopoly = {};
	      faqIconText.circonopoly.id = "text";
	      faqIconText.circonopoly.markedColor = faqIcon.markedColor;
	
	      var faqIconGroup = new fabric.Group([faqIconBackground, faqIconStroke, faqIconText], {
	        hasBorders: false,
	        hasControls: false,
	        selectable: false,
	        reference: false,
	        movable: false,
	        visible: false,
	        hoverCursor: "pointer"
	      });
	
	      faqIconGroup.circonopoly = {};
	      faqIconGroup.circonopoly.faqType = faqIcon.key;
	
	      this.faqIcons.push(faqIconGroup);
	      this.canvas.add(faqIconGroup);
	
	      faqIconGroup.on("mousedown", function (options) {
	        var faqInfo = {};
	
	        faqInfo.faqType = options.target.circonopoly.faqType;
	
	        var sectorLayoutData = null;
	
	        for (var i = 0; i < _this4.layoutData.faqIcons.length; i++) {
	          if (_this4.layoutData.faqIcons[i].key === options.target.circonopoly.faqType) {
	            sectorLayoutData = _this4.layoutData.faqIcons[i].sector;
	            break;
	          }
	        }
	
	        if (_utils2.default.isNotNull(sectorLayoutData)) {
	          for (var _i = 0; _i < _this4.sectors.length; _i++) {
	            if (_this4.sectors[_i].key === sectorLayoutData.key) {
	              faqInfo.sector = _this4.sectors[_i];
	            }
	          }
	        }
	
	        if (_utils2.default.isFunction(_this4.onFaqClick)) _this4.onFaqClick(faqInfo);
	      });
	    }
	
	    // toggle visibility of FAQ icons
	
	  }, {
	    key: "toggleFaqIcons",
	    value: function toggleFaqIcons() {
	      this.setFaqIconsVisible(!this.faqIconsVisible);
	    }
	  }, {
	    key: "setFaqIconsVisible",
	    value: function setFaqIconsVisible(flag) {
	      if (this.faqIconsVisible === flag) return;
	
	      this.faqIconsVisible = flag;
	
	      for (var i = 0; i < this.faqIcons.length; i++) {
	        var f = this.faqIcons[i];
	        f.visible = this.faqIconsVisible;
	      }
	
	      this.canvas.renderAll();
	    }
	
	    // change color of faq to green (CMS)
	
	  }, {
	    key: "markFaqIcon",
	    value: function markFaqIcon(faqType) {
	      for (var i = 0; i < this.faqIcons.length; i++) {
	        var f = this.faqIcons[i];
	        if (f.circonopoly.faqType === faqType) {
	          for (var j = 0; j < f.getObjects().length; ++j) {
	            var o = f.getObjects()[j];
	            if (!_utils2.default.isNullOrEmpty(o.circonopoly)) {
	              if (o.circonopoly.id === "stroke") {
	                o.set({ stroke: o.circonopoly.markedColor });
	              } else if (o.circonopoly.id === "text") {
	                o.set({ stroke: o.circonopoly.markedColor });
	                o.set({ fill: o.circonopoly.markedColor });
	              }
	            }
	          }
	
	          break;
	        }
	      }
	    }
	  }, {
	    key: "drawDebugInfo",
	    value: function drawDebugInfo(text, position, color) {
	      var offset = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
	
	      if (false) {
	        var debugText = new fabric.Textbox(text, {
	          originX: "center",
	          originY: "center",
	          left: position.x + offset,
	          top: position.y + offset,
	
	          fontFamily: "Rubik",
	          fontSize: 24,
	          textAlign: "center",
	          stroke: color,
	          fill: color
	        });
	
	        this.debugGroup.addWithUpdate(debugText);
	      }
	    }
	  }, {
	    key: "setUpCanvasLayer",
	    value: function setUpCanvasLayer() {
	      this.canvas.bringToFront(this.incomeIconGroup);
	
	      for (var i = 0; i < this.faqIcons.length; i++) {
	        var f = this.faqIcons[i];
	        f.visible = this.faqIconsVisible;
	        f.bringToFront();
	      }
	    }
	  }, {
	    key: "getSectorForKey",
	    value: function getSectorForKey(key) {
	      for (var i = 0; i < this.sectors.length; i++) {
	        var sector = this.sectors[i];
	
	        if (sector.key === key) {
	          return sector;
	        }
	      }
	
	      log.error("Failed to find sector for key [%s]", key);
	
	      return null;
	    }
	  }, {
	    key: "loadSvg",
	    value: function loadSvg(source, svgOptions, fromString) {
	      return new Promise(function (resolve, reject) {
	        function onComplete(objects, options) {
	          if (_utils2.default.isNotNull(svgOptions)) {
	            options = _extends({}, options, svgOptions);
	          }
	
	          var obj = fabric.util.groupSVGElements(objects, options);
	
	          obj.originX = options.originX || "left";
	          obj.originY = options.originY || "top";
	          /*obj.top = options.top;
	          obj.left = options.left;*/
	
	          obj.width = options.width || obj.width;
	          obj.height = options.height || obj.height;
	
	          // obj.evented = that.evented;
	          // obj.setCoords();
	
	          resolve(obj);
	        }
	
	        function addSvgProperties(el, obj) {
	          obj.id = el.getAttribute("id");
	        }
	
	        if (fromString) {
	          fabric.loadSVGFromString(source, onComplete, addSvgProperties);
	        } else {
	          fabric.loadSVGFromURL(source, onComplete, addSvgProperties);
	        }
	      });
	    }
	  }, {
	    key: "loadImage",
	    value: function loadImage(source, options) {
	      return new Promise(function (resolve, reject) {
	        var img = new Image();
	        img.src = "";
	        img.onload = function () {
	          var fabricImage = new fabric.Image(this, options);
	          resolve(fabricImage);
	        };
	        img.onerror = reject;
	        img.src = source;
	      });
	    }
	  }, {
	    key: "_setIncomeIconText",
	    value: function _setIncomeIconText(value) {
	      if (_utils2.default.isNotNull(this.incomeIconText)) {
	        var textValue = value >= 0 ? "+ " + value : "- " + Math.abs(value);
	        this.incomeIconText.set({ text: textValue });
	        this.canvas.renderAll();
	      }
	    }
	  }, {
	    key: "setIncomeIconTheme",
	    value: function setIncomeIconTheme(theme, inverse) {
	      var textColor = this.layoutData.incomeIcon.text.color,
	          backgroundColor = this.layoutData.incomeIcon.backgroundColor,
	          innerStrokeColor = this.layoutData.incomeIcon.innerStrokeColor;
	
	      if (_utils2.default.isNotNull(theme) && this.layoutData.incomeIcon.themes.hasOwnProperty(theme)) {
	        this.incomeIconTheme = theme;
	
	        textColor = _utils2.default.isNotNull(this.layoutData.incomeIcon.themes[theme].text.color) ? this.layoutData.incomeIcon.themes[theme].text.color : textColor;
	        backgroundColor = _utils2.default.isNotNull(this.layoutData.incomeIcon.themes[theme].backgroundColor) ? this.layoutData.incomeIcon.themes[theme].backgroundColor : backgroundColor;
	        innerStrokeColor = _utils2.default.isNotNull(this.layoutData.incomeIcon.themes[theme].innerStrokeColor) ? this.layoutData.incomeIcon.themes[theme].innerStrokeColor : innerStrokeColor;
	      } else {
	        this.incomeIconTheme = "default";
	      }
	
	      if (inverse) {
	        var tmp = innerStrokeColor;
	        textColor = backgroundColor;
	        innerStrokeColor = backgroundColor;
	        backgroundColor = tmp;
	
	        this.incomeIconTheme += "_inverse";
	      }
	
	      this.incomeIconBackground.set({ fill: backgroundColor });
	      this.incomeIconStroke.set({ stroke: innerStrokeColor });
	      this.incomeIconText.set({ fill: textColor, stroke: textColor });
	
	      this.canvas.renderAll();
	    }
	  }, {
	    key: "setCompanyIcon",
	    value: function setCompanyIcon(iconUrl) {
	      return this._setSectorActiveIcon("company", iconUrl);
	    }
	  }, {
	    key: "setCompanyExtraProduct",
	    value: function setCompanyExtraProduct(iconUrl) {
	      return this._setSectorActiveIcon("extra_product", iconUrl);
	    }
	  }, {
	    key: "_setSectorActiveIcon",
	    value: function _setSectorActiveIcon(sectorKey, iconUrl) {
	      var _this5 = this;
	
	      return new Promise(function (resolve, reject) {
	        var sector = _this5.getSectorForKey(sectorKey);
	
	        if (_utils2.default.isNull(sector)) {
	          reject(new _appError2.default({ error: new Error("[" + sector + "] sector not found") }));
	        } else {
	          return sector.setActiveIcon(iconUrl);
	        }
	      });
	    }
	  }, {
	    key: "setUpBeginState",
	    value: function setUpBeginState() {
	      var animationOptions = { instant: true };
	
	      for (var i = 0; i < this.layoutData.startActions.length; i++) {
	        var action = this.layoutData.startActions[i];
	
	        if (_utils2.default.isNull(action.waitOn) || true) // %NOTE: waitOn needed ?
	          {
	            doAction.call(this, action);
	          }
	      }
	
	      function doAction(action) {
	        log.info("Executing begin state action: %o", action);
	
	        if (action.targetType === "road") {
	          this.roadMap.activateRoad(action.target[0].startPoint, action.target[0].intersections, action.target[0].endPoint, animationOptions);
	        } else if (action.targetType === "sector") {
	          // noinspection JSPotentiallyInvalidUsageOfClassThis
	          this.getSectorForKey(action.target).activate(animationOptions);
	        } else if (action.targetType === "power-line") {
	          this.powerGrid.activatePowerLines(action.target);
	        }
	      }
	    }
	  }, {
	    key: "previewInvestment",
	    value: function previewInvestment(investmentType) {
	      var animationOptions = {};
	      animationOptions.instant = true;
	      animationOptions.isPreview = true;
	      animationOptions.roadBackgroundColor = "transparent"; //this.layoutData.roadSettings.roadColor;
	
	      animationOptions.sectorStrokeWidthPreview = 2;
	      animationOptions.sectorBackgroundColorPreview = this.layoutData.sectorSettings.backgroundColor;
	
	      if (_utils2.default.isNotNull(investmentType) && this.layoutData.investmentActions.hasOwnProperty(investmentType)) {
	        var investmentActions = this.layoutData.investmentActions[investmentType].actions;
	        for (var i = 0; i < investmentActions.length; ++i) {
	          doAction.call(this, investmentActions[i]);
	        }
	
	        this.canvas.renderAll();
	      }
	
	      function doAction(action) {
	        if (action.type === "road") {
	          animationOptions.roadDividerWidth = this.layoutData.roadSettings.dividerWidth * 2;
	
	          if (!action.active) {
	            animationOptions.roadDividerColor = this.layoutData.roadSettings.dividerColorPreviewInactive;
	          } else {
	            // animationOptions.roadBackgroundColor = "#ffffff";
	            animationOptions.roadDividerColor = this.layoutData.roadSettings.dividerColorPreviewActive;
	          }
	
	          this.previewRoads.push(this.roadMap.previewRoad(action.data.startPoint, action.data.intersections, action.data.endPoint, animationOptions));
	        } else if (action.type === "sector") {
	          if (!action.active) {
	            animationOptions.sectorStrokeColorPreview = this.layoutData.sectorSettings.strokeColorPreviewInactive;
	          } else {
	            animationOptions.sectorStrokeColorPreview = this.layoutData.sectorSettings.strokeColorPreviewActive;
	          }
	
	          // noinspection JSPotentiallyInvalidUsageOfClassThis
	          this.previewSectors.push(this.getSectorForKey(action.data.name).preview(animationOptions, true));
	        } else if (action.type === "power-line") {
	          var color = this.layoutData.powerGridSettings.strokeColorPreviewActive;
	          if (!action.active) {
	            color = this.layoutData.powerGridSettings.strokeColorPreviewInactive;
	          }
	
	          this.previewPowerlines.push(this.powerGrid.previewPowerlines(action.data, color));
	        }
	      }
	    }
	  }, {
	    key: "removePreview",
	    value: function removePreview() {
	      var _this6 = this;
	
	      this.roadMap.previewGroup.getObjects().forEach(function (object, key) {
	        _this6.roadMap.previewGroup.remove(object);
	      });
	
	      for (var i = 0; i < this.previewSectors.length; i++) {
	        var s = this.previewSectors[i];
	        s.hidePreview();
	      }
	
	      this.previewPowerlines.forEach(function (object, key) {
	        object.set({ stroke: _this6.layoutData.powerGridSettings.strokeColor });
	      });
	
	      if (this.incomeIconTheme !== "default") {
	        this.setIncomeIconTheme();
	      }
	
	      this.canvas.renderAll();
	
	      this.previewRoads = [];
	      this.previewSectors = [];
	      this.previewPowerlines = [];
	    }
	  }, {
	    key: "applyInvestment",
	    value: function applyInvestment(investmentType, animationOptions) {
	      this.shouldAbortAnimations = false;
	
	      if (!this.activeInvestments.includes(investmentType)) {
	        this.activeInvestments.push(investmentType);
	        return this._applyInvestment(investmentType, animationOptions);
	      }
	    }
	  }, {
	    key: "_applyInvestment",
	    value: function _applyInvestment(investmentType, animationOptions) {
	      var doAnimation = function () {
	        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(context, investmentActions) {
	          var i, action, shouldWait, sectorAnimationOptions;
	          return regeneratorRuntime.wrap(function _callee$(_context) {
	            while (1) {
	              switch (_context.prev = _context.next) {
	                case 0:
	                  i = 0;
	
	                case 1:
	                  if (!(i < investmentActions.length)) {
	                    _context.next = 60;
	                    break;
	                  }
	
	                  if (!context.shouldAbortAnimations) {
	                    _context.next = 4;
	                    break;
	                  }
	
	                  return _context.abrupt("return");
	
	                case 4:
	                  action = investmentActions[i];
	                  shouldWait = action.wait && !(_utils2.default.isNotNull(animationOptions) && animationOptions.instant);
	
	                  // Note: if something gets added to animation options inside another method then you should copy the object and assign the new value to the copy!
	                  //     eg: animationOptions = Object.assign({}, animationOptions, { instant: true });
	
	                  // if(!utils.isNullOrEmpty(action.requirement)) continue; // %NOTE: wordt hierbuiten afgechecked
	
	                  if (!(action.type === "icon" && action.active)) {
	                    _context.next = 10;
	                    break;
	                  }
	
	                  context.getSectorForKey(action.data.name).setActiveIcon(action.data.source);
	                  _context.next = 57;
	                  break;
	
	                case 10:
	                  if (!(action.type === "text" && action.active)) {
	                    _context.next = 14;
	                    break;
	                  }
	
	                  context.getSectorForKey(action.data.name).setText(action.data.value);
	                  _context.next = 57;
	                  break;
	
	                case 14:
	                  if (!(action.type === "power-line" && action.active)) {
	                    _context.next = 18;
	                    break;
	                  }
	
	                  context.powerGrid.activatePowerLines(action.data);
	                  _context.next = 57;
	                  break;
	
	                case 18:
	                  if (!(action.type === "power-line" && !action.active)) {
	                    _context.next = 22;
	                    break;
	                  }
	
	                  context.powerGrid.deactivatePowerLines(action.data);
	                  _context.next = 57;
	                  break;
	
	                case 22:
	                  if (!(action.type === "road" && action.active)) {
	                    _context.next = 31;
	                    break;
	                  }
	
	                  if (!shouldWait) {
	                    _context.next = 28;
	                    break;
	                  }
	
	                  _context.next = 26;
	                  return context.roadMap.activateRoad(action.data.startPoint, action.data.intersections, action.data.endPoint, animationOptions);
	
	                case 26:
	                  _context.next = 29;
	                  break;
	
	                case 28:
	                  context.roadMap.activateRoad(action.data.startPoint, action.data.intersections, action.data.endPoint, animationOptions);
	
	                case 29:
	                  _context.next = 57;
	                  break;
	
	                case 31:
	                  if (!(action.type === "road" && !action.active)) {
	                    _context.next = 40;
	                    break;
	                  }
	
	                  if (!shouldWait) {
	                    _context.next = 37;
	                    break;
	                  }
	
	                  _context.next = 35;
	                  return context.roadMap.deactivateRoad(action.data.startPoint, action.data.intersections, action.data.endPoint, animationOptions);
	
	                case 35:
	                  _context.next = 38;
	                  break;
	
	                case 37:
	                  context.roadMap.deactivateRoad(action.data.startPoint, action.data.intersections, action.data.endPoint, animationOptions);
	
	                case 38:
	                  _context.next = 57;
	                  break;
	
	                case 40:
	                  if (!(action.type === "sector" && action.active)) {
	                    _context.next = 50;
	                    break;
	                  }
	
	                  // Don't animate sector activation --> always instant
	                  sectorAnimationOptions = Object.assign({}, animationOptions, { instant: true });
	
	                  if (!shouldWait) {
	                    _context.next = 47;
	                    break;
	                  }
	
	                  _context.next = 45;
	                  return context.getSectorForKey(action.data.name).activate(sectorAnimationOptions);
	
	                case 45:
	                  _context.next = 48;
	                  break;
	
	                case 47:
	                  context.getSectorForKey(action.data.name).activate(sectorAnimationOptions);
	
	                case 48:
	                  _context.next = 57;
	                  break;
	
	                case 50:
	                  if (!(action.type === "sector" && !action.active)) {
	                    _context.next = 57;
	                    break;
	                  }
	
	                  if (!shouldWait) {
	                    _context.next = 56;
	                    break;
	                  }
	
	                  _context.next = 54;
	                  return context.getSectorForKey(action.data.name).deactivate(animationOptions);
	
	                case 54:
	                  _context.next = 57;
	                  break;
	
	                case 56:
	                  context.getSectorForKey(action.data.name).deactivate(animationOptions);
	
	                case 57:
	                  i++;
	                  _context.next = 1;
	                  break;
	
	                case 60:
	                case "end":
	                  return _context.stop();
	              }
	            }
	          }, _callee, this);
	        }));
	
	        return function doAnimation(_x2, _x3) {
	          return _ref.apply(this, arguments);
	        };
	      }();
	
	      if (this.shouldAbortAnimations) return;
	
	      if (_utils2.default.isNotNull(investmentType) && this.layoutData.investmentActions.hasOwnProperty(investmentType)) {
	        var investmentActions = this.layoutData.investmentActions[investmentType].actions;
	
	        return doAnimation(this, investmentActions);
	      }
	    }
	  }, {
	    key: "setInvestments",
	    value: function setInvestments(investments) {
	      // Starts from scratch (and also reapplies the begin state)
	      this.reset();
	      this.setUpBeginState();
	      this.updateInvestments(investments, {
	        instant: true
	      });
	      // this.updateInvestments(investments, null);
	    }
	  }, {
	    key: "removeAllInvestments",
	    value: function removeAllInvestments(animationOptions) {
	      this.roadMap.deactivateAllRoads(animationOptions);
	      this.powerGrid.deactivateAllPowerLines(animationOptions);
	
	      for (var i = 0; i < this.sectors.length; i++) {
	        this.sectors[i].deactivate(animationOptions);
	      }
	
	      this.canvas.renderAll();
	
	      this.activeInvestments = [];
	    }
	  }, {
	    key: "updateInvestments",
	    value: function updateInvestments(investments, animationOptions) {
	      this.shouldAbortAnimations = false;
	
	      // Adds to the current business model (!== setInvestments which first clears the current business model)
	      if (_utils2.default.isNull(investments)) return;
	
	      log.info("Updating business model investments:\nCurrent active investments: %o\nUpdate: %o", this.activeInvestments, investments);
	
	      for (var i = 0; i < investments.length; i++) {
	        if (_utils2.default.isNotNull(investments[i]) && !this.shouldAbortAnimations) {
	          this.applyInvestment(investments[i], animationOptions);
	        }
	      }
	    }
	  }, {
	    key: "reset",
	    value: function reset() {
	      this.removePreview();
	      this.setFaqIconsVisible(false);
	
	      this.abortAnimations();
	      this.removeAllInvestments({
	        instant: true
	      });
	    }
	  }, {
	    key: "abortAnimations",
	    value: function abortAnimations() {
	      this.shouldAbortAnimations = true;
	
	      this.powerGrid.abortAnimations();
	      this.roadMap.abortAnimations();
	
	      for (var i = 0; i < this.sectors.length; i++) {
	        this.sectors[i].abortAnimations();
	      }
	    }
	  }, {
	    key: "addGridToCanvas",
	    value: function addGridToCanvas(gridSize) {
	      var width = this.canvas.width,
	          height = this.canvas.height;
	
	      var gridGroup = [];
	
	      for (var i = 0; i < width / gridSize; i++) {
	        var x = i * gridSize;
	
	        gridGroup.push(new fabric.Line([x, 0, x, height], { stroke: "#ccc" }));
	
	        gridGroup.push(new fabric.Text(x + "", {
	          left: x,
	          top: 0,
	          textAlign: "center",
	          fontSize: 10,
	          fontFamily: "Helvetica Nue, Helvetica, Sans-Serif, Arial, Trebuchet MS"
	        }));
	      }
	
	      for (var _i2 = 0; _i2 < height / gridSize; _i2++) {
	        var y = _i2 * gridSize;
	
	        gridGroup.push(new fabric.Line([0, y, width, y], { stroke: "#ccc" }));
	
	        gridGroup.push(new fabric.Text(y + "", {
	          left: 0,
	          top: y,
	          textAlign: "center",
	          fontSize: 10,
	          fontFamily: "Helvetica Nue, Helvetica, Sans-Serif, Arial, Trebuchet MS"
	        }));
	      }
	
	      this.canvas.add(new fabric.Group(gridGroup, {
	        hasBorders: false,
	        hasControls: false,
	        selectable: false,
	        evented: false,
	        reference: false,
	        movable: false
	      }));
	    }
	  }, {
	    key: "destroy",
	    value: function destroy() {
	      this.canvas.clear();
	      this.canvas.dispose();
	      this.canvas = null;
	    }
	  }, {
	    key: "setUpAutoResize",
	    value: function setUpAutoResize() {
	      this.fitToContainer();
	
	      var resizeFunction = _utils2.default.debounce(this.fitToContainer, 250, false, this);
	      window.addEventListener("resize", resizeFunction, false);
	    }
	  }, {
	    key: "fitToContainer",
	    value: function fitToContainer(e) {
	      // Note: using fabric canvas zoom causes blurriness for some reason, manually resize canvas doesn't (not sure if this breaks something else though)
	      // Note²: using `imageSmoothingEnabled: false` has an even better result (event with the fabricjs zooming)
	      // Best to worst quality (sharpness):
	      //    1. imageSmoothingEnabled: false with fabricjs zooming
	      //    2. imageSmoothingEnabled: false with manual canvas scaling
	      //    3. imageSmoothingEnabled: true (default) with manual canvas scaling
	      //    4. imageSmoothingEnabled: true (default) with fabricjs zooming
	      var $window = $(window);
	      // let containerWidth = Math.min(this.layoutData.size.width, this.containerElement.width());
	      // let windowHeight = Math.min(this.layoutData.size.height, $window.height());
	      var containerWidth = Math.min(this.layoutData.size.width * 1.5, this.containerElement.width());
	      var windowHeight = Math.min(this.layoutData.size.height * 1.5, this.containerElement.height());
	
	      if (_utils2.default.isFunction(this.availableCanvasSize)) {
	        var availableSize = this.availableCanvasSize(this);
	        containerWidth = _utils2.default.isNotNull(availableSize.width) ? availableSize.width : containerWidth;
	        windowHeight = _utils2.default.isNotNull(availableSize.height) ? availableSize.height : windowHeight;
	      }
	
	      var scaleRatio = Math.min(containerWidth / this.layoutData.size.width, windowHeight / this.layoutData.size.height);
	
	      log.debug("Resizing canvas to fit container:\nWidth: %f\nHeight: %f\nScale: %f", this.containerElement.width(), this.containerElement.height(), scaleRatio);
	
	      if (scaleRatio > 0) {
	        var oldWidth = this.canvas.width,
	            oldHeight = this.canvas.height;
	
	        var newWidth = this.layoutData.size.width * scaleRatio,
	            newHeight = this.layoutData.size.height * scaleRatio;
	
	        this.canvas.setDimensions({ width: newWidth, height: newHeight });
	        this.canvas.setZoom(scaleRatio);
	
	        if (_utils2.default.isFunction(this.onCanvasSizeChanged)) {
	          this.onCanvasSizeChanged(oldWidth, oldHeight, newWidth, newHeight);
	        }
	      }
	
	      // let initialWidth = this.layoutData.size.width;
	      // let initialHeight = this.layoutData.size.height;
	      //
	      // let $container = this.containerElement;
	      //
	      // let containerElement = this.containerElement.find(".canvas-container");
	      //
	      // resizeCanvas($container.find("canvas").get(0));
	      // resizeCanvas($container.find("canvas").get(1));
	      //
	      // function resizeCanvas(canvas)
	      // {
	      //   let newWidth = null;
	      //   let newHeight = null;
	      //
	      //   let $window = $(window);
	      //   let windowWidth = $window.width(),
	      //     windowHeight = $window.height(),
	      //     windowRatio = windowWidth / windowHeight;
	      //
	      //   let width = Math.min($container.width(), initialWidth);
	      //   let height = initialHeight / initialWidth * width;
	      //
	      //   let wratio = width / height;
	      //   let ratio = initialWidth / initialHeight;
	      //
	      //   if(windowRatio < wratio)
	      //   {
	      //     newWidth = width;
	      //     newHeight = width / ratio;
	      //   }
	      //   else
	      //   {
	      //     height = Math.max(windowHeight, initialHeight);
	      //     width = initialWidth / initialHeight * height;
	      //
	      //     newWidth = width;
	      //     newHeight = height;
	      //   }
	      //
	      //   if(newWidth !== null && newHeight !== null)
	      //   {
	      //     canvas.style.width = newWidth + "px";
	      //     canvas.style.height = newHeight + "px";
	      //
	      //     containerElement.css("width", newWidth + "px");
	      //     containerElement.css("height", newHeight + "px");
	      //   }
	      // }
	    }
	  }, {
	    key: "income",
	    set: function set(value) {
	      if (!_utils2.default.isNumber(value)) {
	        value = parseInt(value);
	        value = _utils2.default.isNumber(value) ? value : 0;
	      }
	
	      this._income = value;
	
	      this._setIncomeIconText(this.income);
	    },
	    get: function get() {
	      return this._income;
	    }
	  }]);
	
	  return BusinessModel;
	}();
	
	exports.default = BusinessModel;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),

/***/ 227:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Created by jv on 2019-09-19 (12:14).
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */
	
	
	var _utils = __webpack_require__(3);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _moment = __webpack_require__(2);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _constants = __webpack_require__(54);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var GameSessionMessage = function () {
	  function GameSessionMessage(options) {
	    _classCallCheck(this, GameSessionMessage);
	
	    this.id = options.id || _utils2.default.UUID();
	
	    this.type = options.type || "request";
	    this.service = options.service;
	    this.error = options.error;
	
	    this.data = options.data;
	
	    this.params = options.params;
	  }
	
	  _createClass(GameSessionMessage, [{
	    key: "serialize",
	    value: function serialize() {
	      var data = {
	        id: this.id,
	
	        type: this.type,
	        service: this.service,
	        error: this.error,
	
	        data: this.data,
	
	        params: this.params,
	
	        sent: _moment2.default.utc().format(_constants2.default.API_DATE_FORMAT)
	      };
	
	      return _utils2.default.stringifyJSON(data);
	    }
	  }], [{
	    key: "createRequest",
	    value: function createRequest(serviceName, params, data) {
	      return new GameSessionMessage({
	        service: serviceName,
	        params: params,
	        data: data
	      });
	    }
	  }, {
	    key: "createResponse",
	    value: function createResponse(serviceName, params, data) {
	      return new GameSessionMessage({
	        type: "response",
	        service: serviceName,
	        params: params,
	        data: data
	      });
	    }
	  }, {
	    key: "createErrorMessage",
	    value: function createErrorMessage(errorCode, params, data) {
	      return new GameSessionMessage({
	        type: "error",
	        error: errorCode,
	        params: params,
	        data: data
	      });
	    }
	  }]);
	
	  return GameSessionMessage;
	}();
	
	exports.default = GameSessionMessage;

/***/ }),

/***/ 291:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _utils = __webpack_require__(3);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _constants = __webpack_require__(54);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	var _languageManager = __webpack_require__(6);
	
	var _languageManager2 = _interopRequireDefault(_languageManager);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Created by jv on 2019-10-01 (16:40).
	 */
	var log = __webpack_require__(5)();
	
	
	__webpack_require__(740);
	
	var TEST_MODE = (false) && false;
	
	var ScoreScreen = function () {
	  function ScoreScreen(options) {
	    _classCallCheck(this, ScoreScreen);
	
	    this.id = _utils2.default.generateElementId("score-screen-");
	
	    this.$container = $(options.container);
	
	    this.title = options.title;
	
	    this.mode = options.mode ? options.mode : "business-model";
	    this.isFinal = options.isFinal;
	
	    this.team = options.team;
	    this.teams = options.teams;
	
	    if (TEST_MODE) this.teams = ["Team1", "Team2", "Team3", "Team4", "Team5", "Team6", "Team7 op 2 lijnen", "Team8", "Team9", "Team10"];
	
	    this.roundOverview = options.roundOverview;
	    this.roundIndex = options.roundIndex;
	
	    this.hideAnimationTimeout = null;
	
	    this._stacked = false;
	
	    this._interactive = options.interactive;
	    this.callbackContext = options.callbackContext;
	    this.onTeamScoreClick = options.onTeamScoreClick;
	  }
	
	  _createClass(ScoreScreen, [{
	    key: "showWaitingIndicators",
	    value: function showWaitingIndicators() {
	      if (_utils2.default.isNotNull(this.$element) && this.$element.length) {
	        this.$element.removeClass("scs__waiting-disabled");
	      }
	    }
	  }, {
	    key: "hideWaitingIndicators",
	    value: function hideWaitingIndicators() {
	      if (_utils2.default.isNotNull(this.$element) && this.$element.length) {
	        this.$element.addClass("scs__waiting-disabled");
	      }
	    }
	  }, {
	    key: "updateTeamList",
	    value: function updateTeamList(teamList) {
	      this.teams = teamList;
	
	      if (this.hasRendered) {
	        this.render();
	        this.update();
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      if (_utils2.default.isNotNull(this.$element) && this.$element.length) this.destroy();
	
	      this.hasRendered = false;
	
	      this.$element = $("<div class='score-screen'></div>");
	      this.$element.addClass("scs-mode__" + this.mode);
	
	      if (this.interactive) {
	        this.$element.addClass("scs__interactive");
	      }
	
	      if (this.teams.length > 8) {
	        this.$element.addClass("scs__small");
	      }
	
	      if (this.stacked) {
	        this.$element.addClass("scs__stacked");
	      }
	
	      var $title = $("<h4 class='scs__title'></h4>");
	
	      if (_utils2.default.isNotNull(this.title)) {
	        $title.text(this.title);
	      } else {
	        $title.hide();
	      }
	
	      this.$element.append($title);
	
	      var $teamsWrapper = $("<div class='score-screen__teams'></div>");
	
	      var $teamScoresWrapper = $("<div class='scs__team-scores'></div>");
	      var $teamLabelsWrapper = $("<div class='scs__team-labels'></div>");
	
	      // Sort teams by name
	      this.teams.sort(function (t1, t2) {
	        return t1.localeCompare(t2);
	      });
	
	      for (var i = 0; i < this.teams.length; i++) {
	        var team = this.teams[i];
	
	        var $scoreEntry = $("<div class='score-screen__team-score'></div>");
	        $scoreEntry.attr("data-team-name", team);
	
	        if (_utils2.default.isNotNull(this.team) && this.team.name === team) {
	          $scoreEntry.addClass("scs__active");
	        }
	
	        var $scoreBarWrapper = $("<div class='score-screen__bar-wrapper'></div>");
	        var $scoreBar = $("<div class='score-screen__bar'></div>");
	        $scoreBar.append("<div class='score-data score-data__points'>0</div>");
	        $scoreBar.append("<div class='score-data score-data__budget'>0</div>");
	        $scoreBar.append("<div class='score-data score-data__has-loaned' style='display: none;'></div>");
	
	        $scoreBarWrapper.append("<div class='score-screen__position'></div>");
	        $scoreBarWrapper.append($scoreBar);
	        $scoreEntry.append($scoreBarWrapper);
	
	        var $teamLabel = $("<div class='score-screen__team-label'></div>");
	        $teamLabel.attr("data-team-name", team);
	
	        if (_utils2.default.isNotNull(this.team) && this.team.name === team) {
	          $teamLabel.addClass("scs__active");
	        }
	
	        $teamLabel.append("<div class='score-screen__team-name'>" + team + "</div>");
	
	        $teamLabel.append("<div class=\"score-screen__waiting-indicator\">" + _languageManager2.default.getValueForKey("serious_game.business_model.score_screen.waiting.indicator") + "</div>");
	
	        var $quizResult = $("<div class='score-screen__quiz-result'></div>");
	        if (this.mode !== "quiz") $quizResult.hide();
	        $teamLabel.append($quizResult);
	
	        $teamLabel.append("<button class=\"btn btn-link scs-team-interact-btn\" type=\"button\">" + _languageManager2.default.getValueForKey("serious_game.business_model.score_screen.interact_btn") + "</button>");
	
	        $teamScoresWrapper.append($scoreEntry);
	        $teamLabelsWrapper.append($teamLabel);
	      }
	
	      $teamsWrapper.append($teamScoresWrapper);
	      $teamsWrapper.append($teamLabelsWrapper);
	
	      this.$element.append($teamsWrapper);
	
	      this.$container.append(this.$element);
	
	      this.setUpEventListeners();
	
	      this.hasRendered = true;
	    }
	  }, {
	    key: "show",
	    value: function show(darkMode) {
	      if (_utils2.default.isNotNull(this.$element) && this.$element.length) {
	        if (_utils2.default.isNotNull(this.hideAnimationTimeout)) {
	          clearTimeout(this.hideAnimationTimeout);
	          this.hideAnimationTimeout = null;
	        }
	
	        if (_utils2.default.isNotNull(this.elementObserver)) {
	          this.elementObserver.observe(this.$element.get(0), { attributes: true, childList: false, subtree: false });
	        }
	
	        if (darkMode) this.$element.addClass("scs__dark-mode");else this.$element.removeClass("scs__dark-mode");
	
	        this.$element.addClass("scs__visible");
	        this.$container.show();
	        this.update();
	
	        if (TEST_MODE) tmpDoTest.call(this);
	      }
	    }
	  }, {
	    key: "hide",
	    value: function hide() {
	      var _this = this;
	
	      if (_utils2.default.isNotNull(this.$container) && this.$container.length) {
	        if (_utils2.default.isNotNull(this.hideAnimationTimeout)) {
	          clearTimeout(this.hideAnimationTimeout);
	          this.hideAnimationTimeout = null;
	        }
	
	        if (_utils2.default.isNotNull(this.elementObserver)) {
	          this.elementObserver.disconnect();
	        }
	
	        this.$element.removeClass("scs__visible");
	
	        this.hideAnimationTimeout = setTimeout(function () {
	          _this.hideAnimationTimeout = null;
	          _this.$container.hide();
	        }, _constants2.default.BM_TRANSITION_SPEED);
	      }
	    }
	  }, {
	    key: "isOpen",
	    value: function isOpen() {
	      return _utils2.default.isNotNull(this.$element) && this.$element.length && this.$element.hasClass("scs__visible");
	    }
	  }, {
	    key: "update",
	    value: function update() {
	      var that = this;
	      this.$element.find(".score-screen__team-score").removeClass("scs__active scs__waiting");
	      this.$element.find(".score-screen__team-label").removeClass("scs__active scs__waiting");
	
	      var scoreInfo = this.getScoreInfo();
	
	      if (_utils2.default.isNotNull(scoreInfo)) {
	        for (var i = 0; i < this.teams.length; i++) {
	          var $scoreEntry = this.$element.find(".score-screen__team-score[data-team-name='" + this.teams[i] + "']");
	          var $teamLabel = this.$element.find(".score-screen__team-label[data-team-name='" + this.teams[i] + "']");
	
	          that.updateTeamScore($scoreEntry, $teamLabel, scoreInfo);
	        }
	      }
	    }
	  }, {
	    key: "updateTeamScore",
	    value: function updateTeamScore($scoreEntry, $teamLabel, scoreInfo) {
	      var teamName = $scoreEntry.data("team-name") + "";
	      var teamData = this.getCommonDataForTeam(teamName);
	
	      if (_utils2.default.isNotNull(teamData)) {
	        var hasClosedRound = _utils2.default.isNotNull(teamData.state.currentRoundClosed) || this.roundIndex < teamData.state.currentRound;
	        var roundScore = this.getCurrentRoundScore(teamData);
	
	        if (this.mode === "quiz" && _utils2.default.isNull(teamData.quizResult) || _utils2.default.isNull(roundScore)) {
	          log.error("Invalid score data for team [%s] - %o", teamData.teamName, teamData);
	          return;
	        }
	
	        if (_utils2.default.isNotNull(this.team) && this.team.name === teamName) {
	          $scoreEntry.addClass("scs__active");
	          $teamLabel.addClass("scs__active");
	        }
	
	        $scoreEntry.data("closed-round", hasClosedRound);
	        $teamLabel.data("closed-round", hasClosedRound);
	
	        if (!hasClosedRound) {
	          $scoreEntry.addClass("scs__waiting");
	          $teamLabel.addClass("scs__waiting");
	        }
	
	        var $barWrapper = $scoreEntry.find(".score-screen__bar-wrapper");
	        var $position = $scoreEntry.find(".score-screen__position");
	
	        var $bar = $scoreEntry.find(".score-screen__bar");
	        var $points = $bar.find(".score-data__points");
	        var $budget = $bar.find(".score-data__budget");
	        var $hasLoaned = $bar.find(".score-data__has-loaned");
	
	        var $quizScore = $teamLabel.find(".score-screen__quiz-result");
	
	        $hasLoaned.hide();
	
	        if (this.mode === "quiz") {
	          $position.text("#" + scoreInfo.teamPositions[teamName]).hide();
	          $points.hide();
	          $budget.text(teamData.quizResult.startBudget).show();
	          $quizScore.text(teamData.quizResult.quizScore + "/" + scoreInfo.highestScore).show();
	
	          if (this.stacked) {
	            var width = ScoreScreen.getBarWidth($barWrapper, $bar, $position, teamData.quizResult.quizScore, scoreInfo.lowestScore, scoreInfo.highestScore);
	            $bar.css("width", width);
	          } else {
	            var height = ScoreScreen.getBarHeight($barWrapper, $bar, $position, teamData.quizResult.quizScore, scoreInfo.lowestScore, scoreInfo.highestScore);
	            $bar.css("height", height);
	          }
	        } else {
	          $position.text("#" + scoreInfo.teamPositions[teamName]).show();
	
	          if (this.isFinal) {
	            $points.text(roundScore.totalScore).show();
	            $budget.text(roundScore.endBudget - roundScore.convertedBudget).show();
	          } else {
	            $points.text(roundScore.endPoints).show();
	            $budget.text(roundScore.endBudget).show();
	          }
	
	          $quizScore.hide();
	
	          if (teamData.totalLoaned > 0) {
	            $hasLoaned.show();
	          }
	
	          if (this.stacked) {
	            var _width = ScoreScreen.getBarWidth($barWrapper, $bar, $position, roundScore.totalScore, scoreInfo.lowestScore, scoreInfo.highestScore);
	            $bar.css("width", _width);
	          } else {
	            var _height = ScoreScreen.getBarHeight($barWrapper, $bar, $position, roundScore.totalScore, scoreInfo.lowestScore, scoreInfo.highestScore);
	            $bar.css("height", _height);
	          }
	        }
	      } else {
	        log.error("Unable to find teamData for team [%s]", teamName);
	      }
	    }
	  }, {
	    key: "getCommonDataForTeam",
	    value: function getCommonDataForTeam(teamName) {
	      if (_utils2.default.isNull(this.roundOverview) || _utils2.default.isNull(this.roundOverview.commonTeamData)) return null;
	
	      for (var i = 0; i < this.roundOverview.commonTeamData.length; i++) {
	        var teamData = this.roundOverview.commonTeamData[i];
	
	        if (teamData.teamName === teamName) {
	          return teamData;
	        }
	      }
	
	      return null;
	    }
	  }, {
	    key: "getCurrentRoundScore",
	    value: function getCurrentRoundScore(teamData) {
	      if (_utils2.default.isNull(teamData) || _utils2.default.isNull(teamData.roundScores)) return null;
	
	      var roundScore = null;
	
	      for (var j = teamData.roundScores.length - 1; j >= 0; j--) {
	        if ((_utils2.default.isNull(this.roundIndex) || teamData.roundScores[j].round === this.roundIndex) && teamData.state.currentRound >= teamData.roundScores[j].round) {
	          roundScore = teamData.roundScores[j];
	          break;
	        }
	      }
	
	      return roundScore;
	    }
	  }, {
	    key: "getScoreInfo",
	    value: function getScoreInfo() {
	      var _this2 = this;
	
	      if (_utils2.default.isNull(this.roundOverview) || _utils2.default.isNull(this.roundOverview.commonTeamData)) return null;
	
	      var lowestScore = null;
	      var highestScore = 0;
	
	      var scores = [];
	
	      var positionMap = {};
	      var teamPositions = {};
	      var allTeamsFinished = true;
	
	      for (var i = 0; i < this.roundOverview.commonTeamData.length; i++) {
	        var teamData = this.roundOverview.commonTeamData[i];
	        var roundScore = this.getCurrentRoundScore(teamData);
	
	        if (_utils2.default.isNull(teamData.state.currentRoundClosed)) {
	          allTeamsFinished = false;
	        }
	
	        if (_utils2.default.isNotNull(roundScore)) {
	          (function () {
	            // If quiz --> use # questions answered correctly instead of points score
	            var teamScore = _this2.mode === "quiz" ? teamData.quizResult.quizScore : roundScore.totalScore;
	            var score = scores.find(function (s) {
	              return s.score === teamScore;
	            });
	
	            if (_utils2.default.isNull(score)) {
	              score = {
	                score: teamScore,
	                teams: []
	              };
	
	              scores.push(score);
	            }
	
	            score.teams.push(teamData.teamName);
	          })();
	        }
	      }
	
	      // Sort scores descending
	      scores.sort(function (s1, s2) {
	        return s2.score - s1.score;
	      });
	
	      var currentPosition = 1;
	
	      for (var _i = 0; _i < scores.length; _i++) {
	        if (scores[_i].score > highestScore) {
	          highestScore = scores[_i].score;
	        } else if (_utils2.default.isNull(lowestScore) || scores[_i].score < lowestScore) {
	          lowestScore = scores[_i].score;
	        }
	
	        if (_i > 0) currentPosition += scores[_i - 1].teams.length;
	        positionMap[currentPosition] = scores[_i].teams;
	
	        for (var j = 0; j < scores[_i].teams.length; j++) {
	          if (!teamPositions.hasOwnProperty(scores[_i].teams[j])) {
	            teamPositions[scores[_i].teams[j]] = currentPosition;
	          }
	        }
	      }
	
	      var scoreInfo = {
	        positionMap: positionMap,
	        teamPositions: teamPositions,
	        highestScore: this.mode === "quiz" ? 5 : highestScore,
	        lowestScore: this.mode === "quiz" ? 0 : lowestScore,
	        allTeamsFinished: allTeamsFinished
	      };
	
	      log.debug("Score info - %o", scoreInfo);
	
	      return scoreInfo;
	    }
	  }, {
	    key: "destroy",
	    value: function destroy() {
	      this.$element.remove();
	    }
	  }, {
	    key: "setUpEventListeners",
	    value: function setUpEventListeners() {
	      var _this3 = this;
	
	      this.$element.find(".scs-team-interact-btn").off("click").on("click", function (e) {
	        if (_this3.interactive) {
	          var $this = $(e.delegateTarget);
	          var $teamScore = $this.closest(".score-screen__team-label");
	
	          var teamName = $teamScore.data("team-name");
	          var closedRound = $teamScore.data("closed-round");
	
	          teamName = _utils2.default.isNotNull(teamName) ? teamName + "" : teamName;
	
	          if (closedRound) {
	            if (_utils2.default.isFunction(_this3.onTeamScoreClick)) {
	              _this3.onTeamScoreClick.call(_this3.callbackContext, e, teamName);
	            }
	          }
	        }
	      });
	
	      var onResize = _utils2.default.debounce(this.reflow.bind(this), 250, false, this);
	      window.addEventListener("resize", onResize, false);
	
	      if (_utils2.default.isNotNull(window.MutationObserver)) {
	        this.elementObserver = new MutationObserver(function (mutationsList, observer) {
	          var _iteratorNormalCompletion = true;
	          var _didIteratorError = false;
	          var _iteratorError = undefined;
	
	          try {
	            for (var _iterator = mutationsList[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	              var mutation = _step.value;
	
	              if (mutation.type === "attributes" && mutation.attributeName === "class") {
	                _this3.stacked = _this3.$element.hasClass("scs__stacked");
	              }
	            }
	          } catch (err) {
	            _didIteratorError = true;
	            _iteratorError = err;
	          } finally {
	            try {
	              if (!_iteratorNormalCompletion && _iterator.return) {
	                _iterator.return();
	              }
	            } finally {
	              if (_didIteratorError) {
	                throw _iteratorError;
	              }
	            }
	          }
	        });
	      }
	    }
	  }, {
	    key: "reflow",
	    value: function reflow() {
	      this.$element.find(".score-screen__bar").each(function (index, el) {
	        $(el).css("width", "");
	        $(el).css("height", "");
	      });
	
	      this.update();
	    }
	  }, {
	    key: "roundOverview",
	    get: function get() {
	      return this._roundOverview;
	    },
	    set: function set(roundOverview) {
	      this._roundOverview = roundOverview;
	      if (TEST_MODE) tmpDuplicateTeamData.call(this);
	    }
	  }, {
	    key: "title",
	    get: function get() {
	      return this._title;
	    },
	    set: function set(title) {
	      this._title = title;
	
	      if (_utils2.default.isNotNull(this.$element) && this.$element.length) {
	        var $title = this.$element.find(".scs__title");
	
	        if (_utils2.default.isNotNull(this.title)) {
	          $title.text(this.title).show();
	        } else {
	          $title.hide();
	        }
	      }
	    }
	  }, {
	    key: "interactive",
	    get: function get() {
	      return this._interactive;
	    },
	    set: function set(interactive) {
	      this._interactive = interactive;
	
	      if (_utils2.default.isNotNull(this.$element) && this.$element.length) {
	        if (this.interactive) {
	          this.$element.addClass("scs__interactive");
	        } else {
	          this.$element.removeClass("scs__interactive");
	        }
	      }
	    }
	  }, {
	    key: "mode",
	    get: function get() {
	      return this._mode;
	    },
	    set: function set(mode) {
	      this._mode = mode;
	      if (_utils2.default.isNotNull(this.$element) && this.$element.length) {
	        this.$element.removeClass(function (index, className) {
	          return (className.match(/(^|\s)scs-mode__\S+/g) || []).join(" ");
	        });
	        this.$element.addClass("scs-mode__" + this.mode);
	      }
	    }
	  }, {
	    key: "stacked",
	    get: function get() {
	      return this._stacked;
	    },
	    set: function set(stacked) {
	      if (this.stacked !== stacked) {
	        this._stacked = stacked;
	
	        if (this.stacked) this.$element.addClass("scs__stacked");else this.$element.removeClass("scs__stacked");
	
	        this.update();
	      }
	    }
	  }], [{
	    key: "getBarHeight",
	    value: function getBarHeight($barWrapper, $bar, $position, totalScore, lowestScore, highestScore) {
	      var minBarHeight = _utils2.default.parseFloat($bar.css("minHeight"));
	      minBarHeight = _utils2.default.isNotNull(minBarHeight) ? minBarHeight : 0;
	      var maxBarHeight = $barWrapper.height() - $position.outerHeight(true) - minBarHeight;
	
	      // Normalized to [0-1]
	      var heightPercentage = (totalScore - lowestScore) / (highestScore - lowestScore);
	      var barHeight = maxBarHeight * heightPercentage + minBarHeight;
	
	      // log.info("Calculating bar height\nMax height: %f\nMin bar height: %f\nPercentage: %f/%f (%f%) --> %fpx", maxBarHeight, minBarHeight, totalScore, highestScore, Math.round(heightPercentage * 10000) / 100, barHeight);
	
	      return barHeight;
	    }
	  }, {
	    key: "getBarWidth",
	    value: function getBarWidth($barWrapper, $bar, $position, totalScore, lowestScore, highestScore) {
	      var minBarWidth = _utils2.default.parseFloat($bar.css("minWidth"));
	      minBarWidth = _utils2.default.isNotNull(minBarWidth) ? minBarWidth : 0;
	      var maxBarWidth = $barWrapper.width() - $position.outerWidth(true) - minBarWidth;
	
	      // Normalized to [0-1]
	      var widthPercentage = (totalScore - lowestScore) / (highestScore - lowestScore);
	      var barWidth = maxBarWidth * widthPercentage + minBarWidth;
	
	      // log.info("Calculating bar height\nMax height: %f\nMin bar height: %f\nPercentage: %f/%f (%f%) --> %fpx", maxBarHeight, minBarHeight, totalScore, highestScore, Math.round(heightPercentage * 10000) / 100, barHeight);
	
	      return barWidth;
	    }
	  }]);
	
	  return ScoreScreen;
	}();
	
	var tmpDuplicateTeamData = void 0;
	var tmpDoTest = void 0;
	
	if (false) {
	  tmpDuplicateTeamData = function tmpDuplicateTeamData() {
	    if (_utils2.default.isNull(this.roundOverview)) return;
	
	    for (var i = 1; i < this.teams.length; i++) {
	      var exists = false;
	
	      for (var j = 0; j < this.roundOverview.commonTeamData.length; j++) {
	        if (this.roundOverview.commonTeamData[j].teamName === this.teams[i]) {
	          exists = true;
	          break;
	        }
	      }
	
	      if (exists) continue;
	
	      var tmp = JSON.parse(JSON.stringify(this.roundOverview.commonTeamData[0]));
	      tmp.teamName = this.teams[i];
	
	      var rs = tmp.roundScores[tmp.roundScores.length - 2];
	      rs.endPoints = _utils2.default.getRandomIntInclusive(4, 12);
	      rs.endBudget += _utils2.default.getRandomIntInclusive(-2, 6);
	
	      tmp.roundScores.pop();
	
	      rs.totalScore = rs.endPoints + (rs.endBudget > 0 ? Math.floor(rs.endBudget) : 0);
	
	      tmp.state.currentRoundClosed = null;
	
	      this.roundOverview.commonTeamData.push(tmp);
	    }
	  };
	
	  tmpDoTest = function tmpDoTest() {
	    var _this4 = this;
	
	    if (_utils2.default.isNull(this.roundOverview)) return;
	
	    var _loop = function _loop(i) {
	      setTimeout(function () {
	        var teamData = _this4.roundOverview.commonTeamData[i];
	        teamData.state.currentRoundClosed = "2019-10-04T08:02:11.000+0000";
	        var rs = JSON.parse(JSON.stringify(teamData.roundScores[teamData.roundScores.length - 1]));
	
	        rs.round += 1;
	        rs.endPoints += _utils2.default.getRandomIntInclusive(2, 6);
	        rs.endBudget += _utils2.default.getRandomIntInclusive(-3, 3);
	        rs.totalScore = rs.endPoints + (rs.endBudget > 0 ? Math.floor(rs.endBudget / 3) : 0);
	
	        teamData.roundScores.push(rs);
	
	        teamData.totalLoaned = _utils2.default.getRandomIntInclusive(0, 10) > 7 ? _utils2.default.getRandomIntInclusive(1, 5) : 0;
	
	        _this4.update();
	      }, _utils2.default.getRandomIntInclusive(2500, 3000) * i);
	    };
	
	    for (var i = 2; i < this.roundOverview.commonTeamData.length; i++) {
	      _loop(i);
	    }
	  };
	}
	
	exports.default = ScoreScreen;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),

/***/ 292:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _utils = __webpack_require__(3);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _client = __webpack_require__(498);
	
	var _client2 = _interopRequireDefault(_client);
	
	var _gameSessionMessage = __webpack_require__(227);
	
	var _gameSessionMessage2 = _interopRequireDefault(_gameSessionMessage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Created by jv on 2019-09-11 (10:14).
	 */
	var log = __webpack_require__(5)();
	
	var GameSessionController = function () {
	  function GameSessionController(options) {
	    _classCallCheck(this, GameSessionController);
	
	    this.baseUrl = options.baseUrl;
	    if (_utils2.default.isNotNull(this.baseUrl) && this.baseUrl.endsWith("/")) this.baseUrl = this.baseUrl.substring(0, this.baseUrl.length - 1);
	
	    this.sessionId = options.sessionId;
	    this.asTeacher = options.asTeacher === true;
	    this.teamName = options.teamName;
	
	    this.onOpenListeners = [];
	    this.onCloseListeners = [];
	    this.onErrorListeners = [];
	    this.onMessageListeners = [];
	  }
	
	  _createClass(GameSessionController, [{
	    key: "init",
	    value: function init() {
	      var _this = this;
	
	      if (this.asTeacher) {
	        this.url = this.baseUrl + "/" + this.sessionId + "?as-teacher=true";
	      } else {
	        this.url = this.baseUrl + "/" + this.sessionId + "?team-name=" + encodeURIComponent(this.teamName);
	      }
	
	      this.client = new _client2.default({
	        url: this.url,
	        onOpen: function onOpen(event) {
	          return _this._onSessionOpened(event);
	        },
	        onClose: function onClose(event) {
	          return _this._onSessionClosed(event);
	        },
	        onError: function onError(event) {
	          return _this._onSessionError(event);
	        },
	        onMessage: function onMessage(event) {
	          return _this._onSessionMessage(event);
	        }
	      });
	    }
	  }, {
	    key: "_onSessionOpened",
	    value: function _onSessionOpened(event) {
	      log.cssLog("Successfully established socket connection - %o", event, log.successCss);
	
	      for (var i = 0; i < this.onOpenListeners.length; i++) {
	        this.onOpenListeners[i].call(this, event);
	      }
	    }
	  }, {
	    key: "_onSessionClosed",
	    value: function _onSessionClosed(event) {
	      log.cssLog("Socket connection was closed - %o", event, log.warningCss);
	
	      for (var i = 0; i < this.onCloseListeners.length; i++) {
	        this.onCloseListeners[i].call(this, event);
	      }
	    }
	  }, {
	    key: "_onSessionError",
	    value: function _onSessionError(event) {
	      log.cssLog("An error occurred on the socket connection - %o", event, log.errorCss);
	
	      for (var i = 0; i < this.onErrorListeners.length; i++) {
	        this.onErrorListeners[i].call(this, event);
	      }
	    }
	  }, {
	    key: "_onSessionMessage",
	    value: function _onSessionMessage(event) {
	      for (var i = 0; i < this.onMessageListeners.length; i++) {
	        this.onMessageListeners[i].call(this, event);
	      }
	    }
	  }, {
	    key: "connect",
	    value: function connect() {
	      if (_utils2.default.isNotNull(this.client)) {
	        this.client.open();
	      }
	    }
	  }, {
	    key: "disconnect",
	    value: function disconnect() {
	      if (_utils2.default.isNotNull(this.client)) {
	        this.client.close();
	      }
	    }
	  }, {
	    key: "sendMessage",
	    value: function sendMessage(message) {
	      if (_utils2.default.isNotNull(this.client)) {
	        var gameSessionMessage = void 0;
	
	        if (message instanceof _gameSessionMessage2.default) {
	          gameSessionMessage = message;
	        } else {
	          gameSessionMessage = new _gameSessionMessage2.default({
	            data: message
	          });
	        }
	
	        var serializedData = gameSessionMessage.serialize();
	
	        log.info("Sending message to server: %o\nSerialized: %s", gameSessionMessage, serializedData);
	
	        this.client.sendData(serializedData);
	      }
	    }
	  }, {
	    key: "addEventListener",
	    value: function addEventListener(type, func) {
	      if (_utils2.default.isNull(type) || !_utils2.default.isFunction(func)) return;
	
	      switch (type) {
	        case "session-opened":
	          this.onOpenListeners.push(func);
	          break;
	        case "session-closed":
	          this.onCloseListeners.push(func);
	          break;
	        case "session-error":
	          this.onErrorListeners.push(func);
	          break;
	        case "session-message":
	          this.onMessageListeners.push(func);
	          break;
	      }
	    }
	  }]);
	
	  return GameSessionController;
	}();
	
	exports.default = GameSessionController;

/***/ }),

/***/ 293:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var utils = __webpack_require__(3);
	var request = __webpack_require__(186);
	
	var CaseServices = {};
	
	(function (CaseServices) {
	  CaseServices.logout = function () {
	    return request.get({
	      url: "/logout",
	      cache: false
	    });
	  };
	
	  CaseServices.getPublishedCases = function () {
	    return CaseServices.getCases(true);
	  };
	
	  CaseServices.getCases = function (onlyPublished) {
	    var serviceUrl = utils.getServiceUrl("/cases");
	
	    if (onlyPublished) serviceUrl += "?only-published=true";
	
	    return request.get({
	      url: serviceUrl,
	      cache: false,
	      dataType: request.DATA_TYPES.JSON,
	      contentType: request.CONTENT_TYPES.APPLICATION_JSON
	    }).then(function (data) {
	      var cases = null;
	
	      if (utils.isNotNull(data) && data.result === "success" && utils.isNotNull(data.data)) {
	        cases = data.data;
	      }
	
	      return cases;
	    });
	  };
	
	  CaseServices.getCase = function (key) {
	    return request.get({
	      url: utils.getServiceUrl("/cases/" + key),
	      cache: false,
	      dataType: request.DATA_TYPES.JSON,
	      contentType: request.CONTENT_TYPES.APPLICATION_JSON
	    }).then(function (data) {
	      var caze = null;
	
	      if (utils.isNotNull(data) && data.result === "success" && utils.isNotNull(data.data)) {
	        caze = data.data;
	      }
	
	      return caze;
	    });
	  };
	
	  CaseServices.createCase = function (name, base) {
	    return request.post({
	      url: utils.getServiceUrl("/cases/create"),
	      cache: false,
	      dataType: request.DATA_TYPES.JSON,
	      contentType: request.CONTENT_TYPES.APPLICATION_FORM_URLENCODED,
	      data: {
	        name: name,
	        base: base
	      }
	    }).then(function (data) {
	      var rtrnData = null;
	
	      if (utils.isNotNull(data) && data.result === "success" && data.data) {
	        rtrnData = data.data;
	      }
	
	      return rtrnData;
	    });
	  };
	
	  CaseServices.updateCase = function (key, name, movie, startBudget, quizBonus, published) {
	    return request.post({
	      url: utils.getServiceUrl("/cases/" + key),
	      cache: false,
	      dataType: request.DATA_TYPES.JSON,
	      contentType: request.CONTENT_TYPES.APPLICATION_JSON,
	      data: {
	        key: key,
	        name: name,
	        movie: movie,
	        startBudget: startBudget,
	        quizBonus: quizBonus,
	        published: published,
	        editable: true // %NOTE: klopt misschien niet helemaal in het uitzonderlijke geval dat een case nog open staat in de cms, maar achterliggend editable:false werd gezet.
	      }
	    }).then(function (data) {
	      var rtrnData = null;
	
	      if (utils.isNotNull(data) && data.result === "success" && data.data) {
	        rtrnData = data.data;
	      }
	
	      return rtrnData;
	    });
	  };
	
	  CaseServices.publishCase = function (key) {
	    return request.put({
	      url: utils.getServiceUrl("/cases/" + key + "/publish"),
	      cache: false,
	      dataType: request.DATA_TYPES.JSON,
	      contentType: request.CONTENT_TYPES.APPLICATION_JSON
	    });
	  };
	
	  CaseServices.unPublishCase = function (key) {
	    return request.put({
	      url: utils.getServiceUrl("/cases/" + key + "/unpublish"),
	      cache: false,
	      dataType: request.DATA_TYPES.JSON,
	      contentType: request.CONTENT_TYPES.APPLICATION_JSON
	    });
	  };
	
	  CaseServices.deleteCase = function (key) {
	    return request.delete({
	      url: utils.getServiceUrl("/cases/" + key),
	      cache: false
	    }).then(function (data) {
	      var rtrnData = null;
	
	      if (utils.isNotNull(data) && data.result === "success" && data.data) {
	        rtrnData = data.data;
	      }
	
	      return rtrnData;
	    });
	  };
	
	  CaseServices.getCaseQuestions = function (key) {
	    return request.get({
	      url: utils.getServiceUrl("/cases/" + key + "/questions"),
	      cache: false,
	      dataType: request.DATA_TYPES.JSON,
	      contentType: request.CONTENT_TYPES.APPLICATION_JSON
	    }).then(function (data) {
	      var questions = null;
	
	      if (utils.isNotNull(data) && data.result === "success" && utils.isNotNull(data.data)) {
	        questions = data.data;
	      }
	
	      return questions;
	    });
	  };
	
	  CaseServices.updateCaseQuestion = function (casekey, key, question, correctimage, correcttext, wrongimage, wrongtext, index) {
	    return request.post({
	      url: utils.getServiceUrl("/cases/" + casekey + "/questions/" + key),
	      cache: false,
	      dataType: request.DATA_TYPES.JSON,
	      contentType: request.CONTENT_TYPES.APPLICATION_JSON,
	      data: {
	        key: key,
	        caseKey: casekey,
	        question: question,
	        correctimage: correctimage,
	        correcttext: correcttext,
	        wrongimage: wrongimage,
	        wrongtext: wrongtext,
	        index: index
	      }
	    }).then(function (data) {
	      var rtrnData = null;
	
	      if (utils.isNotNull(data) && data.result === "success" && data.data) {
	        rtrnData = data.data;
	      }
	
	      return rtrnData;
	    });
	  };
	
	  CaseServices.getCaseIcons = function (key) {
	    return request.get({
	      url: utils.getServiceUrl("/cases/" + key + "/icons"),
	      cache: false,
	      dataType: request.DATA_TYPES.JSON,
	      contentType: request.CONTENT_TYPES.APPLICATION_JSON
	    }).then(function (data) {
	      var questions = null;
	
	      if (utils.isNotNull(data) && data.result === "success" && utils.isNotNull(data.data)) {
	        questions = data.data;
	      }
	
	      return questions;
	    });
	  };
	
	  CaseServices.updateCaseIcon = function (casekey, key, type, value) {
	    return request.post({
	      url: utils.getServiceUrl("/cases/" + casekey + "/icons/" + key),
	      cache: false,
	      dataType: request.DATA_TYPES.JSON,
	      contentType: request.CONTENT_TYPES.APPLICATION_JSON,
	      data: {
	        key: key,
	        caseKey: casekey,
	        type: type,
	        value: value
	      }
	    }).then(function (data) {
	      var rtrnData = null;
	
	      if (utils.isNotNull(data) && data.result === "success" && data.data) {
	        rtrnData = data.data;
	      }
	
	      return rtrnData;
	    });
	  };
	
	  CaseServices.updateCaseIcons = function (casekey, iconList) {
	    return request.post({
	      url: utils.getServiceUrl("/cases/" + casekey + "/icons/"),
	      cache: false,
	      dataType: request.DATA_TYPES.JSON,
	      contentType: request.CONTENT_TYPES.APPLICATION_JSON,
	      data: utils.stringifyJSON(iconList)
	    }).then(function (data) {
	      var rtrnData = null;
	
	      if (utils.isNotNull(data) && data.result === "success" && data.data) {
	        rtrnData = data.data;
	      }
	
	      return rtrnData;
	    });
	  };
	
	  CaseServices.getCaseInvestments = function (key) {
	    return request.get({
	      url: utils.getServiceUrl("/cases/" + key + "/investments"),
	      cache: false,
	      dataType: request.DATA_TYPES.JSON,
	      contentType: request.CONTENT_TYPES.APPLICATION_JSON
	    }).then(function (data) {
	      var investments = null;
	
	      if (utils.isNotNull(data) && data.result === "success" && utils.isNotNull(data.data)) {
	        investments = data.data;
	      }
	
	      return investments;
	    });
	  };
	
	  CaseServices.updateCaseInvestment = function (casekey, key, type, category, title, summary, description, cost, redesignNeeded, points, income) {
	    return request.post({
	      url: utils.getServiceUrl("/cases/" + casekey + "/investments/" + key),
	      cache: false,
	      dataType: request.DATA_TYPES.JSON,
	      contentType: request.CONTENT_TYPES.APPLICATION_JSON,
	      data: {
	        key: key,
	        caseKey: casekey,
	        type: type,
	        category: category,
	        title: title,
	        summary: summary,
	        description: description,
	        cost: cost,
	        redesignNeeded: redesignNeeded,
	        points: points,
	        income: income
	      }
	    }).then(function (data) {
	      var rtrnData = null;
	
	      if (utils.isNotNull(data) && data.result === "success" && data.data) {
	        rtrnData = data.data;
	      }
	
	      return rtrnData;
	    });
	  };
	
	  CaseServices.getInvestmentExamples = function (caseKey, investmentKey) {
	    return request.get({
	      url: utils.getServiceUrl("/cases/" + caseKey + "/investments/" + investmentKey + "/examples"),
	      cache: false,
	      dataType: request.DATA_TYPES.JSON,
	      contentType: request.CONTENT_TYPES.APPLICATION_JSON
	    }).then(function (data) {
	      var examples = null;
	
	      if (utils.isNotNull(data) && data.result === "success" && utils.isNotNull(data.data)) {
	        examples = data.data;
	      }
	
	      return examples;
	    });
	  };
	
	  CaseServices.updateCaseInvestementExamples = function (caseKey, investmentKey, exampleList) {
	    return request.post({
	      url: utils.getServiceUrl("/cases/" + caseKey + "/investments/" + investmentKey + "/examples"),
	      cache: false,
	      dataType: request.DATA_TYPES.JSON,
	      contentType: request.CONTENT_TYPES.APPLICATION_JSON,
	      data: utils.stringifyJSON(exampleList)
	    }).then(function (data) {
	      var examples = null;
	
	      if (utils.isNotNull(data) && data.result === "success" && utils.isNotNull(data.data)) {
	        examples = data.data;
	      }
	
	      return examples;
	    });
	  };
	
	  CaseServices.getCaseEvents = function (key) {
	    return request.get({
	      url: utils.getServiceUrl("/cases/" + key + "/events"),
	      cache: false,
	      dataType: request.DATA_TYPES.JSON,
	      contentType: request.CONTENT_TYPES.APPLICATION_JSON
	    }).then(function (data) {
	      var events = null;
	
	      if (utils.isNotNull(data) && data.result === "success" && utils.isNotNull(data.data)) {
	        events = data.data;
	      }
	
	      return events;
	    });
	  };
	
	  CaseServices.updateCaseEvent = function (caseKey, key, type, title, eventData) {
	    return request.post({
	      url: utils.getServiceUrl("/cases/" + caseKey + "/events/" + key),
	      cache: false,
	      dataType: request.DATA_TYPES.JSON,
	      contentType: request.CONTENT_TYPES.APPLICATION_JSON,
	      data: {
	        key: key,
	        caseKey: caseKey,
	        type: type,
	        title: title,
	        data: JSON.stringify(eventData)
	      }
	    }).then(function (data) {
	      var rtrnData = null;
	
	      if (utils.isNotNull(data) && data.result === "success" && data.data) {
	        rtrnData = data.data;
	      }
	
	      return rtrnData;
	    });
	  };
	
	  CaseServices.getCaseFaqs = function (key) {
	    return request.get({
	      url: utils.getServiceUrl("/cases/" + key + "/faqs"),
	      cache: false,
	      dataType: request.DATA_TYPES.JSON,
	      contentType: request.CONTENT_TYPES.APPLICATION_JSON
	    }).then(function (data) {
	      var faqs = null;
	
	      if (utils.isNotNull(data) && data.result === "success" && utils.isNotNull(data.data)) {
	        faqs = data.data;
	      }
	
	      return faqs;
	    });
	  };
	
	  CaseServices.updateCaseFaq = function (caseKey, key, investmentKey, type, description) {
	    return request.post({
	      url: utils.getServiceUrl("/cases/" + caseKey + "/faqs/" + key),
	      cache: false,
	      dataType: request.DATA_TYPES.JSON,
	      contentType: request.CONTENT_TYPES.APPLICATION_JSON,
	      data: {
	        key: key,
	        caseKey: caseKey,
	        investmentKey: investmentKey,
	        type: type,
	        description: description
	      }
	    }).then(function (data) {
	      var rtrnData = null;
	
	      if (utils.isNotNull(data) && data.result === "success" && data.data) {
	        rtrnData = data.data;
	      }
	
	      return rtrnData;
	    });
	  };
	})(CaseServices);
	
	module.exports = CaseServices;

/***/ }),

/***/ 342:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utils = __webpack_require__(3);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _constants = __webpack_require__(54);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	var _appError = __webpack_require__(51);
	
	var _appError2 = _interopRequireDefault(_appError);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var log = __webpack_require__(5)(); /**
	                                              * Created by jv on 2019-08-22 (11:36).
	                                              */
	
	
	var RoadUtils = {};
	
	(function (RoadUtils) {
	  RoadUtils.pathToPoints = function (pathString, samples, samplePercentage) {
	    var path = document.createElementNS("http://www.w3.org/2000/svg", "path");
	    path.setAttribute("d", pathString);
	
	    var points = [];
	    var len = path.getTotalLength();
	
	    if (_utils2.default.isNull(samples) && _utils2.default.isNotNull(samplePercentage)) {
	      samples = len * samplePercentage;
	    }
	
	    var step = len / samples;
	
	    for (var i = 0; i <= len; i += step) {
	      var p = path.getPointAtLength(i);
	      points.push({ x: p.x, y: p.y });
	    }
	
	    return points;
	  };
	
	  RoadUtils.getPathStringForNavigation = function (startPosition, navigations, endPosition, innerWidth, outerWidth) {
	    /*
	      Path commands (https://developer.mozilla.org/en-US/docs/Web/SVG/Tutorial/Paths):
	      M = move to
	      L = line to
	        H = draw horizontal line (shorthand for horizontal only L, only 1 parameter)
	        V = draw vertical line (shorthand for vertical only L, only 1 parameter)
	      C = cubic curve (2 control points, 1 end point)
	      Q = quadratic curve (1 control point, 1 end point)
	     */
	
	    var pathString = "M " + startPosition.x + " " + startPosition.y;
	    var currentPosition = { x: startPosition.x, y: startPosition.y };
	
	    var curveBuffer = outerWidth / 2;
	
	    for (var j = 0; j < navigations.length; j++) {
	      var navigation = navigations[j];
	      var nextNavigation = j < navigations.length - 1 ? navigations[j + 1] : null;
	
	      if (_utils2.default.isNull(nextNavigation)) {
	        nextNavigation = {
	          // x: endPosition.x - currentPosition.x,
	          // y: endPosition.y - currentPosition.y
	          x: endPosition.x,
	          y: endPosition.y,
	          type: "absolute"
	        };
	      }
	
	      var directionInfo = RoadUtils.getNavigationDirection(currentPosition, navigation, nextNavigation);
	
	      if (navigation.type === "absolute") {
	        currentPosition.x = navigation.x ? navigation.x : currentPosition.x;
	        currentPosition.y = navigation.y ? navigation.y : currentPosition.y;
	      } else {
	        currentPosition.x += navigation.x;
	        currentPosition.y += navigation.y;
	      }
	
	      // log.debug("DirectionInfo: %o\nCurrentPosition: %o", directionInfo, currentPosition);
	
	      if (_utils2.default.isNotNull(directionInfo)) {
	        if (directionInfo.currentDirection === _constants2.default.DIRECTIONS.LEFT || directionInfo.currentDirection === _constants2.default.DIRECTIONS.RIGHT) // Horizontal
	          {
	            if (directionInfo.currentDirection === _constants2.default.DIRECTIONS.LEFT) {
	              pathString += " H " + (currentPosition.x + curveBuffer);
	              // currentPosition.x += curveBuffer;
	            } else {
	              pathString += " H " + (currentPosition.x - curveBuffer);
	              // currentPosition.x -= curveBuffer;
	            }
	
	            if (directionInfo.nextDirection === _constants2.default.DIRECTIONS.UP) {
	              pathString += " Q " + currentPosition.x + " " + currentPosition.y + " " + currentPosition.x + " " + (currentPosition.y - curveBuffer);
	              // currentPosition.y -= curveBuffer;
	            } else if (directionInfo.nextDirection === _constants2.default.DIRECTIONS.DOWN) {
	              pathString += " Q " + currentPosition.x + " " + currentPosition.y + " " + currentPosition.x + " " + (currentPosition.y + curveBuffer);
	              // currentPosition.y += curveBuffer;
	            }
	          } else if (directionInfo.currentDirection === _constants2.default.DIRECTIONS.UP || directionInfo.currentDirection === _constants2.default.DIRECTIONS.DOWN) // Vertical
	          {
	            if (directionInfo.currentDirection === _constants2.default.DIRECTIONS.UP) {
	              pathString += " V " + (currentPosition.y + curveBuffer);
	              // currentPosition.y += curveBuffer;
	            } else {
	              pathString += " V " + (currentPosition.y - curveBuffer);
	              // currentPosition.y -= curveBuffer;
	            }
	
	            if (directionInfo.nextDirection === _constants2.default.DIRECTIONS.LEFT) {
	              pathString += " Q " + currentPosition.x + " " + currentPosition.y + " " + (currentPosition.x - curveBuffer) + " " + currentPosition.y;
	              // currentPosition.x -= curveBuffer;
	            } else if (directionInfo.nextDirection === _constants2.default.DIRECTIONS.RIGHT) {
	              pathString += " Q " + currentPosition.x + " " + currentPosition.y + " " + (currentPosition.x + curveBuffer) + " " + currentPosition.y;
	              // currentPosition.x += curveBuffer;
	            }
	          }
	      } else // diagonal (currently not supported)
	        {
	          log.error("Unexpected road layout");
	        }
	    }
	
	    pathString += " L " + endPosition.x + " " + endPosition.y;
	
	    return pathString;
	  };
	
	  RoadUtils.getPathStringForNavigationOutline = function (startPosition, navigations, endPosition, outerWidth, strokeSide) {
	    // left = if direction is DOWN, the left outline. This stays the same road for the other directions (eg. 180° flipped the direction is UP but the road is now the right outline)
	    strokeSide = _utils2.default.isNullOrEmpty(strokeSide) ? "left" : strokeSide;
	    var curveBuffer = outerWidth / 2;
	
	    var currentNavigation = _utils2.default.isNotNull(navigations) && navigations.length > 0 ? navigations[0] : null;
	
	    if (_utils2.default.isNull(currentNavigation)) {
	      currentNavigation = {
	        x: endPosition.x,
	        y: endPosition.y,
	        type: "absolute"
	      };
	    }
	
	    var directionInfo = RoadUtils.getNavigationDirection(startPosition, currentNavigation, null);
	
	    var pathString = "";
	    var currentPosition = { x: startPosition.x, y: startPosition.y };
	
	    if (directionInfo.currentDirection === _constants2.default.DIRECTIONS.UP) {
	      if (strokeSide === "left") {
	        pathString = "M " + (startPosition.x + curveBuffer) + " " + startPosition.y;
	      } else {
	        pathString = "M " + (startPosition.x - curveBuffer) + " " + startPosition.y;
	      }
	    } else if (directionInfo.currentDirection === _constants2.default.DIRECTIONS.RIGHT) {
	      if (strokeSide === "left") {
	        pathString = "M " + startPosition.x + " " + (startPosition.y + curveBuffer);
	      } else {
	        pathString = "M " + startPosition.x + " " + (startPosition.y - curveBuffer);
	      }
	    } else if (directionInfo.currentDirection === _constants2.default.DIRECTIONS.DOWN) {
	      if (strokeSide === "left") {
	        pathString = "M " + (startPosition.x - curveBuffer) + " " + startPosition.y;
	      } else {
	        pathString = "M " + (startPosition.x + curveBuffer) + " " + startPosition.y;
	      }
	    } else if (directionInfo.currentDirection === _constants2.default.DIRECTIONS.LEFT) {
	      if (strokeSide === "left") {
	        pathString = "M " + startPosition.x + " " + (startPosition.y - curveBuffer);
	      } else {
	        pathString = "M " + startPosition.x + " " + (startPosition.y + curveBuffer);
	      }
	    }
	
	    for (var j = 0; j < navigations.length; j++) {
	      var navigation = navigations[j];
	      var nextNavigation = j < navigations.length - 1 ? navigations[j + 1] : null;
	
	      if (_utils2.default.isNull(nextNavigation)) {
	        nextNavigation = {
	          x: endPosition.x,
	          y: endPosition.y,
	          type: "absolute"
	        };
	      }
	
	      var _directionInfo = RoadUtils.getNavigationDirection(currentPosition, navigation, nextNavigation);
	
	      if (navigation.type === "absolute") {
	        currentPosition.x = navigation.x ? navigation.x : currentPosition.x;
	        currentPosition.y = navigation.y ? navigation.y : currentPosition.y;
	      } else {
	        currentPosition.x += navigation.x;
	        currentPosition.y += navigation.y;
	      }
	
	      // log.debug("DirectionInfo: %o\nCurrentPosition: %o", directionInfo, currentPosition);
	
	      if (_utils2.default.isNotNull(_directionInfo)) {
	        if (_directionInfo.currentDirection === _constants2.default.DIRECTIONS.LEFT || _directionInfo.currentDirection === _constants2.default.DIRECTIONS.RIGHT) // Horizontal
	          {
	            if (_directionInfo.currentDirection === _constants2.default.DIRECTIONS.LEFT) {
	              if (_directionInfo.nextDirection === _constants2.default.DIRECTIONS.UP) {
	                if (strokeSide === "left") // short side
	                  {
	                    pathString += " H " + (currentPosition.x + curveBuffer);
	                    pathString += " Q " + (currentPosition.x + curveBuffer) + " " + (currentPosition.y - curveBuffer) + " " + (currentPosition.x + curveBuffer) + " " + (currentPosition.y - curveBuffer);
	                  } else // long side
	                  {
	                    pathString += " H " + currentPosition.x;
	                    pathString += " Q " + (currentPosition.x - curveBuffer) + " " + (currentPosition.y + curveBuffer) + " " + currentPosition.x + " " + currentPosition.y;
	                  }
	              } else {
	                if (strokeSide === "left") // long side
	                  {
	                    pathString += " H " + currentPosition.x;
	                    pathString += " Q " + (currentPosition.x - curveBuffer) + " " + (currentPosition.y - curveBuffer) + " " + (currentPosition.x + curveBuffer) + " " + currentPosition.y;
	                  } else // short side
	                  {
	                    pathString += " H " + (currentPosition.x + curveBuffer);
	                    pathString += " Q " + (currentPosition.x + curveBuffer) + " " + (currentPosition.y + curveBuffer) + " " + (currentPosition.x + curveBuffer) + " " + (currentPosition.y + curveBuffer);
	                  }
	              }
	            } else {
	              if (_directionInfo.nextDirection === _constants2.default.DIRECTIONS.UP) {
	                if (strokeSide === "left") // long side
	                  {
	                    pathString += " H " + currentPosition.x;
	                    pathString += " Q " + (currentPosition.x + curveBuffer) + " " + (currentPosition.y + curveBuffer) + " " + (currentPosition.x + curveBuffer) + " " + currentPosition.y;
	                  } else // short side
	                  {
	                    pathString += " H " + (currentPosition.x - curveBuffer);
	                    pathString += " Q " + (currentPosition.x - curveBuffer) + " " + (currentPosition.y - curveBuffer) + " " + (currentPosition.x - curveBuffer) + " " + (currentPosition.y - curveBuffer);
	                  }
	              } else {
	                if (strokeSide === "left") // short side
	                  {
	                    pathString += " H " + (currentPosition.x - curveBuffer);
	                    pathString += " Q " + (currentPosition.x - curveBuffer) + " " + (currentPosition.y + curveBuffer) + " " + (currentPosition.x - curveBuffer) + " " + (currentPosition.y + curveBuffer);
	                  } else // long side
	                  {
	                    pathString += " H " + currentPosition.x;
	                    pathString += " Q " + (currentPosition.x + curveBuffer) + " " + (currentPosition.y - curveBuffer) + " " + (currentPosition.x + curveBuffer) + " " + currentPosition.y;
	                  }
	              }
	            }
	          } else if (_directionInfo.currentDirection === _constants2.default.DIRECTIONS.UP || _directionInfo.currentDirection === _constants2.default.DIRECTIONS.DOWN) // Vertical
	          {
	            if (_directionInfo.currentDirection === _constants2.default.DIRECTIONS.UP) {
	              if (_directionInfo.nextDirection === _constants2.default.DIRECTIONS.LEFT) {
	                if (strokeSide === "left") // long side
	                  {
	                    pathString += " V " + currentPosition.y;
	                    pathString += " Q " + (currentPosition.x + curveBuffer) + " " + (currentPosition.y - curveBuffer) + " " + currentPosition.x + " " + (currentPosition.y - curveBuffer);
	                  } else // short side
	                  {
	                    pathString += " V " + (currentPosition.y + curveBuffer);
	                    pathString += " Q " + (currentPosition.x - curveBuffer) + " " + (currentPosition.y + curveBuffer) + " " + (currentPosition.x - curveBuffer) + " " + (currentPosition.y + curveBuffer);
	                  }
	              } else {
	                if (strokeSide === "left") // short side
	                  {
	                    pathString += " V " + (currentPosition.y + curveBuffer);
	                    pathString += " Q " + (currentPosition.x + curveBuffer) + " " + (currentPosition.y + curveBuffer) + " " + (currentPosition.x + curveBuffer) + " " + (currentPosition.y + curveBuffer);
	                  } else // long side
	                  {
	                    pathString += " V " + currentPosition.y;
	                    pathString += " Q " + (currentPosition.x - curveBuffer) + " " + (currentPosition.y - curveBuffer) + " " + currentPosition.x + " " + (currentPosition.y - curveBuffer);
	                  }
	              }
	            } else {
	              if (_directionInfo.nextDirection === _constants2.default.DIRECTIONS.LEFT) {
	                if (strokeSide === "left") // short side
	                  {
	                    pathString += " V " + (currentPosition.y - curveBuffer);
	                    pathString += " Q " + (currentPosition.x - curveBuffer) + " " + (currentPosition.y - curveBuffer) + " " + (currentPosition.x - curveBuffer) + " " + (currentPosition.y - curveBuffer);
	                  } else // long side
	                  {
	                    pathString += " V " + currentPosition.y;
	                    pathString += " Q " + (currentPosition.x + curveBuffer) + " " + (currentPosition.y + curveBuffer) + " " + currentPosition.x + " " + (currentPosition.y + curveBuffer);
	                  }
	              } else {
	                if (strokeSide === "left") // long side
	                  {
	                    pathString += " V " + currentPosition.y;
	                    pathString += " Q " + (currentPosition.x - curveBuffer) + " " + (currentPosition.y + curveBuffer) + " " + currentPosition.x + " " + (currentPosition.y + curveBuffer);
	                  } else // short side
	                  {
	                    pathString += " V " + (currentPosition.y - curveBuffer);
	                    pathString += " Q " + (currentPosition.x + curveBuffer) + " " + (currentPosition.y - curveBuffer) + " " + (currentPosition.x + curveBuffer) + " " + (currentPosition.y - curveBuffer);
	                  }
	              }
	            }
	          }
	      } else // diagonal (currently not supported)
	        {
	          log.error("Unexpected road layout");
	        }
	    }
	
	    currentNavigation = {
	      x: endPosition.x,
	      y: endPosition.y,
	      type: "absolute"
	    };
	
	    directionInfo = RoadUtils.getNavigationDirection(currentPosition, currentNavigation, null);
	
	    log.debug("Final direction: %s", directionInfo.currentDirection);
	
	    if (directionInfo.currentDirection === _constants2.default.DIRECTIONS.UP) {
	      if (strokeSide === "left") {
	        pathString += " L " + (endPosition.x + curveBuffer) + " " + endPosition.y;
	      } else {
	        pathString += " L " + (endPosition.x - curveBuffer) + " " + endPosition.y;
	      }
	    } else if (directionInfo.currentDirection === _constants2.default.DIRECTIONS.RIGHT) {
	      if (strokeSide === "left") {
	        pathString += " L " + endPosition.x + " " + (endPosition.y + curveBuffer);
	      } else {
	        pathString += " L " + endPosition.x + " " + (endPosition.y - curveBuffer);
	      }
	    } else if (directionInfo.currentDirection === _constants2.default.DIRECTIONS.DOWN) {
	      if (strokeSide === "left") {
	        pathString += " L " + (endPosition.x - curveBuffer) + " " + endPosition.y;
	      } else {
	        pathString += " L " + (endPosition.x + curveBuffer) + " " + endPosition.y;
	      }
	    } else if (directionInfo.currentDirection === _constants2.default.DIRECTIONS.LEFT) {
	      if (strokeSide === "left") {
	        pathString += " L " + endPosition.x + " " + (endPosition.y - curveBuffer);
	      } else {
	        pathString += " L " + endPosition.x + " " + (endPosition.y + curveBuffer);
	      }
	    }
	
	    return pathString;
	  };
	
	  RoadUtils.getNavigationDirection = function (currentPosition, currentNavigation, nextNavigation) {
	    var currentXTranslation = void 0;
	    var currentYTranslation = void 0;
	
	    // log.debug("Determining navigation direction\ncurrentPosition: %o\ncurrentNavigation: %o\nnextNavigation: %o", currentPosition, currentNavigation, nextNavigation);
	
	    if (currentNavigation.type === "absolute") {
	      currentXTranslation = currentNavigation.x ? currentNavigation.x - currentPosition.x : 0;
	      currentYTranslation = currentNavigation.y ? currentNavigation.y - currentPosition.y : 0;
	    } else {
	      currentXTranslation = currentNavigation.x;
	      currentYTranslation = currentNavigation.y;
	    }
	
	    var newX = currentPosition.x + currentXTranslation;
	    var newY = currentPosition.y + currentYTranslation;
	
	    var nextXTranslation = void 0;
	    var nextYTranslation = void 0;
	
	    if (_utils2.default.isNotNull(nextNavigation)) {
	      if (nextNavigation.type === "absolute") {
	        nextXTranslation = nextNavigation.x ? nextNavigation.x - newX : 0;
	        nextYTranslation = nextNavigation.y ? nextNavigation.y - newY : 0;
	      } else {
	        nextXTranslation = nextNavigation.x;
	        nextYTranslation = nextNavigation.y;
	      }
	    }
	
	    // log.debug("currentPosition: %o\nnewX: %f\nnewY: %f\ncurrentXTranslation: %f\ncurrentYTranslation: %f\nnextXTranslation: %f\nnextYTranslation: %f", currentPosition, newX, newY, currentXTranslation, currentYTranslation, nextXTranslation, nextYTranslation);
	
	    var currentDirection = void 0;
	    var nextDirection = void 0;
	
	    if (currentXTranslation !== 0 && currentYTranslation === 0) // Horizontal
	      {
	        currentDirection = currentXTranslation < 0 ? _constants2.default.DIRECTIONS.LEFT : _constants2.default.DIRECTIONS.RIGHT;
	      } else if (currentXTranslation === 0 && currentYTranslation !== 0) // Vertical
	      {
	        currentDirection = currentYTranslation < 0 ? _constants2.default.DIRECTIONS.UP : _constants2.default.DIRECTIONS.DOWN;
	      } else // Diagonal
	      {
	        log.error("Current direction is diagonal, this is currently not supported\nx translation: %f\ny translation: %f", currentXTranslation, currentYTranslation);
	        return null;
	      }
	
	    if (_utils2.default.isNotNull(nextNavigation)) {
	      if (nextXTranslation !== 0 && nextYTranslation === 0) // Horizontal
	        {
	          nextDirection = nextXTranslation < 0 ? _constants2.default.DIRECTIONS.LEFT : _constants2.default.DIRECTIONS.RIGHT;
	        } else if (nextXTranslation === 0 && nextYTranslation !== 0) // Vertical
	        {
	          nextDirection = nextYTranslation < 0 ? _constants2.default.DIRECTIONS.UP : _constants2.default.DIRECTIONS.DOWN;
	        } else // Diagonal
	        {
	          log.error("Next direction is diagonal, this is currently not supported\nx translation: %f\ny translation: %f", nextXTranslation, nextYTranslation);
	          return null;
	        }
	    }
	
	    return {
	      currentDirection: currentDirection,
	      nextDirection: nextDirection
	    };
	  };
	
	  RoadUtils.combineConnections = function (connections) {
	    if (_utils2.default.isNull(connections) || connections.length < 2) {
	      throw new _appError2.default({ exception: new Error("At least 2 connections are required to combine") });
	    }
	
	    var startConnection = connections[0];
	
	    var newConnection = {};
	
	    newConnection.start = startConnection.start;
	    newConnection.startType = startConnection.startType;
	    newConnection.startPosition = startConnection.startPosition;
	
	    newConnection.navigation = [];
	
	    var lastNavigation = void 0;
	
	    for (var i = 0; i < connections.length; i++) {
	      var currentConnection = connections[i];
	
	      if (newConnection.navigation.length > 0) {
	        lastNavigation = newConnection.navigation[newConnection.navigation.length - 1];
	
	        if (currentConnection.startPosition.x !== lastNavigation.x || currentConnection.startPosition.y !== lastNavigation.y) {
	          log.error("Error while creating new connection. Navigation doesn't line up:\nlast navigation: %o\nnext start position: %o", lastNavigation, currentConnection.startPosition);
	          return null;
	        }
	      }
	
	      // Don't add startPosition of the connections to the new navigation, it should already be in there since the end position of the previous navigation should be equal to the start position of the next
	
	      // Concat all navigations of the current connection to new connection
	      newConnection.navigation = newConnection.navigation.concat(currentConnection.navigation);
	
	      // If connection is the last set the end position instead of adding it to the navigation
	      if (i === connections.length - 1) {
	        newConnection.end = currentConnection.end;
	        newConnection.endType = currentConnection.endType;
	        newConnection.endPosition = {
	          x: currentConnection.endPosition.x,
	          y: currentConnection.endPosition.y
	        };
	      } else {
	        // Add end position position as navigation part
	        newConnection.navigation.push({
	          x: currentConnection.endPosition.x,
	          y: currentConnection.endPosition.y,
	          type: "absolute"
	        });
	      }
	    }
	
	    return newConnection;
	  };
	
	  RoadUtils.getConnectionsForRoad = function (road, startKey, endKey, intersectionKeys, layoutData) {
	    var connections = [];
	
	    var start = startKey;
	    var end = void 0;
	
	    if (_utils2.default.isNotNull(intersectionKeys) && intersectionKeys.length > 0) {
	      for (var i = 0; i < intersectionKeys.length; i++) {
	        end = intersectionKeys[i];
	        var _currentConnection = getConnectionForStartAndEnd(start, end);
	
	        if (_utils2.default.isNotNull(_currentConnection)) {
	          connections.push(_currentConnection);
	          // next start position is the current end position
	          start = end;
	        } else {
	          log.error("No connection found for start [%s] and end [%s]", start, end);
	          return null;
	        }
	      }
	    }
	
	    end = endKey;
	    var currentConnection = getConnectionForStartAndEnd(start, end);
	
	    if (_utils2.default.isNotNull(currentConnection)) {
	      connections.push(currentConnection);
	    } else {
	      log.error("No connection found for start [%s] and end [%s]", start, end);
	      return null;
	    }
	
	    function getConnectionForStartAndEnd(startKey, endKey) {
	      for (var _i = 0; _i < road.connections.length; _i++) {
	        // Deep clone road connection since we might change some things
	        var _currentConnection2 = road.connections[_i];
	
	        if (_currentConnection2.start === startKey && _currentConnection2.end === endKey) {
	          // Deep clone road connection since we might change some things (only clone once we found our connection, for performance)
	          _currentConnection2 = _utils2.default.parseJSON(_utils2.default.stringifyJSON(road.connections[_i]));
	
	          if (_currentConnection2.startType === "intersection") {
	            var startIntersection = layoutData.intersections[startKey];
	
	            if (_utils2.default.isNull(startIntersection)) {
	              log.error("Intersection [%s] not found in layout data %o", startKey, layoutData);
	            }
	
	            _currentConnection2.startPosition = {
	              x: startIntersection.position.x,
	              y: startIntersection.position.y
	            };
	          }
	
	          if (_currentConnection2.endType === "intersection") {
	            var endIntersection = layoutData.intersections[endKey];
	
	            if (_utils2.default.isNull(endIntersection)) {
	              log.error("Intersection [%s] not found in layout data %o", startKey, layoutData);
	            }
	
	            _currentConnection2.endPosition = {
	              x: endIntersection.position.x,
	              y: endIntersection.position.y
	            };
	          }
	
	          // Clone the connection because we might add some extra navigation
	          return _currentConnection2;
	        }
	      }
	
	      return null;
	    }
	
	    return connections;
	  };
	})(RoadUtils);
	
	exports.default = RoadUtils;

/***/ }),

/***/ 343:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var log = __webpack_require__(5)();
	
	module.exports = function () {
	  function ObjectSelector(options) {
	    _classCallCheck(this, ObjectSelector);
	
	    this.key = options.key;
	    this.name = options.name;
	    this.containerElement = options.containerElement;
	    this.onClickCallback = options.onClickCallback;
	    this.isActive = options.isActive;
	
	    this.create();
	  }
	
	  _createClass(ObjectSelector, [{
	    key: "create",
	    value: function create() {
	      var that = this;
	      var element = $("<a class='object-selector'>" + this.name + "</a>").attr("data-object-key", this.key);
	      element.on("click", function () {
	        that.setActive();
	        that.onClickCallback(that.key);
	      });
	
	      this.containerElement.append(element);
	      this.element = element;
	
	      if (this.isActive) this.setActive();
	    }
	  }, {
	    key: "setActive",
	    value: function setActive() {
	      this.containerElement.find(".object-selector").each(function () {
	        $(this).removeClass("active");
	      });
	
	      this.element.addClass("active");
	    }
	  }]);
	
	  return ObjectSelector;
	}();
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),

/***/ 345:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _utils = __webpack_require__(3);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _languageManager = __webpack_require__(6);
	
	var _languageManager2 = _interopRequireDefault(_languageManager);
	
	var _credits = __webpack_require__(793);
	
	var _credits2 = _interopRequireDefault(_credits);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Created by jv on 2019-10-17 (14:52).
	 */
	var log = __webpack_require__(5)();
	
	
	var CloseSvgIcon = __webpack_require__(49);
	
	__webpack_require__(47);
	__webpack_require__(728);
	
	var CreditsDialog = function () {
	  function CreditsDialog(options) {
	    _classCallCheck(this, CreditsDialog);
	
	    this.dialogId = _utils2.default.generateElementId("credits-dialog-");
	
	    this.callbackContext = options.callbackContext;
	    this.onCancel = options.onCancel;
	  }
	
	  _createClass(CreditsDialog, [{
	    key: "create",
	    value: function create() {
	      if (this._initialized !== true) {
	        this.renderDialog();
	
	        this.$dialog.appendTo("body");
	        this.initialize();
	      }
	    }
	  }, {
	    key: "initialize",
	    value: function initialize() {
	      if (this._initialized !== true) {
	        this.$dialog.modal({
	          backdrop: false,
	          show: false
	        });
	
	        this.setUpDialogEventListeners();
	
	        this._initialized = true;
	      }
	    }
	  }, {
	    key: "renderDialog",
	    value: function renderDialog() {
	      this.$dialog = $("<div id='" + this.dialogId + "' class='modal fade modal-credits' tabindex='-1' role='dialog' aria-hidden='true'>" + "<div class='modal-dialog modal-dialog-centered business-model-dialog credits-dialog'>" + "<div class='modal-content'>" + "</div>" + "</div>" + "</div>");
	
	      this.renderDialogContent();
	    }
	  }, {
	    key: "renderDialogContent",
	    value: function renderDialogContent() {
	      var $dialogContent = this.$dialog.find(".modal-content");
	
	      if (_utils2.default.isNotNull($dialogContent) && $dialogContent.length) {
	        $dialogContent.empty();
	
	        log.debug("Setting up credits dialog");
	
	        var $closeBtn = $("<button class='btn dialog-close-btn' type='button'></button>");
	        $closeBtn.html(CloseSvgIcon);
	        $dialogContent.append($closeBtn);
	
	        var $creditsContent = $(_credits2.default);
	        $dialogContent.append($creditsContent);
	        _languageManager2.default.applyLocale($creditsContent);
	
	        this.setUpCloseRoundEventListeners();
	      }
	    }
	  }, {
	    key: "show",
	    value: function show(showBackdrop) {
	      if (showBackdrop) {
	        this.$dialog.addClass("modal-credits__backdrop");
	      } else {
	        this.$dialog.removeClass("modal-credits__backdrop");
	      }
	
	      this.$dialog.modal("show");
	    }
	  }, {
	    key: "hide",
	    value: function hide() {
	      this.$dialog.modal("hide");
	    }
	  }, {
	    key: "setUpDialogEventListeners",
	    value: function setUpDialogEventListeners() {}
	  }, {
	    key: "setUpCloseRoundEventListeners",
	    value: function setUpCloseRoundEventListeners() {
	      var _this = this;
	
	      this.$dialog.find(".btn").on("transitionend", function (e) {
	        // transitionend fix for dialog close animations
	        e.preventDefault();
	        e.stopPropagation();
	        return false;
	      });
	
	      this.$dialog.find(".dialog-close-btn").on("click", function (e) {
	        if (_utils2.default.isFunction(_this.onCancel)) {
	          _this.onCancel.call(_this.callbackContext, _this);
	        }
	      });
	    }
	  }, {
	    key: "isOpen",
	    get: function get() {
	      return _utils2.default.isNotNull(this.$dialog) && this.$dialog.length && this.$dialog.hasClass("show");
	    }
	  }]);
	
	  return CreditsDialog;
	}();
	
	exports.default = CreditsDialog;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),

/***/ 346:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _utils = __webpack_require__(3);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _languageManager = __webpack_require__(6);
	
	var _languageManager2 = _interopRequireDefault(_languageManager);
	
	var _eventExtra_product_reduction = __webpack_require__(903);
	
	var _eventExtra_product_reduction2 = _interopRequireDefault(_eventExtra_product_reduction);
	
	var _btn_arrow = __webpack_require__(851);
	
	var _btn_arrow2 = _interopRequireDefault(_btn_arrow);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Created by jv on 2019-11-22 (10:42).
	 */
	var log = __webpack_require__(5)();
	
	
	var eventIcons = __webpack_require__(289);
	
	__webpack_require__(731);
	
	var EventPanel = function () {
	  function EventPanel(options) {
	    _classCallCheck(this, EventPanel);
	
	    if (_utils2.default.isNull(options)) options = {};
	
	    this._event = options.event;
	    this.appendTo = $(options.appendTo);
	  }
	
	  _createClass(EventPanel, [{
	    key: "render",
	    value: function render() {
	      if (_utils2.default.isNull(this.event)) return;
	
	      if (_utils2.default.isNotNull(this.$element) && this.$element.length) {
	        this.destroy();
	      }
	
	      this.$element = $("<div class='event-panel'></div>");
	      this.$element.data("event-type", this.event.type);
	
	      log.debug("Setting up event panel for event - %o", this.event);
	
	      var $eventPanelTop = $("<div class='event-panel__top'></div>");
	
	      var icon = EventPanel.getEventIconForEvent(this.event);
	      var $eventIcon = $("<div class='event-panel__icon'></div>");
	      if (_utils2.default.isNotNull(icon)) {
	        $eventIcon.append(icon);
	      }
	
	      $eventPanelTop.append($eventIcon);
	      $eventPanelTop.append("<h4 class=\"event-panel__title\">" + this.event.title + "</h4>");
	
	      var $eventPanelBottom = $("<div class='event-panel__bottom'></div>");
	
	      var $eventDataHtml = EventPanel.getHtmlForEvent(this.event);
	
	      if (_utils2.default.isNotNull($eventDataHtml)) {
	        $eventPanelBottom.append($eventDataHtml);
	      }
	
	      this.$element.append($eventPanelTop);
	      this.$element.append($eventPanelBottom);
	
	      this.$element.appendTo(this.appendTo);
	    }
	  }, {
	    key: "destroy",
	    value: function destroy() {
	      if (_utils2.default.isNotNull(this.$element) && this.$element.length) {
	        this.$element.remove();
	      }
	    }
	  }, {
	    key: "show",
	    value: function show() {
	      if (_utils2.default.isNotNull(this.$element) && this.$element.length) {
	        this.$element.show();
	      }
	    }
	  }, {
	    key: "hide",
	    value: function hide() {
	      if (_utils2.default.isNotNull(this.$element) && this.$element.length) {
	        this.$element.hide();
	      }
	    }
	  }, {
	    key: "event",
	    get: function get() {
	      return this._event;
	    },
	    set: function set(event) {
	      this._event = event;
	      this.render();
	    }
	  }], [{
	    key: "getEventIconForEvent",
	    value: function getEventIconForEvent(event) {
	      var eventIconKey = "./" + event.type + ".svg";
	      if (eventIcons.keys().includes(eventIconKey)) {
	        return eventIcons(eventIconKey);
	      }
	
	      return null;
	    }
	  }, {
	    key: "getHtmlForEvent",
	    value: function getHtmlForEvent(event) {
	      switch (event.type) {
	        case "energy":
	          return EventPanel.getEnergyHtml(event);
	        case "tax":
	          return EventPanel.getTaxHtml(event);
	        case "tradewar":
	          return EventPanel.getTradeWarHtml(event);
	        case "subsidy":
	          return EventPanel.getSubsidyHtml(event);
	      }
	
	      return null;
	    }
	  }, {
	    key: "getEnergyHtml",
	    value: function getEnergyHtml(event) {
	      var $eventData = $("<div class='event-panel__impact'></div>");
	      $eventData.addClass("event-type__" + event.type);
	
	      $eventData.append("<p>" + event.jsonData.text1 + "</p>");
	      $eventData.append("<p>" + event.jsonData.text2 + "</p>");
	
	      var $eventDataGroup = $("<div class='ep__data-group'></div>");
	      $eventDataGroup.append("<div class='ep__data-value event-data event-data__budget'>" + event.jsonData.value + "</div>");
	      $eventDataGroup.append("<div class='ep__data-label'>" + _languageManager2.default.getValueForKey("serious_game.business_model.events.labels.per_product") + "</div>");
	
	      $eventData.append($eventDataGroup);
	
	      return $eventData;
	    }
	  }, {
	    key: "getTaxHtml",
	    value: function getTaxHtml(event) {
	      var $eventData = $("<div class='event-panel__impact'></div>");
	      $eventData.addClass("event-type__" + event.type);
	
	      $eventData.append("<p>" + event.jsonData.text + "</p>");
	
	      var $eventDataGroups = $("<div class='ep__data-groups'></div>");
	
	      var $leftCol = $("<div class='ep__data-group-col'></div>");
	      var $rightCol = $("<div class='ep__data-group-col'></div>");
	
	      event.jsonData.values.sort(function (v1, v2) {
	        return v1.index - v2.index;
	      });
	
	      for (var i = 0; i < event.jsonData.values.length; i++) {
	        var valueGroup = event.jsonData.values[i];
	
	        var pointRange = void 0;
	
	        if (i === event.jsonData.values.length - 1) {
	          // Last
	          pointRange = valueGroup.min + "+";
	        } else {
	          pointRange = valueGroup.min + "-" + (valueGroup.max - 1);
	        }
	
	        var $eventDataGroup = $("<div class='ep__data-group'></div>");
	        $eventDataGroup.append("<div class='ep__data-value event-data event-data__points'>" + pointRange + "</div>");
	        $eventDataGroup.append("<div class='ep__data-connector'>" + _btn_arrow2.default + "</div>");
	        $eventDataGroup.append("<div class='ep__data-value event-data event-data__budget'>" + Math.abs(valueGroup.value) + "</div>");
	
	        if (i < Math.ceil(event.jsonData.values.length / 2)) {
	          $leftCol.append($eventDataGroup);
	        } else {
	          $rightCol.append($eventDataGroup);
	        }
	      }
	
	      $eventDataGroups.append($leftCol);
	      $eventDataGroups.append($rightCol);
	
	      $eventData.append($eventDataGroups);
	
	      return $eventData;
	    }
	  }, {
	    key: "getTradeWarHtml",
	    value: function getTradeWarHtml(event) {
	      var $eventData = $("<div class='event-panel__impact'></div>");
	      $eventData.addClass("event-type__" + event.type);
	
	      $eventData.append("<p>" + event.jsonData.text1 + "</p>");
	
	      var sign = "";
	
	      if (event.jsonData.value1 > 0) {
	        sign = "+";
	      }
	
	      var $eventDataGroup = $("<div class='ep__data-group'></div>");
	      $eventDataGroup.append("<div class='ep__data-value event-data event-data__budget'>" + sign + event.jsonData.value1 + "</div>");
	      $eventDataGroup.append("<div class='ep__data-label'>" + _languageManager2.default.getValueForKey("serious_game.business_model.events.labels.per_product") + "</div>");
	
	      $eventData.append($eventDataGroup);
	
	      sign = "";
	
	      if (event.jsonData.value2 > 0) {
	        sign = "+";
	      }
	
	      $eventData.append("<p>" + event.jsonData.text2 + "</p>");
	
	      $eventDataGroup = $("<div class='ep__data-group'></div>");
	      $eventDataGroup.append("<div class='ep__data-value event-data event-data__budget'>" + sign + event.jsonData.value2 + "</div>");
	      $eventDataGroup.append("<div class='ep__data-label'>" + _languageManager2.default.getValueForKey("serious_game.business_model.events.labels.per_product") + "</div>");
	
	      $eventData.append($eventDataGroup);
	
	      return $eventData;
	    }
	  }, {
	    key: "getSubsidyHtml",
	    value: function getSubsidyHtml(event) {
	      var $eventData = $("<div class='event-panel__impact'></div>");
	      $eventData.addClass("event-type__" + event.type);
	
	      $eventData.append("<p>" + event.jsonData.text + "</p>");
	
	      var $eventDataGroup = $("<div class='ep__data-group'></div>");
	      $eventDataGroup.append("<img src='" + _eventExtra_product_reduction2.default + "' alt=''/>");
	      $eventDataGroup.append("<div class='ep__data-label'>" + _languageManager2.default.getValueForKey("serious_game.business_model.events.labels.cost") + "</div>");
	      $eventDataGroup.append("<div class='ep__data-value event-data event-data__budget'>" + event.jsonData.value + "</div>");
	
	      $eventData.append($eventDataGroup);
	
	      return $eventData;
	    }
	  }]);
	
	  return EventPanel;
	}();
	
	exports.default = EventPanel;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),

/***/ 347:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _utils = __webpack_require__(3);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _languageManager = __webpack_require__(6);
	
	var _languageManager2 = _interopRequireDefault(_languageManager);
	
	__webpack_require__(339);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Created by jv on 2019-10-01 (14:21).
	 */
	__webpack_require__(323);
	__webpack_require__(322);
	
	var log = __webpack_require__(5)();
	
	
	var CloseSvgIcon = __webpack_require__(49);
	var ArrowShortSvg = __webpack_require__(338);
	var TutorialImages = __webpack_require__(340);
	
	__webpack_require__(47);
	__webpack_require__(393);
	__webpack_require__(748);
	
	var tutorialSteps = [{
	  step: 1,
	  text: function text() {
	    return _languageManager2.default.getValueForKey("serious_game.business_model.tutorial.dialog.steps.0.text");
	  },
	  image: "tutorial1.png",
	  alt: ""
	}, {
	  step: 2,
	  text: function text() {
	    return _languageManager2.default.getValueForKey("serious_game.business_model.tutorial.dialog.steps.1.text");
	  },
	  image: "tutorial2.png",
	  alt: ""
	}, {
	  step: 3,
	  text: function text() {
	    return _languageManager2.default.getValueForKey("serious_game.business_model.tutorial.dialog.steps.2.text");
	  },
	  image: "tutorial3.png",
	  alt: ""
	}, {
	  step: 4,
	  text: function text() {
	    return _languageManager2.default.getValueForKey("serious_game.business_model.tutorial.dialog.steps.3.text");
	  },
	  image: "tutorial4.png",
	  alt: ""
	}, {
	  step: 5,
	  text: function text() {
	    return _languageManager2.default.getValueForKey("serious_game.business_model.tutorial.dialog.steps.4.text");
	  },
	  image: "tutorial5.png",
	  alt: ""
	}, {
	  step: 6,
	  text: function text() {
	    return _languageManager2.default.getValueForKey("serious_game.business_model.tutorial.dialog.steps.5.text");
	  },
	  image: "tutorial6.png",
	  alt: ""
	}, {
	  step: 7,
	  text: function text() {
	    return _languageManager2.default.getValueForKey("serious_game.business_model.tutorial.dialog.steps.6.text");
	  },
	  image: "tutorial7.png",
	  alt: ""
	}, {
	  step: 8,
	  text: function text() {
	    return _languageManager2.default.getValueForKey("serious_game.business_model.tutorial.dialog.steps.7.text");
	  },
	  image: "tutorial8.png",
	  alt: ""
	}];
	
	var TutorialDialog = function () {
	  function TutorialDialog(options) {
	    _classCallCheck(this, TutorialDialog);
	
	    this.dialogId = _utils2.default.generateElementId("tutorial-dialog-");
	
	    this.callbackContext = options.callbackContext;
	    this.onCancel = options.onCancel;
	  }
	
	  _createClass(TutorialDialog, [{
	    key: "create",
	    value: function create() {
	      if (this._initialized !== true) {
	        this.renderDialog();
	
	        this.$dialog.appendTo("body");
	        this.initialize();
	      }
	    }
	  }, {
	    key: "initialize",
	    value: function initialize() {
	      if (this._initialized !== true) {
	        this.$dialog.modal({
	          backdrop: false,
	          show: false
	        });
	
	        this._initialized = true;
	      }
	    }
	  }, {
	    key: "renderDialog",
	    value: function renderDialog() {
	      this.$dialog = $("<div id='" + this.dialogId + "' class='modal fade' tabindex='-1' role='dialog' aria-hidden='true'>" + "<div class='modal-dialog modal-dialog-centered business-model-dialog slider-dialog tutorial-dialog'>" + "<div class='modal-content'>" +
	      //
	      "</div>" + "</div>" + "</div>");
	
	      this.renderDialogContent();
	    }
	  }, {
	    key: "renderDialogContent",
	    value: function renderDialogContent() {
	      if (_utils2.default.isNull(tutorialSteps)) return;
	
	      var $dialogContent = this.$dialog.find(".modal-content");
	
	      if (_utils2.default.isNotNull($dialogContent) && $dialogContent.length) {
	        $dialogContent.empty();
	
	        log.debug("Setting up tutorial dialog - %o", tutorialSteps);
	
	        var $closeBtn = $("<button class='btn dialog-close-btn' type='button'></button>");
	        $closeBtn.html(CloseSvgIcon);
	        $dialogContent.append($closeBtn);
	
	        var $tutorialContent = $("<div class='tutorial-dialog__content'></div>");
	
	        // Dialog top
	        var $tutorialTop = $("<div class='tutorial__top'></div>");
	
	        $tutorialTop.append("<h5 class='tutorial-dialog__title'>" + _languageManager2.default.getValueForKey("serious_game.business_model.tutorial.dialog.title") + "</h5>");
	
	        var $sliderPrevBtn = $("<button class=\"btn btn-slider btn-slider__prev slider-dialog__prev-btn\" type=\"button\">" + ArrowShortSvg + "</button>");
	        var $sliderNextBtn = $("<button class=\"btn btn-slider btn-slider__next slider-dialog__next-btn\" type=\"button\">" + ArrowShortSvg + "</button>");
	        var $imageSlider = $("<div class='tutorial-dialog__image-slider'></div>");
	
	        $tutorialTop.append($sliderPrevBtn);
	        $tutorialTop.append($imageSlider);
	        $tutorialTop.append($sliderNextBtn);
	
	        // Dialog bottom
	        var $tutorialBottom = $("<div class='tutorial__bottom'></div>");
	
	        var $contentSlider = $("<div class='tutorial-dialog__content-slider'></div>");
	        $tutorialBottom.append($contentSlider);
	
	        for (var i = 0; i < tutorialSteps.length; i++) {
	          var step = tutorialSteps[i];
	
	          var $tutorialImage = $("<div class='tutorial-step__image'></div>");
	          $tutorialImage.append("<figure><img src=\"" + TutorialDialog.getTutorialStepImage(step) + "\" alt=\"" + step.alt + "\"/></figure>");
	          $imageSlider.append($tutorialImage);
	
	          var $tutorialStepContent = $("<div class='tutorial-step__content'></div>");
	          $tutorialStepContent.html(step.text());
	          $contentSlider.append($tutorialStepContent);
	        }
	
	        $tutorialContent.append($tutorialTop).append($tutorialBottom);
	        $dialogContent.append($tutorialContent);
	
	        this.setUpSlick();
	
	        this.setUpEventListeners();
	      }
	    }
	  }, {
	    key: "show",
	    value: function show() {
	      this.renderDialogContent();
	      this.$dialog.modal("show");
	
	      var $imageSlider = this.$dialog.find(".tutorial-dialog__image-slider");
	      var $contentSlider = this.$dialog.find(".tutorial-dialog__content-slider");
	      $imageSlider.slick("resize");
	      $imageSlider.slick("setPosition");
	      $contentSlider.slick("resize");
	      $contentSlider.slick("setPosition");
	    }
	  }, {
	    key: "hide",
	    value: function hide() {
	      this.$dialog.modal("hide");
	    }
	  }, {
	    key: "setUpEventListeners",
	    value: function setUpEventListeners() {
	      var _this = this;
	
	      this.$dialog.find(".btn").on("transitionend", function (e) {
	        // transitionend fix for dialog close animations
	        e.preventDefault();
	        e.stopPropagation();
	        return false;
	      });
	
	      this.$dialog.find(".dialog-close-btn").on("click", function (e) {
	        if (_utils2.default.isFunction(_this.onCancel)) {
	          _this.onCancel.call(_this.callbackContext, _this);
	        }
	      });
	    }
	  }, {
	    key: "setUpSlick",
	    value: function setUpSlick() {
	      var $imageSlider = this.$dialog.find(".tutorial-dialog__image-slider");
	      var $contentSlider = this.$dialog.find(".tutorial-dialog__content-slider");
	
	      var slickOptionsDefault = {
	        focusOnSelect: false,
	
	        mobileFirst: true,
	
	        draggable: false,
	        swipe: true,
	
	        infinite: false,
	
	        // dots: true,
	        arrows: true,
	        prevArrow: this.$dialog.find(".slider-dialog__prev-btn"),
	        nextArrow: this.$dialog.find(".slider-dialog__next-btn"),
	
	        slidesToShow: 1,
	        slidesToScroll: 1,
	
	        // Without this, adding slides after the initialize is fcked up for some reason:
	        // https://github.com/kenwheeler/slick/commit/be0d17cc858fb30e6a4d6b28cc29860c7170040d#comments
	        rows: 0
	      };
	
	      var imageSliderOptions = _extends({}, slickOptionsDefault, {
	        asNavFor: $contentSlider
	      });
	
	      var contentSliderOptions = _extends({}, slickOptionsDefault, {
	        arrows: false,
	        dots: true,
	        appendDots: this.$dialog.find(".modal-content"),
	        asNavFor: $imageSlider
	      });
	
	      $imageSlider.slick(imageSliderOptions);
	      $contentSlider.slick(contentSliderOptions);
	    }
	  }, {
	    key: "isOpen",
	    get: function get() {
	      return _utils2.default.isNotNull(this.$dialog) && this.$dialog.length && this.$dialog.hasClass("show");
	    }
	  }], [{
	    key: "getTutorialStepImage",
	    value: function getTutorialStepImage(step) {
	      if (_utils2.default.isNull(step) || _utils2.default.isNull(step.image)) return null;
	      var requireKey = "./" + step.image;
	      if (!TutorialImages.keys().includes(requireKey)) return null;
	
	      return TutorialImages(requireKey);
	    }
	  }]);
	
	  return TutorialDialog;
	}();
	
	exports.default = TutorialDialog;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),

/***/ 348:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _utils = __webpack_require__(3);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _appError = __webpack_require__(51);
	
	var _appError2 = _interopRequireDefault(_appError);
	
	var _historyController = __webpack_require__(496);
	
	var _historyController2 = _interopRequireDefault(_historyController);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Created by jv on 2019-09-09 (12:33).
	 */
	var log = __webpack_require__(5)();
	
	var GamePageController = function () {
	  function GamePageController(options) {
	    _classCallCheck(this, GamePageController);
	
	    if (_utils2.default.isNull(options) || !_utils2.default.isArray(options.gameViews) || options.gameViews.length === 0) {
	      throw new _appError2.default({ exception: new Error("GamePageController needs valid options object with at least 1 gameView") });
	    }
	
	    this.gameViews = options.gameViews;
	    this.defaultView = options.defaultView ? options.defaultView : this.gameViews[0];
	
	    this.basePath = options.basePath ? options.basePath : "";
	
	    this.onBeforePageChange = options.onBeforePageChange;
	    this.onContentShow = options.onContentShow;
	
	    this.initialPage = options.initialPage;
	
	    this.currentGameView = null;
	  }
	
	  _createClass(GamePageController, [{
	    key: "init",
	    value: function init() {
	      this._setInitialPage();
	      this._setUpEventListeners();
	    }
	  }, {
	    key: "changePage",
	    value: function changePage(gameView, replaceState) {
	      // NOTE - browser navigation should be disabled, we don't want users to use the back/forward buttons
	      replaceState = true;
	
	      if (_utils2.default.isNull(gameView)) gameView = {};
	
	      log.info("Trying to change page to gameView [%s]\nreplaceState: %s", gameView.key, replaceState);
	
	      if (_utils2.default.isFunction(this.onBeforePageChange)) {
	        var allowContinue = this.onBeforePageChange(gameView);
	
	        if (!allowContinue) {
	          return;
	        }
	      }
	
	      var valid = this.validateView(gameView.key);
	
	      log.info("GameView '%s' valid ? %s", gameView.key, valid);
	
	      if (valid) {
	        var url = this.basePath + "/" + gameView.path;
	
	        if (replaceState) {
	          _historyController2.default.replaceState({
	            contentId: gameView.key
	          }, null, url);
	        } else {
	          _historyController2.default.pushState({
	            contentId: gameView.key
	          }, null, url);
	        }
	
	        this.showContent(gameView);
	      }
	    }
	  }, {
	    key: "showContent",
	    value: function showContent(gameView) {
	      if (_utils2.default.isNull(gameView)) return;
	
	      var isValid = this.validateView(gameView.key);
	
	      if (!isValid) {
	        return;
	      }
	
	      for (var i = 0; i < this.gameViews.length; i++) {
	        this.gameViews[i].hide();
	      }
	
	      if (!gameView.hasRendered) {
	        gameView.render();
	      }
	
	      this.currentGameView = gameView;
	
	      if (_utils2.default.isFunction(this.onContentShow)) {
	        this.onContentShow.call(this, gameView);
	      }
	
	      if (gameView.key === "session-join") {
	        $("footer").removeClass("marketing").addClass("marketing");
	        $("footer div.container").show();
	      } else {
	        $("footer").removeClass("marketing");
	        $("footer div.container").hide();
	      }
	    }
	  }, {
	    key: "validatePath",
	    value: function validatePath(path) {
	      if (_utils2.default.isNotNull(path)) {
	        path = path.replace(this.basePath + "/", "");
	
	        // TODO validate path
	        return true;
	      }
	
	      return false;
	    }
	  }, {
	    key: "validateView",
	    value: function validateView(gameViewKey) {
	      if (_utils2.default.isNotNull(gameViewKey)) {
	        for (var i = 0; i < this.gameViews.length; i++) {
	          if (this.gameViews[i].key === gameViewKey) {
	            return true;
	          }
	        }
	      }
	
	      return false;
	    }
	  }, {
	    key: "_setInitialPage",
	    value: function _setInitialPage() {
	      var pathName = this.initialPage || _utils2.default.getUrlPath();
	
	      var isValid = this.validatePath(pathName);
	
	      log.info("Path '%s' is %s", pathName, isValid ? "valid" : "not valid");
	
	      if (isValid) {
	        var foundGameView = null;
	
	        for (var i = 0; i < this.gameViews.length; i++) {
	          if (pathName.includes(this.gameViews[i].path)) {
	            foundGameView = this.gameViews[i];
	            break;
	          }
	        }
	
	        if (_utils2.default.isNotNull(foundGameView)) {
	          if (_utils2.default.isNull(this.initialPage) || this.initialPage === _utils2.default.getUrlPath()) {
	            this.showContent(foundGameView);
	          } else {
	            this.changePage(foundGameView, true);
	          }
	        } else {
	          this.changePage(this.defaultView, true);
	        }
	      } else {
	        this.changePage(this.defaultView, true);
	      }
	    }
	  }, {
	    key: "_setUpEventListeners",
	    value: function _setUpEventListeners() {
	      var _this = this;
	
	      $(window).on("popstate", function (event) {
	        log.info(event);
	        log.info("On popstate - state: %o", event.originalEvent.state);
	
	        var contentId = void 0;
	        var valid = false;
	
	        if (_utils2.default.isNotNull(event.originalEvent.state)) {
	          valid = _this.validateView(event.originalEvent.state.contentId);
	          contentId = event.originalEvent.state.contentId;
	        }
	
	        if (valid) {
	          _this.showContent(contentId);
	        } else {
	          _this.changePage(_this.defaultView, true);
	        }
	      });
	    }
	  }]);
	
	  return GamePageController;
	}();
	
	module.exports = GamePageController;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),

/***/ 349:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _utils = __webpack_require__(3);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _gameProgressController = __webpack_require__(796);
	
	var _gameProgressController2 = _interopRequireDefault(_gameProgressController);
	
	var _languageManager = __webpack_require__(6);
	
	var _languageManager2 = _interopRequireDefault(_languageManager);
	
	var _businessModel = __webpack_require__(226);
	
	var _businessModel2 = _interopRequireDefault(_businessModel);
	
	var _default = __webpack_require__(212);
	
	var _default2 = _interopRequireDefault(_default);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Created by jv on 2019-11-26 (13:37).
	 */
	var log = __webpack_require__(5)();
	// %NOTE: CMS.faq also uses this config, please change there too :)
	
	var eventIcons = __webpack_require__(289);
	var iconCardsReq = __webpack_require__(288);
	
	__webpack_require__(735);
	
	var GameProgressView = function () {
	  function GameProgressView(options) {
	    _classCallCheck(this, GameProgressView);
	
	    this.$container = $(options.container);
	
	    this.businessModel = null;
	
	    this.roundIndex = options.roundIndex;
	    this.roundProgressMap = options.roundProgressMap;
	
	    this.onRenderCompleted = options.onRenderComplete;
	    this.executeOnRender = [];
	  }
	
	  _createClass(GameProgressView, [{
	    key: "render",
	    value: function render() {
	      this.$element = $(_gameProgressController2.default);
	      this.$container.append(this.$element);
	      _languageManager2.default.applyLocale(this.$element);
	
	      this.$businessModelCanvas = this.$element.find(".game-progress__canvas");
	
	      this.showBusinessModelOnRender = true;
	      this.setLoadingState(true);
	      this.renderBusinessModelCanvas();
	
	      this._setUpEventListeners();
	    }
	  }, {
	    key: "onRender",
	    value: function onRender() {
	      log.info("Business model has rendered");
	
	      this.setUpChangeRoundButtons();
	      this.update();
	
	      if (this.showBusinessModelOnRender) {
	        this.showBusinessModel(true, false);
	        this.businessModel.fitToContainer();
	      }
	
	      for (var i = 0; i < this.executeOnRender.length; i++) {
	        if (_utils2.default.isFunction(this.executeOnRender[i])) {
	          this.executeOnRender[i].call(this);
	        }
	      }
	
	      if (_utils2.default.isFunction(this.onRenderCompleted)) {
	        this.onRenderCompleted.call(this);
	      }
	    }
	  }, {
	    key: "renderBusinessModelCanvas",
	    value: function renderBusinessModelCanvas() {
	      var _this = this;
	
	      this.businessModel = new _businessModel2.default({
	        containerElement: this.$businessModelCanvas,
	        layoutData: _default2.default,
	        onRenderComplete: this.onRender.bind(this),
	        availableCanvasSize: function availableCanvasSize(businessModel) {
	          var $overview = _this.$element.find(".game-progress__overview");
	          var $canvasWrapper = $overview.find(".game-progress__canvas-wrapper");
	          var $roundSelector = $overview.find(".game-progress__round-selector");
	
	          // Dirty hack to reset canvas size (otherwise it won't shrink anymore)
	          $canvasWrapper.hide();
	          var availableWidth = $overview.width() - $roundSelector.outerWidth(true);
	          var availableHeight = $overview.height();
	          $canvasWrapper.show();
	
	          return {
	            width: Math.min(businessModel.layoutData.size.width * 1.5, availableWidth),
	            height: Math.min(businessModel.layoutData.size.height * 1.5, availableHeight)
	          };
	        },
	        onCanvasSizeChanged: function onCanvasSizeChanged(oldWidth, oldHeight, newWidth, newHeight) {
	          log.info("Size changed: \noldWidth: %f\noldHeight: %f\nnewWidth: %f\nnewHeight: %f", oldWidth, oldHeight, newWidth, newHeight);
	          _this.$element.find(".game-progress__canvas-wrapper").css({
	            width: newWidth,
	            height: newHeight
	          });
	        }
	      });
	
	      log.info("Rendering business model: %o", this.businessModel);
	
	      this.businessModel.render();
	    }
	  }, {
	    key: "show",
	    value: function show() {
	      if (_utils2.default.isNotNull(this.$element) && this.$element.length) {
	        this.$element.show();
	      }
	    }
	  }, {
	    key: "hide",
	    value: function hide() {
	      if (_utils2.default.isNotNull(this.$element) && this.$element.length) {
	        this.$element.hide();
	      }
	    }
	  }, {
	    key: "destroy",
	    value: function destroy() {
	      if (_utils2.default.isNotNull(this.$element) && this.$element.length) {
	        this.$element.remove();
	      }
	    }
	  }, {
	    key: "showBusinessModel",
	    value: function showBusinessModel(flag) {
	      if (flag) {
	        if (this.businessModel.hasRendered()) {
	          this.setLoadingState(false);
	          this.$businessModelCanvas.show();
	        } else {
	          this.showBusinessModelOnRender = true;
	          this.setLoadingState(true);
	        }
	      } else {
	        this.$businessModelCanvas.hide();
	      }
	    }
	  }, {
	    key: "setLoadingState",
	    value: function setLoadingState(flag) {
	      if (flag) this.$element.addClass("gp__is-loading");else this.$element.removeClass("gp__is-loading");
	    }
	  }, {
	    key: "setUpChangeRoundButtons",
	    value: function setUpChangeRoundButtons() {
	      var _this2 = this;
	
	      // Determines if buttons are clickable or not
	
	      if (_utils2.default.isNotNull(this.$element) && this.$element.length) {
	        this.$element.find(".select-round-btn").each(function (index, el) {
	          var $el = $(el);
	          var roundIndex = parseInt($el.data("gp-round-index"));
	
	          $el.parent().removeClass("active");
	
	          var clickable = _this2.canViewGameProgress(roundIndex);
	          $el.prop("disabled", !clickable);
	
	          if (clickable && roundIndex === _this2.roundIndex) {
	            $el.parent().addClass("active");
	          }
	        });
	      }
	    }
	  }, {
	    key: "_setUpEventListeners",
	    value: function _setUpEventListeners() {
	      this.$element.find(".select-round-btn").off("click").on("click", this.onChangeRoundEvent.bind(this));
	    }
	  }, {
	    key: "update",
	    value: function update() {
	      if (_utils2.default.isNotNull(this.$element) && this.$element.length) {
	        var roundProgress = this.roundProgressMap[this.roundIndex];
	
	        if (_utils2.default.isNull(roundProgress)) {
	          log.error("Round progress for round [%d] not found - %o", this.roundIndex, this.roundProgressMap);
	          return false;
	        }
	
	        if (_utils2.default.isNull(roundProgress.roundData.closed)) {
	          log.error("Can't view game progress for round that's not yet finished");
	          return;
	        }
	
	        log.info("Applying game progress for round [%d]\nRound progress: %o", this.roundIndex, roundProgress);
	
	        this.updateBusinessModel(roundProgress);
	        this.updateData(roundProgress);
	      }
	    }
	  }, {
	    key: "updateBusinessModel",
	    value: function updateBusinessModel(roundProgress) {
	      // Update business model
	      if (_utils2.default.isNotNull(this.businessModel) && this.businessModel.hasRendered()) {
	        var currentInvestments = this.getAllCurrentInvestments();
	        currentInvestments = currentInvestments.map(function (ti) {
	          return ti.type;
	        });
	        this.businessModel.setInvestments(currentInvestments);
	        this.businessModel.income = roundProgress.roundData.currentIncome;
	
	        var productIcon = roundProgress.productIcon;
	        var extraProductIcon = roundProgress.extraProductIcon;
	
	        if (_utils2.default.isNotNull(productIcon)) {
	          this.businessModel.setCompanyIcon(productIcon);
	        }
	
	        if (_utils2.default.isNotNull(extraProductIcon)) {
	          this.businessModel.setCompanyExtraProduct(extraProductIcon);
	        }
	      }
	    }
	  }, {
	    key: "updateData",
	    value: function updateData(roundProgress) {
	      var _this3 = this;
	
	      // Budget / Points
	      this.$element.find("[data-game-progress-round]").each(function (index, el) {
	        $(el).attr("data-game-progress-round", _this3.roundIndex).text(_this3.roundIndex);
	      });
	
	      this.$element.find("[data-game-progress-budget]").each(function (index, el) {
	        $(el).attr("data-game-progress-budget", roundProgress.roundData.currentBudget).text(roundProgress.roundData.currentBudget);
	      });
	
	      this.$element.find("[data-game-progress-points]").each(function (index, el) {
	        $(el).attr("data-game-progress-points", roundProgress.roundData.currentPoints).text(roundProgress.roundData.currentPoints);
	      });
	
	      // Event
	      this.$element.find("[data-game-progress-event]").each(function (index, el) {
	        var eventType = _utils2.default.isNotNull(roundProgress.event) ? roundProgress.event.type : null;
	        var $el = $(el);
	        $el.attr("data-game-progress-event", _utils2.default.isNull(eventType) ? "" : eventType);
	
	        $el.empty();
	
	        if (_utils2.default.isNotNull(roundProgress.event)) {
	          var $icon = $("<div class=\"gp__event-icon\">" + GameProgressView.getEventIconForType(eventType) + "</div>");
	          var $label = $("<div class=\"gp__event-label\">" + roundProgress.event.title + "</div>");
	
	          $el.append($icon).append($label);
	        } else {
	          $el.append("<div class=\"gp__event-label mx-auto text-center\">" + _languageManager2.default.getValueForKey("teacher_platform.game_progress.data.no_event.label") + "</div>");
	        }
	      });
	
	      // Investments
	      this.$element.find("[data-game-progress-investment-1]").each(function (index, el) {
	        var investment1 = roundProgress.investments.find(function (i) {
	          return i.key === roundProgress.roundData.investmentKey1;
	        });
	        var investmentType = _utils2.default.isNotNull(investment1) ? investment1.type : null;
	        var $el = $(el);
	        $el.attr("data-game-progress-investment-1", _utils2.default.isNull(investmentType) ? "" : investmentType);
	
	        $el.empty();
	
	        if (_utils2.default.isNotNull(investment1)) {
	          var $icon = $("<div class=\"gp__investment-icon\">" + GameProgressView.getInvestmentIconForType(investmentType) + "</div>");
	          $icon.addClass("gp-investment__" + investmentType);
	          var $label = $("<div class=\"gp__investment-label\">" + _languageManager2.default.getValueForKey("serious_game.business_model.investments.front.titles." + investmentType) + "</div>");
	
	          $el.append($icon).append($label);
	        } else {
	          $el.append("<div class=\"gp__investment-label mx-auto text-center\">" + _languageManager2.default.getValueForKey("teacher_platform.game_progress.data.investment_not_used.label") + "</div>");
	        }
	      });
	
	      this.$element.find("[data-game-progress-investment-2]").each(function (index, el) {
	        var investment2 = roundProgress.investments.find(function (i) {
	          return i.key === roundProgress.roundData.investmentKey2;
	        });
	        var investmentType = _utils2.default.isNotNull(investment2) ? investment2.type : null;
	        var $el = $(el);
	        $el.attr("data-game-progress-investment-2", _utils2.default.isNull(investmentType) ? "" : investmentType);
	
	        $el.empty();
	
	        if (_utils2.default.isNotNull(investment2)) {
	          var $icon = $("<div class=\"gp__investment-icon\">" + GameProgressView.getInvestmentIconForType(investmentType) + "</div>");
	          $icon.addClass("gp-investment__" + investmentType);
	          var $label = $("<div class=\"gp__investment-label\">" + _languageManager2.default.getValueForKey("serious_game.business_model.investments.front.titles." + investmentType) + "</div>");
	
	          $el.append($icon).append($label);
	        } else {
	          $el.append("<div class=\"gp__investment-label mx-auto text-center\">" + _languageManager2.default.getValueForKey("teacher_platform.game_progress.data.investment_not_used.label") + "</div>");
	        }
	      });
	    }
	  }, {
	    key: "onChangeRoundEvent",
	    value: function onChangeRoundEvent(e) {
	      log.info("Clicked on change round button - %o", e);
	      var $this = $(e.currentTarget);
	      var roundIndex = parseInt($this.data("gp-round-index"));
	
	      if (this.canViewGameProgress(roundIndex)) {
	        this.$element.find(".game-progress__round-selector li.active").removeClass("active");
	        $this.parent().addClass("active");
	
	        if (_utils2.default.isNumber(roundIndex)) {
	          this.roundIndex = roundIndex;
	          this.update();
	        }
	      }
	    }
	  }, {
	    key: "getAllCurrentInvestments",
	    value: function getAllCurrentInvestments() {
	      var investments = [];
	
	      for (var roundIndex in this.roundProgressMap) {
	        if (roundIndex > this.roundIndex) break;
	
	        if (this.roundProgressMap.hasOwnProperty(roundIndex)) {
	          investments = investments.concat(this.roundProgressMap[roundIndex].investments);
	        }
	      }
	
	      return investments;
	    }
	  }, {
	    key: "canViewGameProgress",
	    value: function canViewGameProgress(roundIndex) {
	      if (_utils2.default.isNull(roundIndex) || !_utils2.default.isNumber(roundIndex) || _utils2.default.isNull(this.roundProgressMap) || !this.roundProgressMap.hasOwnProperty(roundIndex)) return false;
	
	      var roundProgress = this.roundProgressMap[roundIndex];
	
	      if (_utils2.default.isNull(roundProgress)) {
	        log.error("Round progress for round [%d] not found - %o", roundIndex, this.roundProgress);
	        return false;
	      }
	
	      return _utils2.default.isNotNull(roundProgress.roundData.closed);
	    }
	  }, {
	    key: "roundProgressMap",
	    get: function get() {
	      return this._roundProgressMap;
	    },
	    set: function set(roundProgressMap) {
	      this._roundProgressMap = roundProgressMap;
	      this.setUpChangeRoundButtons();
	    }
	  }, {
	    key: "roundIndex",
	    get: function get() {
	      return this._roundIndex;
	    },
	    set: function set(roundIndex) {
	      this._roundIndex = roundIndex;
	      this.setUpChangeRoundButtons();
	    }
	  }], [{
	    key: "getEventIconForType",
	    value: function getEventIconForType(eventType) {
	      var eventIconKey = "./" + eventType + ".svg";
	      if (eventIcons.keys().includes(eventIconKey)) {
	        return eventIcons(eventIconKey);
	      }
	
	      return null;
	    }
	  }, {
	    key: "getInvestmentIconForType",
	    value: function getInvestmentIconForType(investmentType) {
	      var requireKey = "./" + investmentType + ".svg";
	
	      if (iconCardsReq.keys().includes(requireKey)) {
	        return iconCardsReq(requireKey);
	      }
	
	      return null;
	    }
	  }]);
	
	  return GameProgressView;
	}();
	
	module.exports = GameProgressView;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),

/***/ 350:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utils = __webpack_require__(3);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _request = __webpack_require__(186);
	
	var _request2 = _interopRequireDefault(_request);
	
	var _appError = __webpack_require__(51);
	
	var _appError2 = _interopRequireDefault(_appError);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var log = __webpack_require__(5)();
	
	
	var GameSessionServices = {};
	
	(function (GameSessionServices) {
	  GameSessionServices.getGameSessions = function () {
	    return _request2.default.get({
	      url: _utils2.default.getServiceUrl("/game-sessions"),
	      cache: false,
	      dataType: _request2.default.DATA_TYPES.JSON
	    }).then(function (data) {
	      if (data.result === "success") {
	        return data.data;
	      } else {
	        throw new _appError2.default({
	          code: null,
	          message: null,
	          data: data,
	          exception: new Error("Unexpected result from request")
	        });
	      }
	    });
	  };
	
	  GameSessionServices.createGameSession = function (gameSession) {
	    return _request2.default.post({
	      url: _utils2.default.getServiceUrl("/game-sessions"),
	      cache: false,
	      dataType: _request2.default.DATA_TYPES.JSON,
	      contentType: _request2.default.CONTENT_TYPES.APPLICATION_JSON,
	      data: gameSession
	    });
	  };
	
	  GameSessionServices.removeGameSession = function (gameSessionId) {
	    return _request2.default.delete({
	      url: _utils2.default.getServiceUrl("/game-sessions/" + gameSessionId + "?for-sessionid=true"),
	      cache: false,
	      dataType: _request2.default.DATA_TYPES.JSON
	    });
	  };
	
	  GameSessionServices.duplicateGameSession = function (gameSessionId) {
	    return _request2.default.post({
	      url: _utils2.default.getServiceUrl("/game-sessions/" + gameSessionId + "/duplicate?for-sessionid=true"),
	      cache: false,
	      dataType: _request2.default.DATA_TYPES.JSON
	    });
	  };
	
	  GameSessionServices.removeTeamFromGameSession = function (teamName, gameSessionId) {
	    return _request2.default.post({
	      url: _utils2.default.getServiceUrl("/game-sessions/" + gameSessionId + "/remove-team?for-sessionid=true"),
	      cache: false,
	      data: {
	        "team-name": teamName
	      }
	    });
	  };
	
	  GameSessionServices.goToSession = function (gameSessionId) {
	    _utils2.default.redirect("/teacher/sessions/" + gameSessionId);
	  };
	})(GameSessionServices);
	
	exports.default = GameSessionServices;

/***/ }),

/***/ 351:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	/**
	 * Created by jv on 31/05/2017.
	 */
	var utils = __webpack_require__(3);
	var request = __webpack_require__(186);
	
	var uploadService = {};
	
	(function (UploadService) {
	  UploadService.uploadFiles = function (files, successCb, failCb) {
	    if (!utils.isArray(files)) {
	      if (utils.isFunction(failCb)) {
	        failCb();
	      }
	
	      return;
	    }
	
	    var url = utils.getServiceUrl("/upload");
	    uploadFiles(url, files, successCb, failCb).then(function (data) {
	      if (utils.isNotNull(data) && data.hasOwnProperty("data") && utils.isNotNull(data.data)) {
	        var result = utils.parseJSON(data.data, true);
	
	        if (utils.isFunction(successCb)) {
	          successCb(result);
	        }
	      } else {
	        if (utils.isFunction(failCb)) {
	          failCb();
	        }
	      }
	    }).catch(function (err) {
	      if (utils.isFunction(failCb)) {
	        failCb(err);
	      }
	    });
	  };
	
	  UploadService.uploadResources = function (files, successCb, failCb) {
	    var url = utils.getServiceUrl("/upload-resources");
	    return uploadFiles(url, files, successCb, failCb);
	  };
	
	  function uploadFiles(url, files) {
	    var formData = new FormData();
	    for (var i = 0; i < files.length; i++) {
	      formData.append(files[i].name, files[i].data);
	    }
	
	    return request.post({
	      url: url,
	      data: formData,
	      cache: false,
	      contentType: false,
	      processData: false,
	      dataType: "json",
	      enctype: "multipart/form-data"
	    });
	  }
	})(uploadService);
	
	module.exports = uploadService;

/***/ }),

/***/ 352:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Created by jv on 16/05/2017.
	 */
	var utils = __webpack_require__(3);
	
	var ANIMATION_DURATION = 300;
	
	module.exports = function () {
	  function DialogTemplate(options) {
	    _classCallCheck(this, DialogTemplate);
	
	    if (utils.isNull(options)) {
	      throw "options must be defined";
	    }
	
	    this.dialogId = utils.isNotNull(options.dialogId) ? options.dialogId : utils.generateUIDShort();
	    this.backdropIdSuffix = "-modal-backdrop";
	    this.title = options.title;
	    this.dialogContent = options.dialogContent;
	    this.disposable = utils.isBoolean(options.disposable) ? options.disposable : true;
	
	    this.confirmText = options.confirmText;
	    this.cancelText = options.cancelText;
	    this.cancelTopRight = utils.isBoolean(options.cancelTopRight) ? options.cancelTopRight : false;
	
	    this.onConfirm = options.onConfirm;
	    this.onCancel = options.onCancel;
	    this.onDispose = options.onDispose;
	
	    this.create();
	  }
	
	  _createClass(DialogTemplate, [{
	    key: "create",
	    value: function create() {
	      if (this._initialized !== true) {
	        this.renderDialog();
	
	        this.backdrop = "<div id='" + this.backdropId + "' class='modal-backdrop fade show'></div>";
	
	        this.dialogEl.appendTo("body");
	
	        if (this.disposable) {
	          this.addDisposeListener();
	        }
	
	        this._initialized = true;
	      }
	    }
	  }, {
	    key: "renderDialog",
	    value: function renderDialog() {
	      this.dialogEl = $("<div id='" + this.dialogId + "' class='modal fade' style='display: block;'>" + "<div class='modal-dialog modal-dialog-centered'>" + "<div class='modal-content clearfix'>" + "</div>" + "</div>" + "</div>");
	
	      this.renderDialogHeader();
	      this.renderDialogContent();
	      this.renderDialogFooter();
	    }
	  }, {
	    key: "renderDialogHeader",
	    value: function renderDialogHeader() {
	      var dialogContentEl = this.dialogEl.find(".modal-content");
	
	      if (utils.isNotNull(dialogContentEl) && dialogContentEl.length) {
	        var dialogHeader = "<div class='modal-header'><h4 class='dialog-title'>" + this.title + "</h4></div>";
	        dialogContentEl.append(dialogHeader);
	      }
	    }
	  }, {
	    key: "renderDialogContent",
	    value: function renderDialogContent() {
	      var dialogContentEl = this.dialogEl.find(".modal-content");
	
	      if (utils.isNotNull(dialogContentEl) && dialogContentEl.length) {
	        var dialogBodyEl = $("<div class='modal-body'></div>");
	        dialogBodyEl.append(this.dialogContent);
	
	        dialogContentEl.append(dialogBodyEl);
	      }
	    }
	  }, {
	    key: "renderDialogFooter",
	    value: function renderDialogFooter() {
	      var that = this;
	      var dialogContentEl = that.dialogEl.find(".modal-content");
	
	      var isCms = $("body").hasClass("cms");
	
	      if (utils.isNotNull(dialogContentEl) && dialogContentEl.length) {
	        var dialogFooterEl = $("<div class='modal-footer'></div>");
	
	        if (utils.isNotNull(that.confirmText)) {
	          var confirmBtn = $("<button class='btn btn-c-light-blue dialog-confirm-btn' type='button'>" + that.confirmText + "</button>");
	
	          if (isCms) {
	            confirmBtn.removeClass("btn-c-light-blue").addClass("btn-c-green text-white");
	          }
	
	          confirmBtn.on("click", function (e) {
	            if (utils.isFunction(that.onConfirm)) {
	              that.onConfirm();
	            }
	          });
	
	          dialogFooterEl.append(confirmBtn);
	        }
	
	        if (utils.isNotNull(that.cancelText) || that.cancelTopRight === true) {
	          var classNames = "btn btn-c-light-blue dialog-cancel-btn";
	          var innerHTML = that.cancelText;
	
	          if (that.cancelTopRight) {
	            classNames = "btn btn-icon frameless cross-circle dark-grey pull-right";
	            innerHTML = "";
	          }
	
	          var cancelBtn = $("<button class='" + classNames + "' type='button'>" + innerHTML + "</button>");
	
	          if (isCms && !that.cancelTopRight) {
	            cancelBtn.removeClass("btn-c-light-blue").addClass("btn-c-green text-white");
	          }
	
	          cancelBtn.on("click", function () {
	            that.cancel();
	          });
	
	          if (that.cancelTopRight) {
	            that.dialogEl.find(".modal-content").prepend(cancelBtn);
	          } else {
	            dialogFooterEl.append(cancelBtn);
	          }
	        }
	
	        dialogContentEl.append(dialogFooterEl);
	      }
	    }
	  }, {
	    key: "destroy",
	    value: function destroy() {
	      var that = this;
	
	      if (utils.isNotNull(that.dialogEl) && that.dialogEl.length && that._destroying !== true) {
	        that._destroying = true;
	
	        that.hide(function () {
	          that.dialogEl.remove();
	          that._initialized = false;
	          that._destroying = false;
	        });
	      }
	    }
	  }, {
	    key: "show",
	    value: function show(addBackdrop) {
	      var $body = $("body");
	      if (!$body.hasClass("modal-open")) {
	        $body.addClass("modal-open");
	      }
	
	      if (!this.backdropExists && addBackdrop !== false) {
	        $body.append(this.backdrop);
	      }
	
	      // Reading a css property forces layout to be computed
	      this.dialogEl.show().css("width");
	      this.dialogEl.addClass("show");
	    }
	  }, {
	    key: "hide",
	    value: function hide(callback) {
	      var that = this;
	      var $body = $("body");
	      if ($body.hasClass("modal-open")) {
	        $body.removeClass("modal-open");
	      }
	
	      var $backdrop = $("#" + this.backdropId);
	
	      if (utils.isNotNull($backdrop) && $backdrop.length) {
	        $backdrop.remove();
	      }
	
	      this.dialogEl.removeClass("show");
	
	      setTimeout(function () {
	        that.dialogEl.hide();
	        if (utils.isFunction(callback)) {
	          callback();
	        }
	      }, ANIMATION_DURATION);
	    }
	  }, {
	    key: "cancel",
	    value: function cancel() {
	      this.hide();
	
	      if (utils.isFunction(this.onCancel)) {
	        this.onCancel();
	      }
	    }
	  }, {
	    key: "dispose",
	    value: function dispose() {
	      this.hide();
	
	      if (utils.isFunction(this.onDispose)) {
	        this.onDispose();
	      }
	    }
	  }, {
	    key: "addDisposeListener",
	    value: function addDisposeListener() {
	      var that = this;
	
	      that.dialogEl.off().on("click", function (e) {
	        if (e.target.className === "modal-content" || $(e.target).closest(".modal-content").length) {
	          e.stopPropagation();
	          return;
	        }
	        that.dispose();
	      });
	    }
	  }, {
	    key: "backdropId",
	    get: function get() {
	      return this.dialogId + this.backdropIdSuffix;
	    }
	  }, {
	    key: "backdropExists",
	    get: function get() {
	      return $("#" + this.backdropId).length;
	    }
	  }]);
	
	  return DialogTemplate;
	}();
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),

/***/ 353:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var utils = __webpack_require__(3);
	var LanguageManager = __webpack_require__(6);
	var DialogTemplate = __webpack_require__(352);
	
	var dialog = {};
	
	(function (Dialog) {
	  Dialog.showMessageDialog = function (options) {
	    var messageDialog = new DialogTemplate({
	      title: LanguageManager.getValueForKey(options.title),
	      dialogContent: LanguageManager.getValueForKey(options.message),
	      confirmText: LanguageManager.getValueForKey("modal.buttons.ok"),
	      disposable: options.disposable,
	      onConfirm: function onConfirm() {
	        messageDialog.destroy();
	
	        if (utils.isFunction(options.onConfirm)) {
	          options.onConfirm();
	        }
	      },
	      onCancel: function onCancel() {
	        messageDialog.destroy();
	      },
	      onDispose: function onDispose() {
	        messageDialog.destroy();
	
	        if (utils.isFunction(options.onDispose)) {
	          options.onDispose();
	        }
	      }
	    });
	
	    messageDialog.show();
	
	    return messageDialog;
	  };
	
	  Dialog.showOkCancelDialog = function (options) {
	    var okCancelDialog = new DialogTemplate({
	      title: LanguageManager.getValueForKey(options.title),
	      dialogContent: LanguageManager.getValueForKey(options.message),
	      confirmText: LanguageManager.getValueForKey("modal.buttons.ok"),
	      cancelText: LanguageManager.getValueForKey("modal.buttons.cancel"),
	      disposable: options.disposable,
	      onConfirm: function onConfirm() {
	        okCancelDialog.destroy();
	
	        if (utils.isFunction(options.onOk)) {
	          options.onOk();
	        }
	      },
	      onCancel: function onCancel() {
	        okCancelDialog.destroy();
	
	        if (utils.isFunction(options.onCancel)) {
	          options.onCancel();
	        }
	      },
	      onDispose: function onDispose() {
	        okCancelDialog.destroy();
	
	        if (utils.isFunction(options.onDispose)) {
	          options.onDispose();
	        }
	      }
	    });
	
	    okCancelDialog.show();
	
	    return okCancelDialog;
	  };
	
	  Dialog.showYesNoDialog = function (options) {
	    var yesNoDialog = new DialogTemplate({
	      title: LanguageManager.getValueForKey(options.title),
	      dialogContent: LanguageManager.getValueForKey(options.message),
	      confirmText: LanguageManager.getValueForKey("modal.buttons.yes"),
	      cancelText: LanguageManager.getValueForKey("modal.buttons.no"),
	      disposable: options.disposable,
	      onConfirm: function onConfirm() {
	        yesNoDialog.destroy();
	
	        if (utils.isFunction(options.onYes)) {
	          options.onYes();
	        }
	      },
	      onCancel: function onCancel() {
	        yesNoDialog.destroy();
	
	        if (utils.isFunction(options.onNo)) {
	          options.onNo();
	        }
	      },
	      onDispose: function onDispose() {
	        yesNoDialog.destroy();
	
	        if (utils.isFunction(options.onDispose)) {
	          options.onDispose();
	        }
	      }
	    });
	
	    yesNoDialog.show();
	
	    return yesNoDialog;
	  };
	})(dialog);
	
	module.exports = dialog;

/***/ }),

/***/ 467:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Created by jv on 2019-08-23 (13:53).
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */
	
	
	var _utils = __webpack_require__(3);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _appError = __webpack_require__(51);
	
	var _appError2 = _interopRequireDefault(_appError);
	
	var _roadUtils = __webpack_require__(342);
	
	var _roadUtils2 = _interopRequireDefault(_roadUtils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var log = __webpack_require__(5)();
	
	var PowerGrid = function () {
	  function PowerGrid(options) {
	    _classCallCheck(this, PowerGrid);
	
	    if (_utils2.default.isNull(options)) throw new _appError2.default({ exception: new Error("Options for BusinessModel cannot be null") });
	
	    this.businessModel = options.businessModel;
	
	    this.id = this.businessModel.id;
	
	    this.containerElement = this.businessModel.containerElement;
	    this.layoutData = this.businessModel.layoutData;
	
	    this.canvas = this.businessModel.canvas;
	    this.powerGridGroup = null;
	
	    this.powerCabinets = [];
	    this.powerLines = [];
	
	    this.activePowerLines = [];
	
	    // this.shouldAbortAnimations = false;
	
	    this.onRenderComplete = options.onRenderComplete;
	  }
	
	  _createClass(PowerGrid, [{
	    key: "render",
	    value: function render() {
	      this.powerGridGroup = new fabric.Group([], {
	        hasBorders: false,
	        hasControls: false,
	        selectable: false,
	        evented: false,
	        reference: false,
	        movable: false,
	        visible: false,
	        objectCaching: false
	      });
	
	      this.canvas.add(this.powerGridGroup);
	
	      this.renderCabinets();
	      this.renderPowerLines();
	
	      this._checkRenderComplete();
	    }
	  }, {
	    key: "_checkRenderComplete",
	    value: function _checkRenderComplete() {
	      if (this.hasRendered() && _utils2.default.isFunction(this.onRenderComplete)) {
	        this.powerGridGroup.visible = true;
	
	        this.onRenderComplete.call(this);
	      }
	    }
	  }, {
	    key: "hasRendered",
	    value: function hasRendered() {
	      var powerCabinetsRendered = Object.keys(this.layoutData.powerCabinets).length === this.powerCabinets.length;
	      var powerLinesRendered = this.layoutData.powerLines.length === this.powerLines.length;
	
	      return powerCabinetsRendered && powerLinesRendered;
	    }
	  }, {
	    key: "renderCabinets",
	    value: function renderCabinets() {
	      var _this = this;
	
	      for (var powerCabinetKey in this.layoutData.powerCabinets) {
	        if (this.layoutData.powerCabinets.hasOwnProperty(powerCabinetKey)) {
	          this.makePowerCabinet(this.layoutData.powerCabinets[powerCabinetKey]).then(function (powerCabinetGroup) {
	            _this._checkRenderComplete();
	          });
	        }
	      }
	    }
	  }, {
	    key: "makePowerCabinet",
	    value: function makePowerCabinet(powerCabinet) {
	      var _this2 = this;
	
	      return this.businessModel.loadSvg(this.layoutData.powerGridSettings.cabinetIcon).then(function (fabricObj) {
	        var powerCabinetGroup = {
	          data: powerCabinet
	        };
	
	        fabricObj.originX = "center";
	        fabricObj.originY = "center";
	
	        fabricObj.top = powerCabinet.position.y;
	        fabricObj.left = powerCabinet.position.x;
	
	        fabricObj.scaleToWidth(_this2.layoutData.powerGridSettings.cabinetSize.width);
	        fabricObj.scaleToHeight(_this2.layoutData.powerGridSettings.cabinetSize.height);
	
	        fabricObj.evented = false;
	        fabricObj.selectable = false;
	        fabricObj.hasBorders = false;
	        fabricObj.hasControls = false;
	        fabricObj.reference = false;
	
	        _this2.powerGridGroup.addWithUpdate(fabricObj);
	
	        powerCabinetGroup.powerCabinetObj = fabricObj;
	        _this2.powerCabinets.push(powerCabinetGroup);
	
	        return powerCabinetGroup;
	      }).catch(function (error) {
	        log.error("Failed to load cabinet icon - %o", error);
	      });
	    }
	  }, {
	    key: "renderPowerLines",
	    value: function renderPowerLines() {
	      var _this3 = this;
	
	      for (var i = 0; i < this.layoutData.powerLines.length; i++) {
	        this.makePowerLine(this.layoutData.powerLines[i]).then(function (powerLineGroup) {
	          _this3._checkRenderComplete();
	        });
	      }
	    }
	  }, {
	    key: "makePowerLine",
	    value: function makePowerLine(powerLine) {
	      var _this4 = this;
	
	      return new Promise(function (resolve, reject) {
	        var powerLineGroup = {
	          data: powerLine,
	          pylons: [],
	          activeIcons: []
	        };
	
	        var outerWidth = _this4.layoutData.powerGridSettings.outerWidth,
	            innerWidth = _this4.layoutData.powerGridSettings.innerWidth;
	
	        log.debug("Drawing power line '%s'", powerLine.key);
	
	        var connectionsRendered = 0;
	
	        for (var i = 0; i < powerLine.connections.length; i++) {
	          var connection = powerLine.connections[i];
	          var startPosition = connection.startPosition;
	          var endPosition = connection.endPosition;
	
	          var pathString1 = _roadUtils2.default.getPathStringForNavigationOutline(startPosition, connection.navigation, endPosition, outerWidth, "left");
	          var pathString2 = _roadUtils2.default.getPathStringForNavigationOutline(startPosition, connection.navigation, endPosition, outerWidth, "right");
	
	          var pathString = pathString1 + " " + pathString2;
	          pathString.trim();
	
	          log.debug("Path string for road: %s", pathString);
	
	          powerLineGroup.strokePath = _this4.drawPowerLine(pathString);
	
	          connectionsRendered++;
	        }
	
	        var pylonsRendered = 0;
	
	        for (var _i = 0; _i < powerLine.pylons.length; _i++) {
	          _this4.drawElectricityPylon(powerLine.pylons[_i], powerLineGroup).then(function (pylonObj) {
	            pylonsRendered++;
	            checkPowerLineRendered.call(_this4, connectionsRendered, pylonsRendered, activeIconsRendered);
	          });
	        }
	
	        var activeIconsRendered = 0;
	
	        for (var _i2 = 0; _i2 < powerLine.activeIcons.length; _i2++) {
	          _this4.drawPowerLineActiveIcon(powerLine.activeIcons[_i2], powerLineGroup).then(function (activeIconObj) {
	            activeIconsRendered++;
	            checkPowerLineRendered.call(_this4, connectionsRendered, pylonsRendered, activeIconsRendered);
	          });
	        }
	
	        _this4.powerLines.push(powerLineGroup);
	
	        function checkPowerLineRendered(connectionsRendered, pylonsRendered, activeIconsRendered) {
	          var powerLineRendered = powerLine.connections.length === connectionsRendered;
	          powerLineRendered = powerLineRendered && powerLine.pylons.length === pylonsRendered;
	          powerLineRendered = powerLineRendered && powerLine.activeIcons.length === activeIconsRendered;
	
	          if (powerLineRendered) {
	            resolve(powerLineGroup);
	          }
	        }
	      });
	    }
	  }, {
	    key: "drawPowerLine",
	    value: function drawPowerLine(pathString) {
	      var innerWidth = this.layoutData.powerGridSettings.innerWidth,
	          outerWidth = this.layoutData.powerGridSettings.outerWidth;
	
	      /*let background = new fabric.Path(pathString, {
	        fill: "transparent",
	        stroke: this.layoutData.powerGridSettings.backgroundColor,
	        // stroke: "red",
	        strokeWidth: innerWidth
	      });*/
	
	      var powerLine = new fabric.Path(pathString, {
	        fill: "transparent",
	        stroke: this.layoutData.powerGridSettings.strokeColor,
	        strokeWidth: (outerWidth - innerWidth) / 2,
	        hasBorders: false,
	        hasControls: false,
	        selectable: false,
	        evented: false,
	        reference: false
	      });
	
	      this.powerGridGroup.addWithUpdate(powerLine);
	
	      return powerLine;
	    }
	  }, {
	    key: "drawPowerLineActiveIcon",
	    value: function drawPowerLineActiveIcon(position, powerLineGroup) {
	      var _this5 = this;
	
	      return this.businessModel.loadSvg(this.layoutData.powerGridSettings.activeIcon).then(function (fabricObj) {
	        fabricObj.originX = "center";
	        fabricObj.originY = "center";
	
	        fabricObj.top = position.y;
	        fabricObj.left = position.x;
	
	        /*this.canvas.add(new fabric.Line([fabricObj.left, fabricObj.top - 50, fabricObj.left, fabricObj.top + 50], {
	          stroke: "red"
	        }));
	        this.canvas.add(new fabric.Line([fabricObj.left - 50, fabricObj.top, fabricObj.left + 50, fabricObj.top], {
	          stroke: "red"
	        }));*/
	
	        fabricObj.scaleToWidth(_this5.layoutData.powerGridSettings.activeIconSize.width);
	        fabricObj.scaleToHeight(_this5.layoutData.powerGridSettings.activeIconSize.height);
	
	        fabricObj.evented = false;
	        fabricObj.selectable = false;
	        fabricObj.hasBorders = false;
	        fabricObj.hasControls = false;
	        fabricObj.reference = false;
	
	        fabricObj.visible = false;
	
	        _this5.powerGridGroup.addWithUpdate(fabricObj);
	
	        powerLineGroup.activeIcons.push(fabricObj);
	
	        return fabricObj;
	      }).catch(function (error) {
	        log.error("Failed to load active power line icon - %o", error);
	      });
	    }
	  }, {
	    key: "drawElectricityPylon",
	    value: function drawElectricityPylon(position, powerLineGroup) {
	      var _this6 = this;
	
	      return this.businessModel.loadSvg(this.layoutData.powerGridSettings.pylonIcon).then(function (fabricObj) {
	        fabricObj.originX = "center";
	        fabricObj.originY = "center";
	
	        fabricObj.top = position.y;
	        fabricObj.left = position.x;
	
	        /*this.canvas.add(new fabric.Line([fabricObj.left, fabricObj.top - 50, fabricObj.left, fabricObj.top + 50], {
	          stroke: "red"
	        }));
	        this.canvas.add(new fabric.Line([fabricObj.left - 50, fabricObj.top, fabricObj.left + 50, fabricObj.top], {
	          stroke: "red"
	        }));*/
	
	        fabricObj.scaleToWidth(_this6.layoutData.powerGridSettings.pylonSize.width);
	        fabricObj.scaleToHeight(_this6.layoutData.powerGridSettings.pylonSize.height);
	
	        fabricObj.evented = false;
	        fabricObj.selectable = false;
	        fabricObj.hasBorders = false;
	        fabricObj.hasControls = false;
	        fabricObj.reference = false;
	
	        _this6.powerGridGroup.addWithUpdate(fabricObj);
	
	        powerLineGroup.pylons.push(fabricObj);
	
	        return fabricObj;
	      }).catch(function (error) {
	        log.error("Failed to load pylon icon - %o", error);
	      });
	    }
	  }, {
	    key: "previewPowerlines",
	    value: function previewPowerlines(points, color) {
	      for (var i = 0; i < points.length; i++) {
	        var startPoint = points[i].startPoint;
	        var endPoint = points[i].endPoint;
	
	        log.info("Previewing power line from '%s' to '%s'", startPoint, endPoint);
	
	        var foundPowerLine = null;
	
	        for (var _i3 = 0; _i3 < this.powerLines.length; _i3++) {
	          var powerLineGroup = this.powerLines[_i3];
	          var powerLineData = powerLineGroup.data;
	
	          if (powerLineData.connects.includes(startPoint) && powerLineData.connects.includes(endPoint)) {
	            foundPowerLine = powerLineGroup;
	          }
	        }
	
	        if (_utils2.default.isNotNull(foundPowerLine)) {
	          foundPowerLine.strokePath.set({ stroke: color });
	
	          return foundPowerLine.strokePath;
	        } else {
	          log.error("No power line found for start point [%s] and end point [%s]", startPoint, endPoint);
	        }
	      }
	    }
	  }, {
	    key: "activatePowerLines",
	    value: function activatePowerLines(points) {
	      for (var i = 0; i < points.length; i++) {
	        this.activatePowerLine(points[i].startPoint, points[i].endPoint);
	      }
	    }
	  }, {
	    key: "activatePowerLine",
	    value: function activatePowerLine(startPoint, endPoint) {
	      log.info("Activating power line from '%s' to '%s'", startPoint, endPoint);
	
	      var foundPowerLine = null;
	
	      for (var i = 0; i < this.powerLines.length; i++) {
	        var powerLineGroup = this.powerLines[i];
	        var powerLineData = powerLineGroup.data;
	
	        if (powerLineData.connects.includes(startPoint) && powerLineData.connects.includes(endPoint)) {
	          foundPowerLine = powerLineGroup;
	          break;
	        }
	      }
	
	      if (_utils2.default.isNotNull(foundPowerLine)) {
	        for (var _i4 = 0; _i4 < this.activePowerLines.length; _i4++) {
	          var _powerLineGroup = this.activePowerLines[_i4];
	
	          if (_powerLineGroup.data.key === foundPowerLine.data.key) {
	            log.error("Power line [%s] already active", foundPowerLine.data.key);
	            return;
	          }
	        }
	
	        foundPowerLine.strokePath.set({
	          stroke: this.layoutData.powerGridSettings.strokeColorActive
	        });
	
	        for (var j = 0; j < foundPowerLine.activeIcons.length; j++) {
	          var activeIcon = foundPowerLine.activeIcons[j];
	          activeIcon.visible = true;
	        }
	
	        this.activePowerLines.push(foundPowerLine);
	
	        this.canvas.renderAll();
	      } else {
	        log.error("No power line found for start point [%s] and end point [%s]", startPoint, endPoint);
	      }
	    }
	  }, {
	    key: "deactivateAllPowerLines",
	    value: function deactivateAllPowerLines() {
	      for (var i = this.activePowerLines.length - 1; i >= 0; i--) {
	        var powerLineGroup = this.activePowerLines[i];
	        this._deactivatePowerLine(powerLineGroup, i);
	      }
	    }
	  }, {
	    key: "deactivatePowerLines",
	    value: function deactivatePowerLines(points) {
	      for (var i = 0; i < points.length; i++) {
	        this.deactivatePowerLine(points[i].startPoint, points[i].endPoint);
	      }
	    }
	  }, {
	    key: "deactivatePowerLine",
	    value: function deactivatePowerLine(startPoint, endPoint) {
	      log.info("Deactivating power line from '%s' to '%s'", startPoint, endPoint);
	
	      var foundIndex = null;
	      var foundPowerLine = null;
	
	      for (var i = 0; i < this.activePowerLines.length; i++) {
	        var powerLineGroup = this.activePowerLines[i];
	        var powerLineData = powerLineGroup.data;
	
	        if (powerLineData.connects.includes(startPoint) && powerLineData.connects.includes(endPoint)) {
	          foundIndex = i;
	          foundPowerLine = powerLineGroup;
	          break;
	        }
	      }
	
	      if (_utils2.default.isNotNull(foundPowerLine)) {
	        this._deactivatePowerLine(foundPowerLine, foundIndex);
	      } else {
	        log.error("No power line found for start point [%s] and end point [%s]", startPoint, endPoint);
	      }
	    }
	  }, {
	    key: "_deactivatePowerLine",
	    value: function _deactivatePowerLine(powerLine, index) {
	      log.info("Deactivating power line %o", powerLine);
	
	      if (_utils2.default.isNotNull(powerLine)) {
	        powerLine.strokePath.set({
	          stroke: this.layoutData.powerGridSettings.strokeColor
	        });
	
	        for (var j = 0; j < powerLine.activeIcons.length; j++) {
	          var activeIcon = powerLine.activeIcons[j];
	          activeIcon.visible = false;
	        }
	
	        this.activePowerLines.splice(index, 1);
	
	        this.canvas.renderAll();
	      }
	    }
	  }, {
	    key: "abortAnimations",
	    value: function abortAnimations() {
	      // Note used in power grid since there are no animations here
	      // this.shouldAbortAnimations = true;
	    }
	  }]);
	
	  return PowerGrid;
	}();
	
	exports.default = PowerGrid;

/***/ }),

/***/ 468:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Created by jv on 2019-08-22 (11:36).
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */
	
	
	var _utils = __webpack_require__(3);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _appError = __webpack_require__(51);
	
	var _appError2 = _interopRequireDefault(_appError);
	
	var _constants = __webpack_require__(54);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	var _roadUtils = __webpack_require__(342);
	
	var _roadUtils2 = _interopRequireDefault(_roadUtils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var log = __webpack_require__(5)();
	
	var RoadMap = function () {
	  function RoadMap(options) {
	    _classCallCheck(this, RoadMap);
	
	    if (_utils2.default.isNull(options)) throw new _appError2.default({ exception: new Error("Options for BusinessModel cannot be null") });
	
	    this.businessModel = options.businessModel;
	
	    this.id = this.businessModel.id;
	
	    this.containerElement = this.businessModel.containerElement;
	    this.layoutData = this.businessModel.layoutData;
	
	    this.canvas = this.businessModel.canvas;
	    this.roadMapGroup = null;
	    this.crossingsGroup = null;
	
	    this.arrowGroups = {}; // Not a fabric obj
	
	    this.intersections = [];
	    this.roads = [];
	
	    this._templateRoadArrow = null;
	    this.activeConnections = [];
	    this.activeRoadsGroup = null;
	
	    this.previewGroup = null;
	
	    this.animationsRunning = 0;
	    this.shouldAbortAnimations = false;
	
	    this.onRenderComplete = options.onRenderComplete;
	  }
	
	  _createClass(RoadMap, [{
	    key: "render",
	    value: function render() {
	      var _this = this;
	
	      this.roadMapGroup = new fabric.Group([], {
	        hasBorders: false,
	        hasControls: false,
	        selectable: false,
	        evented: false,
	        reference: false,
	        movable: false
	      });
	
	      this.previewGroup = new fabric.Group([], {
	        hasBorders: false,
	        hasControls: false,
	        selectable: false,
	        evented: false,
	        reference: false,
	        movable: false
	      });
	
	      this.crossingsGroup = new fabric.Group([], {
	        hasBorders: false,
	        hasControls: false,
	        selectable: false,
	        evented: false,
	        reference: false
	      });
	
	      this.canvas.add(this.roadMapGroup);
	      this.canvas.add(this.previewGroup);
	      this.canvas.add(this.crossingsGroup);
	
	      for (var i = 0; i < this.layoutData.roads.length; i++) {
	        this.drawRoad(this.layoutData.roads[i]).then(function (roadGroup) {
	          _this._checkRenderComplete();
	        });
	      }
	
	      for (var intersectionKey in this.layoutData.intersections) {
	        if (this.layoutData.intersections.hasOwnProperty(intersectionKey)) {
	          this.drawIntersection(this.layoutData.intersections[intersectionKey], intersectionKey);
	        }
	      }
	
	      this.activeRoadsGroup = new fabric.Group([], {
	        hasBorders: false,
	        hasControls: false,
	        selectable: false,
	        evented: false,
	        reference: false,
	        movable: false,
	        objectCaching: false
	      });
	
	      this.canvas.add(this.activeRoadsGroup);
	
	      this.businessModel.loadSvg(this.layoutData.roadSettings.activeArrow).then(function (fabricObj) {
	        _this._templateRoadArrow = fabricObj;
	        _this._templateRoadArrow.left = 0;
	        _this._templateRoadArrow.top = 0;
	        _this._templateRoadArrow.visible = false;
	        _this._templateRoadArrow.originX = "center";
	        _this._templateRoadArrow.originY = "center";
	
	        _this.canvas.add(_this._templateRoadArrow);
	        _this._templateRoadArrow.scaleToHeight(_this.layoutData.roadSettings.dividerWidth * 2.5);
	
	        _this.drawArrows();
	
	        _this._checkRenderComplete();
	      }).catch(function (err) {
	        log.error("Failed to load template arrow for active road - %o", err);
	      });
	
	      this._checkRenderComplete();
	    }
	  }, {
	    key: "_checkRenderComplete",
	    value: function _checkRenderComplete() {
	      if (this.hasRendered() && _utils2.default.isFunction(this.onRenderComplete)) {
	        this.roadMapGroup.addWithUpdate();
	        this.roadMapGroup.setCoords();
	
	        this.setUpCanvasLayer();
	
	        this.canvas.renderAll();
	
	        this.onRenderComplete.call(this);
	      }
	    }
	  }, {
	    key: "setUpCanvasLayer",
	    value: function setUpCanvasLayer() {
	      this.canvas.bringToFront(this.activeRoadsGroup);
	      this.canvas.bringToFront(this.crossingsGroup);
	
	      for (var group in this.arrowGroups) {
	        if (this.arrowGroups.hasOwnProperty(group)) {
	          this.canvas.bringToFront(this.arrowGroups[group].fabricObj);
	        }
	      }
	    }
	  }, {
	    key: "hasRendered",
	    value: function hasRendered() {
	      var intersectionsRendered = Object.keys(this.layoutData.intersections).length === this.intersections.length;
	      var roadsRendered = this.layoutData.roads.length === this.roads.length;
	      var templateArrowRendered = _utils2.default.isNotNull(this._templateRoadArrow);
	
	      // log.debug("Intersections: %d/%d (rendered/required)\nRoads: %d/%d (rendered/required)", this.intersections.length, Object.keys(this.layoutData.intersections).length, this.roads.length, this.layoutData.roads.length);
	
	      return intersectionsRendered && roadsRendered && templateArrowRendered;
	    }
	  }, {
	    key: "drawIntersection",
	    value: function drawIntersection(intersection, key) {
	      this.businessModel.drawDebugInfo(key, intersection.position, "#FFAA00");
	
	      var intersectionGroup = {
	        data: intersection
	      };
	
	      var dividerWidth = this.layoutData.roadSettings.dividerWidth,
	          backgroundSize = this.layoutData.roadSettings.innerWidth,
	          outerSize = this.layoutData.roadSettings.outerWidth,
	          strokeWidth = (outerSize - backgroundSize) / 2;
	
	      var strokePathString = "";
	      var dividerPathString = "";
	
	      var intersectionTop = intersection.position.y - backgroundSize / 2 - strokeWidth / 2;
	      var intersectionRight = intersection.position.x + backgroundSize / 2 + strokeWidth / 2;
	      var intersectionBottom = intersection.position.y + backgroundSize / 2 + strokeWidth / 2;
	      var intersectionLeft = intersection.position.x - backgroundSize / 2 - strokeWidth / 2;
	
	      var intersectionCenter = {
	        x: intersection.position.x,
	        y: intersection.position.y
	      };
	
	      var dividerCenterSpacing = 5;
	      var dividerEdgeSpacing = 2;
	
	      if (intersection.connectionSides.includes(_constants2.default.DIRECTIONS.UP)) {
	        dividerPathString += " M " + intersectionCenter.x + " " + (intersectionCenter.y - dividerCenterSpacing) + " L " + intersectionCenter.x + " " + (intersectionTop + dividerEdgeSpacing);
	      } else {
	        strokePathString += " M " + intersectionLeft + " " + intersectionTop + " L " + intersectionRight + " " + intersectionTop;
	      }
	
	      if (intersection.connectionSides.includes(_constants2.default.DIRECTIONS.RIGHT)) {
	        dividerPathString += " M " + (intersectionCenter.x + dividerCenterSpacing) + " " + intersectionCenter.y + " L " + (intersectionRight - dividerEdgeSpacing) + " " + intersectionCenter.y;
	      } else {
	        strokePathString += " M " + intersectionRight + " " + intersectionTop + " L " + intersectionRight + " " + intersectionBottom;
	      }
	
	      if (intersection.connectionSides.includes(_constants2.default.DIRECTIONS.DOWN)) {
	        dividerPathString += " M " + intersectionCenter.x + " " + (intersectionCenter.y + dividerCenterSpacing) + " L " + intersectionCenter.x + " " + (intersectionBottom - dividerEdgeSpacing);
	      } else {
	        strokePathString += " M " + intersectionLeft + " " + intersectionBottom + " L " + intersectionRight + " " + intersectionBottom;
	      }
	
	      if (intersection.connectionSides.includes(_constants2.default.DIRECTIONS.LEFT)) {
	        dividerPathString += " M " + (intersectionCenter.x - dividerCenterSpacing) + " " + intersectionCenter.y + " L " + (intersectionLeft + dividerEdgeSpacing) + " " + intersectionCenter.y;
	      } else {
	        strokePathString += " M " + intersectionLeft + " " + intersectionTop + " L " + intersectionLeft + " " + intersectionBottom;
	      }
	
	      strokePathString.trim();
	      dividerPathString.trim();
	
	      var intersectionStroke = new fabric.Path(strokePathString, {
	        fill: "transparent",
	        stroke: this.layoutData.roadSettings.strokeColor,
	        strokeWidth: strokeWidth
	      });
	
	      var backgroundRect = new fabric.Rect({
	        width: outerSize,
	        height: outerSize,
	        top: intersection.position.y,
	        left: intersection.position.x,
	        fill: this.layoutData.roadSettings.roadColor,
	        originX: "center",
	        originY: "center"
	      });
	
	      var dividerPath = new fabric.Path(dividerPathString, {
	        fill: "",
	        stroke: this.layoutData.roadSettings.dividerColor,
	        strokeDashArray: this.layoutData.roadSettings.dividerDashArray,
	        // strokeDashArray: [2, 2],
	        strokeWidth: dividerWidth
	      });
	
	      var intersectionGroupObj = new fabric.Group([backgroundRect, intersectionStroke], {
	        hasBorders: false,
	        hasControls: false,
	        selectable: false,
	        evented: false,
	        reference: false
	      });
	
	      this.roadMapGroup.add(intersectionGroupObj);
	
	      intersectionGroup.backgroundObj = backgroundRect;
	      intersectionGroup.strokeObj = intersectionStroke;
	      // intersectionGroup.dividerObj = dividerPath;
	      intersectionGroup.groupObj = intersectionGroupObj;
	
	      this.intersections.push(intersectionGroup);
	    }
	  }, {
	    key: "drawRoad",
	    value: function drawRoad(road) {
	      var _this2 = this;
	
	      this.businessModel.drawDebugInfo(road.key, road.connections[0].startPosition, "#0000FF");
	
	      return new Promise(function (resolve, reject) {
	        var roadGroup = {
	          data: road,
	          crossings: []
	        };
	
	        /*
	          Path commands (https://developer.mozilla.org/en-US/docs/Web/SVG/Tutorial/Paths):
	          M = move to
	          L = line to
	            H = draw horizontal line
	            V = draw vertical line
	          C = cubic curve (2 control points, 1 end point)
	          Q = quadratic curve (1 control point, 1 end point)
	         */
	
	        var outerWidth = _this2.layoutData.roadSettings.outerWidth,
	            innerWidth = _this2.layoutData.roadSettings.innerWidth;
	
	        log.debug("Drawing road '%s'", road.key);
	
	        for (var i = 0; i < road.connections.length; i++) {
	          var connection = road.connections[i];
	          var startPosition = connection.startPosition;
	          var endPosition = connection.endPosition;
	
	          var pathString = _roadUtils2.default.getPathStringForNavigation(startPosition, connection.navigation, endPosition, innerWidth, outerWidth);
	
	          // log.debug("Path string for road: %s", pathString);
	
	          var fabricObjects = _this2.drawConnection(pathString, {
	            dividerWidth: _this2.layoutData.roadSettings.dividerWidth,
	            innerWidth: _this2.layoutData.roadSettings.innerWidth,
	            outerWidth: _this2.layoutData.roadSettings.outerWidth,
	
	            dividerColor: _this2.layoutData.roadSettings.dividerColor,
	            dividerDashArray: _this2.layoutData.roadSettings.dividerDashArray,
	
	            backgroundColor: _this2.layoutData.roadSettings.roadColor,
	
	            strokeColor: _this2.layoutData.roadSettings.strokeColor
	          });
	
	          roadGroup.dividerObj = fabricObjects.dividerObj;
	          roadGroup.backgroundObj = fabricObjects.backgroundObj;
	          roadGroup.strokeObj = fabricObjects.strokeObj;
	          roadGroup.groupObj = fabricObjects.groupObj;
	        }
	
	        if (_utils2.default.isNotNull(road.crossings) && road.crossings.length > 0) {
	          (function () {
	            var crossingsRendered = 0;
	
	            for (var _i = 0; _i < road.crossings.length; _i++) {
	              _this2.drawCrossing(road.crossings[_i], roadGroup).then(function (crossingObj) {
	                _this2.crossingsGroup.addWithUpdate(crossingObj);
	                crossingsRendered++;
	                checkRoadRendered.call(_this2, crossingsRendered);
	              });
	            }
	          })();
	        } else {
	          checkRoadRendered.call(_this2, 0);
	        }
	
	        function checkRoadRendered(crossingsRendered) {
	          /*if(utils.isNotNull(road.crossings))
	          {
	            log.debug("Road [%s] - crossings: %d/%d (rendered/required)", road.key, crossingsRendered, road.crossings.length);
	          }
	          else
	          {
	            log.debug("Road [%s] - has no crossings", road.key);
	          }*/
	
	          if (_utils2.default.isNull(road.crossings) || road.crossings.length === 0 || road.crossings.length === crossingsRendered) {
	            this.roads.push(roadGroup);
	            resolve(roadGroup);
	          }
	        }
	      });
	    }
	  }, {
	    key: "drawConnection",
	    value: function drawConnection(pathString, options) {
	      var dividerWidth = options.dividerWidth,
	          innerWidth = options.innerWidth,
	          outerWidth = options.outerWidth,
	          dividerColor = options.dividerColor,
	          dividerDashArray = options.dividerDashArray,
	          backgroundColor = options.backgroundColor,
	          strokeColor = options.strokeColor;
	
	      var group = [];
	
	      var path = void 0,
	          background = void 0,
	          roadStroke = void 0;
	
	      if (_utils2.default.isNotNull(dividerColor)) {
	        path = new fabric.Path(pathString, {
	          fill: "",
	          stroke: dividerColor,
	          strokeDashArray: dividerDashArray,
	          // strokeLinejoin: "miter",
	          // strokeMiterlimit: 3,
	          strokeWidth: dividerWidth
	        });
	      }
	
	      if (_utils2.default.isNotNull(backgroundColor)) {
	        background = new fabric.Path(pathString, {
	          fill: "transparent",
	          stroke: backgroundColor,
	          strokeWidth: innerWidth
	        });
	      }
	
	      if (_utils2.default.isNotNull(strokeColor)) {
	        roadStroke = new fabric.Path(pathString, {
	          fill: "transparent",
	          stroke: strokeColor,
	          strokeWidth: outerWidth
	        });
	      }
	
	      if (roadStroke) group.push(roadStroke);
	      if (background) group.push(background);
	      if (path) group.push(path);
	
	      var roadGroupObj = new fabric.Group(group, {});
	
	      var g = options.addToGroup || this.roadMapGroup;
	
	      if (options.addWithUpdate) {
	        g.addWithUpdate(roadGroupObj);
	      } else {
	        g.add(roadGroupObj);
	      }
	
	      return {
	        dividerObj: path,
	        backgroundObj: background,
	        strokeObj: roadStroke,
	        groupObj: roadGroupObj
	      };
	    }
	  }, {
	    key: "drawActiveConnection",
	    value: function drawActiveConnection(pathString, options) {
	      var dividerWidth = options.dividerWidth,
	          innerWidth = options.innerWidth,
	          dividerColor = options.dividerColor,
	          backgroundColor = options.backgroundColor;
	
	      var points = _roadUtils2.default.pathToPoints(pathString, options.samples, options.pointsSamplePercentage);
	
	      var divider = void 0,
	          background = void 0;
	
	      var startPoints = options.startEmpty ? [] : points;
	
	      if (_utils2.default.isNotNull(dividerColor)) {
	        divider = new fabric.Polyline(startPoints, {
	          fill: "transparent",
	          stroke: dividerColor,
	          strokeWidth: dividerWidth,
	          objectCaching: false
	        });
	      }
	
	      if (_utils2.default.isNotNull(backgroundColor)) {
	        background = new fabric.Polyline(startPoints, {
	          fill: "transparent",
	          stroke: backgroundColor,
	          strokeWidth: innerWidth,
	          objectCaching: false
	        });
	      }
	
	      if (options.addWithUpdate) {
	        this.activeRoadsGroup.addWithUpdate(background);
	        this.activeRoadsGroup.addWithUpdate(divider);
	      } else {
	        this.activeRoadsGroup.add(background);
	        this.activeRoadsGroup.add(divider);
	      }
	
	      // Make background not overlap divider of other active roads
	      background.sendToBack();
	
	      return {
	        dividerObj: divider,
	        backgroundObj: background,
	        points: points
	      };
	    }
	  }, {
	    key: "drawCrossing",
	    value: function drawCrossing(position, roadGroup) {
	      var _this3 = this;
	
	      return this.businessModel.loadSvg(this.layoutData.roadSettings.crossingIcon).then(function (fabricObj) {
	        fabricObj.originX = "center";
	        fabricObj.originY = "center";
	
	        fabricObj.top = position.y;
	        fabricObj.left = position.x;
	
	        fabricObj.scaleToWidth(_this3.layoutData.roadSettings.innerWidth - 2);
	        fabricObj.angle = position.rotation;
	
	        roadGroup.crossings.push(fabricObj);
	
	        return fabricObj;
	      }).catch(function (error) {
	        log.error("Failed to load crossings icon - %o", error);
	      });
	    }
	  }, {
	    key: "drawArrows",
	    value: function drawArrows() {
	      for (var i = 0; i < this.layoutData.roads.length; i++) {
	        if (_utils2.default.isNotNull(this.layoutData.roads[i].arrows) && this.layoutData.roads[i].arrows.length > 0) {
	          for (var j = 0; j < this.layoutData.roads[i].arrows.length; j++) {
	            var arrowInfo = this.layoutData.roads[i].arrows[j];
	
	            var arrowGroup = void 0;
	
	            if (this.arrowGroups.hasOwnProperty(arrowInfo.group)) {
	              arrowGroup = this.arrowGroups[arrowInfo.group];
	            } else {
	              arrowGroup = {};
	
	              arrowGroup.fabricObj = new fabric.Group([], {
	                hasBorders: false,
	                hasControls: false,
	                selectable: false,
	                evented: false,
	                reference: false,
	                opacity: 0
	              });
	
	              this.canvas.add(arrowGroup.fabricObj);
	
	              this.arrowGroups[arrowInfo.group] = arrowGroup;
	            }
	
	            arrowGroup.fabricObj.addWithUpdate(this.drawArrow(arrowInfo));
	          }
	        }
	      }
	    }
	  }, {
	    key: "drawArrow",
	    value: function drawArrow(position) {
	      var tmpArrow = fabric.util.object.clone(this._templateRoadArrow);
	      tmpArrow.left = position.x;
	      tmpArrow.top = position.y;
	      tmpArrow.angle = position.rotation;
	      tmpArrow.visible = true;
	      // tmpArrow.opacity = 0;
	
	      // tmpArrow.scaleToHeight(this.layoutData.roadSettings.dividerWidth * 3);
	
	      return tmpArrow;
	    }
	  }, {
	    key: "previewRoad",
	    value: function previewRoad(startPoint, intersections, endPoint, animationOptions) {
	      animationOptions = _utils2.default.isNotNull(animationOptions) ? animationOptions : {};
	
	      var foundRoad = this.findRoad(startPoint, endPoint, intersections);
	
	      if (_utils2.default.isNotNull(foundRoad)) {
	        log.debug("Found road: %o", foundRoad);
	
	        var connections = _roadUtils2.default.getConnectionsForRoad(foundRoad.data, startPoint, endPoint, intersections, this.layoutData);
	
	        log.info("Connection info for road [%s]\nStartPoint: %s --- EndPoint: %s --- Intersections: %o\nConnections: %o", foundRoad.data.key, startPoint, endPoint, intersections, connections);
	
	        var pathString = this.createPathForConnections(connections);
	
	        this.drawConnection(pathString, {
	          dividerWidth: animationOptions.roadDividerWidth || this.layoutData.roadSettings.dividerWidth,
	          innerWidth: this.layoutData.roadSettings.innerWidth,
	
	          dividerColor: animationOptions.roadDividerColor || this.layoutData.roadSettings.dividerColorActive,
	          backgroundColor: animationOptions.roadBackgroundColor || this.layoutData.roadSettings.roadColorActive,
	
	          addWithUpdate: true,
	          startEmpty: false,
	
	          // Active roads need to be animated so we can't just use path, we use PolyLine instead. This gives us control
	          // over all the points but the disadvantage of this is that the road might not be as nicely drawn as a path.
	          // Use 20% of the total path length as sample count (the more samples the more exact the road will be, 20% seems to be enough).
	          // A higher sample count = less performance since I assume PolyLine is less performant than Path.
	          // use 'samples' instead of 'pointsSamplePercentage' if you want to use an exact sample count
	          samples: null,
	          pointsSamplePercentage: 0.2,
	          addToGroup: this.previewGroup
	        });
	
	        this.previewGroup.bringToFront();
	        return this.previewGroup;
	      } else {
	        log.error("No road found for start point [%s] and end point [%s] with intersections [%o]", startPoint, endPoint, intersections);
	      }
	    }
	
	    /**
	     * waitOnPrevious: (boolean) waits on previous road to complete its animation before starting its own animation
	     */
	
	  }, {
	    key: "activateRoads",
	    value: function activateRoads(roads, animationOptions, waitOnPrevious) {
	      var _this4 = this;
	
	      var activateRoadsWait = function () {
	        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(context) {
	          var i;
	          return regeneratorRuntime.wrap(function _callee$(_context) {
	            while (1) {
	              switch (_context.prev = _context.next) {
	                case 0:
	                  i = 0;
	
	                case 1:
	                  if (!(i < roads.length)) {
	                    _context.next = 7;
	                    break;
	                  }
	
	                  _context.next = 4;
	                  return context.activateRoad(roads[i].startPoint, roads[i].intersections, roads[i].endPoint, animationOptions);
	
	                case 4:
	                  i++;
	                  _context.next = 1;
	                  break;
	
	                case 7:
	                case "end":
	                  return _context.stop();
	              }
	            }
	          }, _callee, this);
	        }));
	
	        return function activateRoadsWait(_x) {
	          return _ref.apply(this, arguments);
	        };
	      }();
	
	      if (waitOnPrevious) {
	        return activateRoadsWait(this);
	      } else {
	        return new Promise(function (resolve, reject) {
	          var roadsActivated = 0;
	
	          for (var i = 0; i < roads.length; i++) {
	            _this4.activateRoad(roads[i].startPoint, roads[i].intersections, roads[i].endPoint, animationOptions).then(function (data) {
	              if (++roadsActivated === roads.length) {
	                resolve();
	              }
	            });
	          }
	        });
	      }
	    }
	  }, {
	    key: "activateRoad",
	    value: function activateRoad(startPoint, intersections, endPoint, animationOptions) {
	      var _this5 = this;
	
	      animationOptions = _utils2.default.isNotNull(animationOptions) ? animationOptions : {};
	
	      return new Promise(function (resolve, reject) {
	        log.info("Activating road from '%s' to '%s'", startPoint, endPoint);
	
	        var activeConnectionInfo = _this5.findActiveConnection(startPoint, endPoint, intersections);
	
	        if (_utils2.default.isNotNull(activeConnectionInfo)) {
	          // reject(new AppError({ exception: new Error("Road is already activated" )}));
	          resolve();
	          return;
	        }
	
	        var foundRoad = _this5.findRoad(startPoint, endPoint, intersections);
	
	        if (_utils2.default.isNotNull(foundRoad)) {
	          log.debug("Found road: %o", foundRoad);
	
	          var connections = _roadUtils2.default.getConnectionsForRoad(foundRoad.data, startPoint, endPoint, intersections, _this5.layoutData);
	
	          log.info("Connection info for road [%s]\nStartPoint: %s --- EndPoint: %s --- Intersections: %o\nConnections: %o", foundRoad.data.key, startPoint, endPoint, intersections, connections);
	
	          var pathString = _this5.createPathForConnections(connections);
	
	          var activeConnectionGroup = _this5.drawActiveConnection(pathString, {
	            dividerWidth: _this5.layoutData.roadSettings.dividerWidth,
	            innerWidth: _this5.layoutData.roadSettings.innerWidth,
	
	            dividerColor: _this5.layoutData.roadSettings.dividerColorActive,
	            backgroundColor: _this5.layoutData.roadSettings.roadColorActive,
	
	            addWithUpdate: true,
	            startEmpty: true,
	
	            // Active roads need to be animate so we can't just use path, we use PolyLine instead. This gives us control
	            // over all the points but the disadvantage of this is that the road might not be as nicely drawn as a path
	            // Use 20% of the total path length as sample count (the more samples the more exact the road will be, 20% seems to be enough).
	            // A higher sample count = less performance since I assume PolyLine is less performant than Path.
	            // use samples instead of pointsSamplePercentage if you want to use an exact sample count
	            samples: null,
	            pointsSamplePercentage: 0.2
	          });
	
	          log.debug("ActiveConnectionGroup: %o", activeConnectionGroup);
	
	          if (_utils2.default.isNotNull(activeConnectionGroup)) {
	            activeConnectionGroup.connections = connections;
	            // Save parameters in activeConnectionGroup so we can easily find out if it's already active or to deactivate it.
	            activeConnectionGroup.parameters = { startPoint: startPoint, intersections: intersections, endPoint: endPoint };
	            _this5.activeConnections.push(activeConnectionGroup);
	
	            _this5.animateRoadForActiveConnection(activeConnectionGroup, animationOptions).then(resolve).catch(reject);
	          } else {
	            log.error("Failed to draw active connection for path [%s]", pathString);
	            reject(new _appError2.default({ exception: new Error("Failed to draw active connection for path") }));
	          }
	        } else {
	          log.error("No road found for start point [%s] and end point [%s] with intersections [%o]", startPoint, endPoint, intersections);
	          reject(new _appError2.default({ exception: new Error(_utils2.default.format("No road found for start point [{0}] and end point [{1}]", startPoint, endPoint)) }));
	        }
	      });
	    }
	  }, {
	    key: "createPathForConnections",
	    value: function createPathForConnections(connections) {
	      var newConnection = connections.length === 1 ? connections[0] : _roadUtils2.default.combineConnections(connections);
	
	      log.debug("Merged connection: %o\nOriginals: %o", newConnection, connections);
	
	      if (_utils2.default.isNotNull(newConnection)) {
	        var outerWidth = this.layoutData.roadSettings.outerWidth,
	            innerWidth = this.layoutData.roadSettings.innerWidth;
	
	        var pathString = _roadUtils2.default.getPathStringForNavigation(newConnection.startPosition, newConnection.navigation, newConnection.endPosition, innerWidth, outerWidth);
	
	        log.debug("Path string for merged connections: %s", pathString);
	
	        return pathString;
	      } else {
	        log.error("Failed to combine connections [%o]", connections);
	
	        return null;
	      }
	    }
	  }, {
	    key: "deactivateAllRoads",
	    value: function deactivateAllRoads(animationOptions) {
	      var allRoads = this.activeConnections.map(function (ar) {
	        return ar.parameters;
	      });
	      log.info("Deactivating all roads: %o", allRoads);
	      this.deactivateRoads(allRoads, animationOptions, false);
	    }
	  }, {
	    key: "deactivateRoads",
	    value: function deactivateRoads(roads, animationOptions, waitOnPrevious) {
	      var _this6 = this;
	
	      var deactivateRoadsWait = function () {
	        var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(context) {
	          var i;
	          return regeneratorRuntime.wrap(function _callee2$(_context2) {
	            while (1) {
	              switch (_context2.prev = _context2.next) {
	                case 0:
	                  i = 0;
	
	                case 1:
	                  if (!(i < roads.length)) {
	                    _context2.next = 7;
	                    break;
	                  }
	
	                  _context2.next = 4;
	                  return context.deactivateRoad(roads[i].startPoint, roads[i].intersections, roads[i].endPoint, animationOptions);
	
	                case 4:
	                  i++;
	                  _context2.next = 1;
	                  break;
	
	                case 7:
	                case "end":
	                  return _context2.stop();
	              }
	            }
	          }, _callee2, this);
	        }));
	
	        return function deactivateRoadsWait(_x2) {
	          return _ref2.apply(this, arguments);
	        };
	      }();
	
	      if (waitOnPrevious) {
	        return deactivateRoadsWait(this);
	      } else {
	        return new Promise(function (resolve, reject) {
	          var roadsDeactivated = 0;
	
	          for (var i = 0; i < roads.length; i++) {
	            _this6.deactivateRoad(roads[i].startPoint, roads[i].intersections, roads[i].endPoint, animationOptions).then(function (data) {
	              if (++roadsDeactivated === roads.length) {
	                resolve();
	              }
	            });
	          }
	        });
	      }
	    }
	  }, {
	    key: "deactivateRoad",
	    value: function deactivateRoad(startPoint, intersections, endPoint, animationOptions) {
	      var _this7 = this;
	
	      animationOptions = _utils2.default.isNotNull(animationOptions) ? animationOptions : {};
	
	      return new Promise(function (resolve, reject) {
	        log.info("Deactivating road from '%s' to '%s'", startPoint, endPoint);
	
	        var activeConnectionInfo = _this7.findActiveConnection(startPoint, endPoint, intersections);
	
	        if (_utils2.default.isNull(activeConnectionInfo)) {
	          reject(new _appError2.default({ exception: new Error("Road isn't active") }));
	        } else {
	          animationOptions = Object.assign({}, animationOptions, { inverse: true });
	
	          _this7.activeConnections.splice(activeConnectionInfo.index, 1);
	          _this7.animateRoadForActiveConnection(activeConnectionInfo.activeConnection, animationOptions).then(resolve).catch(reject);
	        }
	      });
	    }
	  }, {
	    key: "findRoad",
	    value: function findRoad(startPoint, endPoint, intersections) {
	      var foundRoad = null;
	
	      for (var i = 0; i < this.roads.length; i++) {
	        var roadGroup = this.roads[i];
	        var roadData = roadGroup.data;
	
	        var includesAllIntersections = true;
	
	        if (_utils2.default.isNotNull(intersections)) {
	          for (var j = 0; j < intersections.length; j++) {
	            if (!roadData.connects.includes(intersections[j])) {
	              includesAllIntersections = false;
	              break;
	            }
	          }
	        }
	
	        if (roadData.connects.includes(startPoint) && roadData.connects.includes(endPoint) && includesAllIntersections) {
	          foundRoad = roadGroup;
	          break;
	        }
	      }
	
	      return foundRoad;
	    }
	  }, {
	    key: "findActiveConnection",
	    value: function findActiveConnection(startPoint, endPoint, intersections) {
	      for (var i = 0; i < this.activeConnections.length; i++) {
	        var connectionParameters = this.activeConnections[i].parameters;
	
	        if (connectionParameters.startPoint === startPoint && connectionParameters.endPoint === endPoint && _utils2.default.arraysAreEqual(intersections, connectionParameters.intersections)) {
	          return { index: i, activeConnection: this.activeConnections[i] };
	        }
	      }
	
	      return null;
	    }
	  }, {
	    key: "animateRoadForActiveConnection",
	    value: function animateRoadForActiveConnection(activeConnectionGroup, animationOptions) {
	      var _this8 = this;
	
	      animationOptions = _utils2.default.isNotNull(animationOptions) ? animationOptions : {};
	
	      return new Promise(function (resolve, reject) {
	        log.debug("Animating road: %o --- animationOptions: %o", activeConnectionGroup, animationOptions);
	
	        if (_utils2.default.isNull(activeConnectionGroup.arrows)) // && !animationOptions.inverse
	          {
	            activeConnectionGroup.arrows = [];
	          }
	
	        if (animationOptions.instant) {
	          if (animationOptions.inverse) {
	            while (activeConnectionGroup.arrows.length > 0) {
	              var arrow = activeConnectionGroup.arrows.pop();
	              _this8.activeRoadsGroup.removeWithUpdate(arrow);
	            }
	
	            activeConnectionGroup.arrows = null;
	
	            _this8.activeRoadsGroup.removeWithUpdate(activeConnectionGroup.backgroundObj);
	            _this8.activeRoadsGroup.removeWithUpdate(activeConnectionGroup.dividerObj);
	          } else {
	            activeConnectionGroup.backgroundObj.set({ points: activeConnectionGroup.points });
	            activeConnectionGroup.dividerObj.set({ points: activeConnectionGroup.points });
	
	            _this8.canvas.renderAll();
	
	            activeConnectionGroup.backgroundObj.setCoords();
	            activeConnectionGroup.dividerObj.setCoords();
	
	            _this8.activeRoadsGroup.addWithUpdate();
	          }
	
	          _this8.showArrowGroup(activeConnectionGroup, animationOptions);
	
	          _this8.canvas.renderAll();
	
	          resolve(activeConnectionGroup);
	        } else {
	          if (animationOptions.inverse) _this8.showArrowGroup(activeConnectionGroup, animationOptions);
	
	          var lastPointIndexAdded = -1;
	
	          _this8.animationsRunning++;
	          fabric.util.animate({
	            startValue: 0,
	            endValue: activeConnectionGroup.points.length - 1,
	            duration: activeConnectionGroup.points.length * 10,
	            onChange: function onChange(value) {
	              value = Math.ceil(value);
	
	              if (value > lastPointIndexAdded) {
	                // log.debug("lastPointIndexAdded: %d --- Value: %d\nspliceStart: %d --- spliceLength: %d", lastPointIndexAdded, value, lastPointIndexAdded + 1, value - upToPoint);
	
	                if (animationOptions.inverse) {
	                  activeConnectionGroup.backgroundObj.points.splice(0, value - lastPointIndexAdded);
	                  activeConnectionGroup.dividerObj.points.splice(0, value - lastPointIndexAdded);
	                } else {
	                  var pointsToConcat = activeConnectionGroup.points.slice(lastPointIndexAdded + 1, value + 1);
	
	                  activeConnectionGroup.backgroundObj.points = activeConnectionGroup.backgroundObj.points.concat(pointsToConcat);
	                  activeConnectionGroup.dividerObj.points = activeConnectionGroup.dividerObj.points.concat(pointsToConcat);
	                }
	
	                _this8.canvas.renderAll();
	
	                lastPointIndexAdded = value;
	              }
	            },
	            onComplete: function onComplete() {
	              _this8.animationsRunning--;
	              _this8.setShouldAbortAnimations();
	
	              if (animationOptions.inverse) {
	                while (activeConnectionGroup.arrows.length > 0) {
	                  var _arrow = activeConnectionGroup.arrows.pop();
	                  _this8.activeRoadsGroup.removeWithUpdate(_arrow);
	                }
	
	                activeConnectionGroup.arrows = null;
	
	                _this8.activeRoadsGroup.removeWithUpdate(activeConnectionGroup.backgroundObj);
	                _this8.activeRoadsGroup.removeWithUpdate(activeConnectionGroup.dividerObj);
	              } else {
	                activeConnectionGroup.backgroundObj.setCoords();
	                activeConnectionGroup.dividerObj.setCoords();
	
	                _this8.showArrowGroup(activeConnectionGroup, animationOptions);
	              }
	
	              _this8.canvas.renderAll();
	
	              log.debug("Road animation complete");
	
	              if (_this8.shouldAbortAnimations) {
	                _this8.setShouldAbortAnimations();
	                reject();
	              } else {
	                resolve(activeConnectionGroup);
	              }
	            },
	            abort: function abort() {
	              return _this8.shouldAbortAnimations;
	            }
	          });
	        }
	      });
	    }
	  }, {
	    key: "showArrowGroup",
	    value: function showArrowGroup(activeConnectionGroup, animationOptions) {
	      if (animationOptions.instant || true) {
	        // Hide arrow
	        for (var i = 0; i < activeConnectionGroup.connections.length; i++) {
	          var arrowGroup = activeConnectionGroup.connections[i].arrowGroup;
	
	          if (this.arrowGroups.hasOwnProperty(arrowGroup)) {
	            this.arrowGroups[arrowGroup].fabricObj.opacity = animationOptions.inverse ? 0 : 1;
	            /*for(let j = 0; j < this.arrowGroups[arrowGroup].fabricObj._objects.length; j++)
	            {
	              let arrowObj = this.arrowGroups[arrowGroup].fabricObj._objects[j];
	              arrowObj.opacity = animationOptions.inverse ? 0 : 1;
	            }*/
	          }
	        }
	      } else {
	        if (animationOptions.inverse) {} else {}
	      }
	    }
	  }, {
	    key: "setShouldAbortAnimations",
	    value: function setShouldAbortAnimations() {
	      log.info("Should abort ? %s --- animationsRunning ? %d", this.shouldAbortAnimations, this.animationsRunning);
	
	      if (this.shouldAbortAnimations && this.animationsRunning <= 0) {
	        this.shouldAbortAnimations = false;
	      }
	    }
	  }, {
	    key: "abortAnimations",
	    value: function abortAnimations() {
	      if (this.animationsRunning > 0) {
	        this.shouldAbortAnimations = true;
	      }
	    }
	  }]);
	
	  return RoadMap;
	}();
	
	exports.default = RoadMap;

/***/ }),

/***/ 469:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Created by jv on 2019-09-02 (15:28).
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */
	
	
	var _utils = __webpack_require__(3);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _appError = __webpack_require__(51);
	
	var _appError2 = _interopRequireDefault(_appError);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var log = __webpack_require__(5)();
	
	var Sector = function () {
	  function Sector(options) {
	    _classCallCheck(this, Sector);
	
	    if (_utils2.default.isNull(options)) throw new _appError2.default({ exception: new Error("Options for BusinessModel cannot be null") });
	
	    this.businessModel = options.businessModel;
	
	    this.id = this.businessModel.id;
	
	    this.containerElement = this.businessModel.containerElement;
	    this.layoutData = this.businessModel.layoutData;
	
	    this.canvas = this.businessModel.canvas;
	    this.sectorGroup = null;
	
	    this.sectorData = options.sectorData;
	    this.key = this.sectorData.key;
	
	    this.backgroundObj = null;
	    this.iconObj = null;
	    this.iconActiveObj = null;
	    this.textObj = null;
	
	    this.active = false;
	
	    this.previewBackground = null;
	
	    this.iconActiveSource = null;
	
	    this.animationsRunning = 0;
	    this.shouldAbortAnimations = false;
	
	    this.hasRendered = false;
	    this.onRenderComplete = options.onRenderComplete;
	  }
	
	  _createClass(Sector, [{
	    key: "render",
	    value: function render() {
	      var _this = this;
	
	      this.hasRendered = false;
	
	      this.businessModel.drawDebugInfo(this.key, this.sectorData.position, "#FF0000", this.layoutData.sectorSettings.size.width / 2);
	
	      this.businessModel.loadSvg(this.sectorData.icon).then(function (iconInactive) {
	        _this.iconActiveSource = _this.sectorData.iconActive;
	
	        if (_utils2.default.isNotNull(_this.sectorData.iconActive)) {
	          _this.businessModel.loadSvg(_this.sectorData.iconActive).then(function (iconActive) {
	            _this._onIconsLoaded(iconInactive, iconActive);
	          }).catch(function (err) {
	            log.error("Failed to load sector icon %s - %o", _this.sectorData.iconActive, err);
	          });
	        } else {
	          _this._onIconsLoaded(iconInactive, null);
	        }
	      }).catch(function (err) {
	        log.error("Failed to load sector icon %s - %o", _this.sectorData.icon, err);
	      });
	    }
	  }, {
	    key: "_onIconsLoaded",
	    value: function _onIconsLoaded(iconInactive, iconActive) {
	      var groupArray = [];
	
	      this.backgroundObj = this.setSectorBackground();
	      groupArray.push(this.backgroundObj);
	
	      // InactiveIcon
	      this.iconObj = this.setSectorIcon(iconInactive);
	      groupArray.push(this.iconObj);
	
	      if (_utils2.default.isNotNull(iconActive)) {
	        // ActiveIcon
	        this.iconActiveObj = this.setSectorIcon(iconActive);
	        this.iconActiveObj.set({ opacity: 0 });
	        groupArray.push(this.iconActiveObj);
	      }
	
	      if (!_utils2.default.isFunction(this.sectorData.name)) {
	        this.sectorData.name = function () {
	          return "";
	        };
	      }
	
	      this.textObj = this.setSectorName();
	      groupArray.push(this.textObj);
	
	      groupArray.push(this.createPreviewOverlay());
	
	      this.sectorGroup = new fabric.Group(groupArray, {
	        objectCaching: false
	      });
	
	      this.hasRendered = true;
	
	      if (_utils2.default.isFunction(this.onRenderComplete)) {
	        this.onRenderComplete.call(this);
	      }
	    }
	  }, {
	    key: "createPreviewOverlay",
	    value: function createPreviewOverlay() {
	      this.previewBackground = this.setSectorBackground();
	      this.previewBackground.set({
	        fill: "transparent",
	        stroke: "transparent",
	        strokeDashArray: null,
	        strokeWidth: 2,
	        visible: false
	      });
	
	      return this.previewBackground;
	    }
	  }, {
	    key: "setSectorBackground",
	    value: function setSectorBackground() {
	      var sectorBackground = new fabric.Rect({
	        width: this.layoutData.sectorSettings.size.width, height: this.layoutData.sectorSettings.size.height,
	        left: this.sectorData.position.x, top: this.sectorData.position.y,
	        fill: this.layoutData.sectorSettings.backgroundColor,
	        angle: 0,
	        rx: this.layoutData.sectorSettings.radius.rx,
	        ry: this.layoutData.sectorSettings.radius.ry,
	        selectable: false,
	        hoverCursor: "default"
	      });
	
	      if (this.sectorData.startsEmpty) {
	        sectorBackground.set({
	          stroke: this.layoutData.sectorSettings.strokeColor,
	          strokeDashArray: [5, 5],
	          strokeWidth: 2
	        });
	      }
	
	      sectorBackground.setShadow({
	        color: "rgba(0, 0, 0, 0.3)",
	        blur: 3,
	        offsetX: 0,
	        offsetY: 0
	      });
	
	      return sectorBackground;
	    }
	  }, {
	    key: "setSectorIcon",
	    value: function setSectorIcon(fabricObj) {
	      if (_utils2.default.isNotNull(fabricObj)) {
	        fabricObj.originX = "center";
	        fabricObj.originY = "center";
	
	        fabricObj.top = this.backgroundObj.top + this.layoutData.sectorSettings.size.height / 2;
	        fabricObj.left = this.backgroundObj.left + this.layoutData.sectorSettings.size.width / 2;
	
	        fabricObj.evented = false;
	        fabricObj.selectable = false;
	        fabricObj.hasBorders = false;
	        fabricObj.hasControls = false;
	        fabricObj.reference = false;
	
	        return fabricObj;
	      }
	
	      return null;
	    }
	  }, {
	    key: "setSectorName",
	    value: function setSectorName() {
	      var sectorName = this.sectorData.name().toUpperCase();
	
	      return new fabric.Textbox(sectorName, {
	        width: this.layoutData.sectorSettings.size.width * 0.9,
	        height: this.layoutData.sectorSettings.size.height * 0.2,
	        originX: "center",
	        originY: "bottom",
	        top: this.backgroundObj.top + this.layoutData.sectorSettings.size.height - 10,
	        left: this.backgroundObj.left + this.layoutData.sectorSettings.size.width / 2,
	
	        fontFamily: "Rubik",
	        fontSize: 12,
	        charSpacing: 20,
	        textAlign: "center",
	
	        evented: false,
	        selectable: false,
	        hasBorders: false,
	        hasControls: false,
	        reference: false
	      });
	    }
	  }, {
	    key: "setActiveIcon",
	    value: function setActiveIcon(source, type) {
	      var _this2 = this;
	
	      if (source === this.iconActiveSource) return;
	      this.iconActiveSource = source;
	
	      return this.businessModel.loadSvg(source).then(function (iconActive) {
	        if (_utils2.default.isNotNull(_this2.iconActiveObj)) {
	          _this2.sectorGroup.remove(_this2.iconActiveObj);
	        }
	
	        _this2.iconActiveObj = _this2.setSectorIcon(iconActive);
	        _this2.sectorGroup.add(_this2.iconActiveObj);
	
	        _this2.canvas.renderAll();
	      }).catch(function (err) {
	        log.error("Failed to load sector icon %s - %o", source, err);
	      });
	    }
	  }, {
	    key: "setText",
	    value: function setText(text) {
	      this.textObj.set({ text: text.toUpperCase() });
	      this.canvas.renderAll();
	    }
	  }, {
	    key: "preview",
	    value: function preview(animationOptions, render) {
	      this.previewBackground.set({
	        visible: true,
	        stroke: animationOptions.sectorStrokeColorPreview || "transparent",
	        strokeDashArray: null,
	        strokeWidth: animationOptions.sectorStrokeWidthPreview || 0
	      });
	
	      if (render) this.canvas.renderAll();
	
	      return this;
	    }
	  }, {
	    key: "hidePreview",
	    value: function hidePreview(render) {
	      this.previewBackground.set({ visible: false });
	
	      if (render) this.canvas.renderAll();
	    }
	  }, {
	    key: "activate",
	    value: function activate(animationOptions) {
	      var _this3 = this;
	
	      log.info("Activating sector for key [%s] - %o", this.key, animationOptions);
	
	      animationOptions = _utils2.default.isNotNull(animationOptions) ? animationOptions : {};
	
	      if (_utils2.default.isNull(this.iconActiveObj)) {
	        throw new _appError2.default({ exception: new Error("Sector doesn't have an active icon - first call sector.setActiveIcon before activating") });
	      }
	
	      if (animationOptions.instant) {
	        this.backgroundObj.set({
	          fill: animationOptions.sectorBackgroundColorPreview || this.layoutData.sectorSettings.backgroundColorActive,
	          stroke: "transparent",
	          strokeDashArray: null,
	          strokeWidth: animationOptions.sectorStrokeWidthPreview || 0
	        });
	
	        this.iconObj.set({ opacity: 0 });
	        this.iconActiveObj.set({ opacity: 1 });
	      } else {
	        var animationDuration = this.layoutData.animationDuration || 300;
	
	        this.animationsRunning++;
	        this.iconObj.animate("opacity", 0, {
	          duration: animationDuration,
	          onComplete: function onComplete() {
	            _this3.animationsRunning--;
	            _this3.setShouldAbortAnimations();
	          },
	          abort: function abort() {
	            return _this3.shouldAbortAnimations;
	          }
	        });
	
	        this.animationsRunning++;
	        this.iconActiveObj.animate("opacity", 1, {
	          duration: animationDuration,
	          onComplete: function onComplete() {
	            _this3.animationsRunning--;
	            _this3.setShouldAbortAnimations();
	          },
	          abort: function abort() {
	            return _this3.shouldAbortAnimations;
	          }
	        });
	
	        var fromColor = this.layoutData.sectorSettings.backgroundColor,
	            toColor = animationOptions.sectorBackgroundColorPreview || this.layoutData.sectorSettings.backgroundColorActive;
	
	        this.animationsRunning++;
	        fabric.util.animateColor(fromColor, toColor, animationDuration, {
	          onChange: function onChange(value) {
	            _this3.backgroundObj.set("fill", value);
	            _this3.backgroundObj.canvas.renderAll();
	          },
	          onComplete: function onComplete() {
	            _this3.animationsRunning--;
	
	            _this3.setShouldAbortAnimations();
	
	            _this3.backgroundObj.set({
	              fill: toColor,
	              stroke: animationOptions.sectorStrokeColorPreviewActive || "transparent",
	              strokeDashArray: null,
	              strokeWidth: animationOptions.sectorStrokeWidthPreview || 2
	            });
	
	            _this3.active = false;
	
	            resolve();
	          },
	          abort: function abort() {
	            return _this3.shouldAbortAnimations;
	          }
	        });
	
	        if (this.active && !animationOptions.instant) {
	          this.flash(this.layoutData.sectorSettings.backgroundColorActive, this.layoutData.sectorSettings.backgroundColor);
	        }
	      }
	
	      this.active = true;
	
	      this.canvas.renderAll();
	    }
	  }, {
	    key: "flash",
	    value: function flash(startColor, endColor) {
	      var _this4 = this;
	
	      // %TODO: better 'already active' animation
	
	      var pulseCount = 5;
	      var pulseDuration = 1000 / pulseCount;
	      var i = 0;
	
	      var pulseAnimation = function pulseAnimation(fromColor, toColor) {
	        if (i++ > pulseCount || _this4.shouldAbortAnimations) return;
	
	        _this4.animationsRunning++;
	        fabric.util.animateColor(fromColor, toColor, pulseDuration, {
	          onChange: function onChange(value) {
	            _this4.backgroundObj.set("fill", value);
	            _this4.backgroundObj.canvas.renderAll();
	          },
	          onComplete: function onComplete() {
	            _this4.animationsRunning--;
	
	            if (_this4.shouldAbortAnimations) {
	              _this4.setShouldAbortAnimations();
	            } else {
	              if (i % 2 === 0) {
	                pulseAnimation(_this4.layoutData.sectorSettings.backgroundColorActive, _this4.layoutData.sectorSettings.backgroundColor);
	              } else {
	                pulseAnimation(_this4.layoutData.sectorSettings.backgroundColor, _this4.layoutData.sectorSettings.backgroundColorActive);
	              }
	            }
	          },
	          abort: function abort() {
	            return _this4.shouldAbortAnimations;
	          }
	        });
	      };
	
	      pulseAnimation(startColor, endColor);
	    }
	  }, {
	    key: "deactivate",
	    value: function deactivate(animationOptions) {
	      var _this5 = this;
	
	      log.info("Deactivating sector for key [%s]", this.key);
	
	      animationOptions = _utils2.default.isNotNull(animationOptions) ? animationOptions : {};
	
	      // Copy object
	      animationOptions = Object.assign({}, animationOptions, { instant: true });
	
	      return new Promise(function (resolve, reject) {
	        var animationDuration = animationOptions.instant ? 1 : _this5.layoutData.animationDuration;
	
	        if (animationOptions.instant) {
	          _this5.iconObj.set({ opacity: 1 });
	          _this5.iconActiveObj.set({ opacity: 0 });
	
	          _this5.backgroundObj.set("fill", _this5.layoutData.sectorSettings.backgroundColor);
	
	          if (animationOptions.isPreview) {
	            _this5.backgroundObj.set({
	              stroke: animationOptions.sectorStrokeColorPreviewInactive || _this5.layoutData.sectorSettings.strokeColor,
	              strokeDashArray: null,
	              strokeWidth: animationOptions.sectorStrokeWidthPreview || 2
	            });
	          } else if (_this5.sectorData.startsEmpty) {
	            _this5.backgroundObj.set({
	              stroke: animationOptions.sectorStrokeColorPreviewInactive || _this5.layoutData.sectorSettings.strokeColor,
	              strokeDashArray: [5, 5],
	              strokeWidth: 2
	            });
	          }
	
	          _this5.active = false;
	
	          resolve();
	        } else {
	          _this5.animationsRunning++;
	          _this5.iconObj.animate("opacity", 1, {
	            duration: animationDuration,
	            onComplete: function onComplete() {
	              _this5.animationsRunning--;
	              _this5.setShouldAbortAnimations();
	            },
	            abort: function abort() {
	              return _this5.shouldAbortAnimations;
	            }
	          });
	
	          _this5.animationsRunning++;
	          _this5.iconActiveObj.animate("opacity", 0, {
	            duration: animationDuration,
	            onComplete: function onComplete() {
	              _this5.animationsRunning--;
	              _this5.setShouldAbortAnimations();
	            },
	            abort: function abort() {
	              return _this5.shouldAbortAnimations;
	            }
	          });
	
	          var fromColor = _this5.layoutData.sectorSettings.backgroundColorActive,
	              toColor = animationOptions.sectorBackgroundColorPreview || _this5.layoutData.sectorSettings.backgroundColor;
	
	          _this5.animationsRunning++;
	          fabric.util.animateColor(fromColor, toColor, animationDuration, {
	            onChange: function onChange(value) {
	              _this5.backgroundObj.set("fill", value);
	              _this5.backgroundObj.canvas.renderAll();
	            },
	            onComplete: function onComplete() {
	              _this5.animationsRunning--;
	
	              _this5.setShouldAbortAnimations();
	
	              if (_this5.shouldAbortAnimations) {
	                _this5.backgroundObj.set("fill", _this5.layoutData.sectorSettings.backgroundColor);
	              }
	
	              if (animationOptions.isPreview) {
	                _this5.backgroundObj.set({
	                  stroke: animationOptions.sectorStrokeColorPreviewInactive || _this5.layoutData.sectorSettings.strokeColor,
	                  strokeDashArray: null,
	                  strokeWidth: animationOptions.sectorStrokeWidthPreview || 2
	                });
	              } else if (_this5.sectorData.startsEmpty) {
	                _this5.backgroundObj.set({
	                  stroke: animationOptions.sectorStrokeColorPreviewInactive || _this5.layoutData.sectorSettings.strokeColor,
	                  strokeDashArray: [5, 5],
	                  strokeWidth: 2
	                });
	              }
	
	              _this5.active = false;
	
	              resolve();
	            },
	            abort: function abort() {
	              return _this5.shouldAbortAnimations;
	            }
	          });
	        }
	      });
	    }
	  }, {
	    key: "setShouldAbortAnimations",
	    value: function setShouldAbortAnimations() {
	      if (this.shouldAbortAnimations && this.animationsRunning <= 0) {
	        this.shouldAbortAnimations = false;
	      }
	    }
	  }, {
	    key: "abortAnimations",
	    value: function abortAnimations() {
	      if (this.animationsRunning > 0) {
	        this.shouldAbortAnimations = true;
	      }
	    }
	  }]);
	
	  return Sector;
	}();
	
	exports.default = Sector;

/***/ }),

/***/ 494:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	/**
	 * Created by jv on 20/01/2017.
	 */
	var tooltip = {};
	
	(function (Tooltip) {
	  /*
	   *  options.selector
	   *  options.trigger
	   *  options.title
	   *  options.content
	   *  options.placement
	   */
	  Tooltip.create = function (options) {
	    $(options.selector).popover({
	      content: options.content,
	      title: options.title || "",
	      placement: options.placement || "auto",
	      trigger: options.trigger || "hover",
	      html: true
	    });
	  };
	
	  Tooltip.dispose = function (options) {
	    try {
	      $(options.selector).popover("dispose");
	    } catch (e) {
	      // ignore?: dispose sometimes gives nullpointer on removeChild //%TODO: find out why
	    }
	  };
	})(tooltip);
	
	module.exports = tooltip;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),

/***/ 495:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	/**
	 * Created by jv on 16/01/2017.
	 */
	var config = {
	  serviceBaseURL: "/services",
	  something: {}
	};
	
	if (false) {
	  config.something.something = "";
	} else {
	  config.something.something = "";
	}
	
	module.exports = config;

/***/ }),

/***/ 496:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	/**
	 * Created by jv on 22/08/2017.
	 */
	var utils = __webpack_require__(3);
	
	var HistoryController = {};
	
	(function (HistoryController) {
	  var history = window.history;
	
	  HistoryController.currentState = function () {
	    if (utils.isNotNull(history)) {
	      return history.state;
	    }
	  };
	
	  HistoryController.back = function () {
	    if (utils.isNotNull(history)) {
	      history.back();
	    }
	  };
	
	  HistoryController.forward = function () {
	    if (utils.isNotNull(history)) {
	      history.forward();
	    }
	  };
	
	  HistoryController.go = function (index) {
	    if (utils.isNotNull(history)) {
	      history.go(index);
	    }
	  };
	
	  HistoryController.pushState = function (stateObj, title, url) {
	    if (utils.isNotNull(history)) {
	      history.pushState(stateObj, title, url);
	    }
	  };
	
	  HistoryController.replaceState = function (stateObj, title, url) {
	    if (utils.isNotNull(history)) {
	      history.replaceState(stateObj, title, url);
	    }
	  };
	})(HistoryController);
	
	module.exports = HistoryController;

/***/ }),

/***/ 497:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	var _storageController = __webpack_require__(50);
	
	var _storageController2 = _interopRequireDefault(_storageController);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var utils = __webpack_require__(3); /**
	                                             * Created by jv on 23/12/2016.
	                                             */
	
	var GoogleAnalytics = {};
	var TAG_ID = "G-2J8QRVHM3L";
	
	$(function () {
	  GoogleAnalytics.addScriptIfConsented();
	});
	
	(function (GoogleAnalytics) {
	  GoogleAnalytics.hasConsented = function () {
	    return String(_storageController2.default.getCookie(_storageController2.default.keys.COOKIEPOLIYCY_ANALYTICS_CONSENT)) === "true";
	  };
	
	  GoogleAnalytics.enable = function () {
	    insertScriptTag();
	  };
	
	  GoogleAnalytics.disable = function () {
	    removeScriptTag();
	    removeGACookies();
	  };
	
	  GoogleAnalytics.addScriptIfConsented = function () {
	    if (GoogleAnalytics.hasConsented()) {
	      insertScriptTag();
	    }
	  };
	
	  function insertScriptTag() {
	    console.log("adding script");
	
	    var script = document.createElement('script');
	    script.type = 'text/javascript';
	    script.src = 'https://www.googletagmanager.com/gtag/js?id=' + TAG_ID;
	    $(script)[0].setAttribute("async", "");
	    document.head.appendChild(script);
	
	    window.dataLayer = window.dataLayer || [];
	
	    function gtag() {
	      window.dataLayer.push(arguments);
	    }
	
	    gtag('js', new Date());
	    gtag('config', TAG_ID);
	  }
	
	  function removeScriptTag() {
	    var $gaScriptEl = $("script[src='https://www.googletagmanager.com/gtag/js?id=" + TAG_ID + "']");
	    $gaScriptEl.remove();
	    if (!utils.isUndefined(window.dataLayer)) {
	      window.dataLayer = window.dataLayer.filter(function (x) {
	        return x[0] !== "js" && x[0] !== "config";
	      });
	    }
	  }
	
	  function removeGACookies() {
	    _storageController2.default.removeCookie("_ga");
	    _storageController2.default.removeCookie("_ga_" + TAG_ID);
	    _storageController2.default.removeCookie("_gid");
	  }
	})(GoogleAnalytics);
	
	module.exports = GoogleAnalytics;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),

/***/ 498:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Created by jv on 2019-09-09 (15:49).
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */
	
	
	var _utils = __webpack_require__(3);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var log = __webpack_require__(5)();
	
	var SOCKET_STATES = {
	  CONNECTING: WebSocket ? WebSocket.CONNECTING : 0,
	  OPEN: WebSocket ? WebSocket.OPEN : 1,
	  CLOSING: WebSocket ? WebSocket.CLOSING : 2,
	  CLOSED: WebSocket ? WebSocket.CLOSED : 3
	};
	
	var WebSocketClient = function () {
	  function WebSocketClient(options) {
	    _classCallCheck(this, WebSocketClient);
	
	    this.url = options.url;
	
	    this.onOpen = options.onOpen;
	    this.onClose = options.onClose;
	    this.onError = options.onError;
	    this.onMessage = options.onMessage;
	  }
	
	  _createClass(WebSocketClient, [{
	    key: "open",
	    value: function open() {
	      var _this = this;
	
	      this.socket = new WebSocket(this.url);
	
	      this.socket.onopen = function (event) {
	        return _this._onOpen(event);
	      };
	      this.socket.onmessage = function (event) {
	        return _this._onMessage(event);
	      };
	      this.socket.onclose = function (event) {
	        return _this._onClose(event);
	      };
	      this.socket.onerror = function (event) {
	        return _this._onError(event);
	      };
	    }
	  }, {
	    key: "close",
	    value: function close(code, reason) {
	      if (_utils2.default.isNotNull(this.socket) && this.socket.readyState === SOCKET_STATES.OPEN) {
	        this.socket.close(code, reason);
	      }
	    }
	  }, {
	    key: "isConnected",
	    value: function isConnected() {
	      if (_utils2.default.isNotNull(this.socket)) {
	        return this.socket.readyState === SOCKET_STATES.OPEN;
	      }
	
	      return false;
	    }
	  }, {
	    key: "isClosed",
	    value: function isClosed() {
	      if (_utils2.default.isNotNull(this.socket)) {
	        return this.socket.readyState === SOCKET_STATES.CLOSED;
	      }
	
	      return false;
	    }
	  }, {
	    key: "sendData",
	    value: function sendData(data) {
	      if (_utils2.default.isNotNull(this.socket) && this.isConnected()) {
	        this.socket.send(data);
	      }
	    }
	  }, {
	    key: "_onOpen",
	    value: function _onOpen(event) {
	      // log.debug("websocket connection established - %o", event);
	
	      if (_utils2.default.isFunction(this.onOpen)) {
	        this.onOpen.call(this, event);
	      }
	    }
	  }, {
	    key: "_onMessage",
	    value: function _onMessage(event) {
	      // log.debug("websocket messaged received - %o", event);
	
	      if (_utils2.default.isFunction(this.onMessage)) {
	        this.onMessage.call(this, event);
	      }
	    }
	  }, {
	    key: "_onClose",
	    value: function _onClose(event) {
	      // log.debug("websocket connection closed - %o", event);
	
	      if (_utils2.default.isFunction(this.onClose)) {
	        this.onClose.call(this, event);
	      }
	    }
	  }, {
	    key: "_onError",
	    value: function _onError() {
	      // log.error("websocket error occurred - %o", event);
	
	      if (_utils2.default.isFunction(this.onError)) {
	        this.onError.call(this, event);
	      }
	    }
	  }]);
	
	  return WebSocketClient;
	}();
	
	exports.default = WebSocketClient;

/***/ }),

/***/ 500:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	/**
	 * Created by jv on 10/02/2021.
	 */
	var LanguageManager = __webpack_require__(6);
	var utils = __webpack_require__(3);
	var StorageController = __webpack_require__(502);
	var GoogleAnalytics = __webpack_require__(497);
	
	//Require the css like any other css file
	__webpack_require__(392);
	__webpack_require__(448); // requires the cookieconsent library like it was a script tag in the html
	// var cookieconsent = require("exports?cookieconsent!cookieconsent/build/cookieconsent.min.js"); // Doesn't rly do much, it still exposes cookieconsent to the window but it now also exports the value
	// import CC from "CookieConsent";
	
	var CookieconsentController = {};
	
	(function (CookieconsentController) {
	  CookieconsentController.initialize = function () {
	    var consentCookie = StorageController.getCookie(StorageController.keys.COOKIEPOLIYCY_ANALYTICS_CONSENT);
	
	    if (utils.isNull(consentCookie)) {
	      StorageController.removeCookie("cookieconsent_status");
	    }
	
	    window.cookieconsent.initialise({
	      "palette": {
	        "popup": {
	          "background": "#222222",
	          "text": "#ffffff"
	        },
	        "button": {
	          "background": "#28aae1",
	          "text": "#ffffff"
	        }
	      },
	      "theme": "classic",
	      "type": "opt-in",
	      "content": {
	        "message": LanguageManager.getValueForKey("cookies.message"),
	        "deny": LanguageManager.getValueForKey("cookies.button.deny.text"),
	        "allow": LanguageManager.getValueForKey("cookies.button.allow.text"),
	        "link": LanguageManager.getValueForKey("cookies.link.text"),
	        "href": LanguageManager.getValueForKey("cookies.link")
	      },
	      "cookie": {
	        "expiryDays": 365
	      },
	      "onStatusChange": function onStatusChange(status, chosenBefore) {
	        var enableCookies = status === "allow";
	        //utils.devLog("User has chosen to '%s' cookies", (enableCookies ? "enabled" : "disable"));
	        StorageController.saveCookie(StorageController.keys.COOKIEPOLIYCY_ANALYTICS_CONSENT, enableCookies, 365);
	
	        if (enableCookies) {
	          onConsented();
	        } else {
	          onDeclined();
	        }
	      }
	    });
	  };
	
	  function onConsented() {
	    console.log(GoogleAnalytics);
	    GoogleAnalytics.enable();
	    //GoogleAnalytics.triggerPageVisit();
	  }
	
	  function onDeclined() {
	    GoogleAnalytics.disable();
	  }
	})(CookieconsentController);
	
	module.exports = CookieconsentController;

/***/ }),

/***/ 502:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _jsCookie = __webpack_require__(425);
	
	var _jsCookie2 = _interopRequireDefault(_jsCookie);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// This gives errors in the browser, don't know why :(
	//const Cookies = require("js-cookie");
	var utils = __webpack_require__(3); /**
	                                             * Created by jv on 13/01/2017.
	                                             */
	
	/*
	  Probably never used.
	  You probably want to use the storage-controller in controllers/storage-controller.js
	 */
	
	var storageController = {};
	
	(function (StorageController) {
	  StorageController.keys = {
	    COOKIEPOLIYCY_ANALYTICS_CONSENT: "cookiepolicy_analytics_consent"
	  };
	
	  StorageController.clearAll = function () {
	    StorageController.clearSession();
	    StorageController.clearLocal();
	  };
	
	  StorageController.clearSession = function () {
	    sessionStorage.clear();
	  };
	
	  StorageController.clearLocal = function () {
	    localStorage.clear();
	  };
	
	  StorageController.removeFromSession = function (key) {
	    StorageController.saveToSession(key);
	  };
	
	  StorageController.saveToSession = function (key, obj) {
	    if (storageKeyIsValid(key)) {
	      // if obj is null then remove
	      if (utils.isUndefined(obj)) {
	        sessionStorage.removeItem(key);
	      } else {
	        if (utils.isObject(obj)) {
	          obj = utils.stringifyJSON(obj);
	        }
	
	        sessionStorage.setItem(key, obj);
	      }
	    } else {
	      console.error("Invalid storage key [%s]", key);
	    }
	  };
	
	  StorageController.getFromSession = function (key) {
	    if (storageKeyIsValid(key)) {
	      var tmpValue = sessionStorage.getItem(key);
	
	      if (tmpValue) {
	        return utils.parseJSON(tmpValue, true);
	      }
	
	      return tmpValue;
	    } else {
	      console.error("Invalid storage key [%s]", key);
	    }
	
	    return null;
	  };
	
	  StorageController.removeFromLocal = function (key) {
	    StorageController.saveToLocal(key);
	  };
	
	  StorageController.saveToLocal = function (key, obj) {
	    if (storageKeyIsValid(key)) {
	      if (utils.isUndefined(obj)) {
	        localStorage.removeItem(key);
	      } else {
	        if (utils.isObject(obj)) {
	          obj = utils.stringifyJSON(obj);
	        }
	
	        localStorage.setItem(key, obj);
	      }
	    } else {
	      console.error("Invalid storage key [%s]", key);
	    }
	  };
	
	  StorageController.getFromLocal = function (key, json) {
	    if (storageKeyIsValid(key)) {
	      var tmpValue = localStorage.getItem(key);
	
	      if (tmpValue) {
	        return utils.parseJSON(tmpValue, true);
	      }
	
	      return tmpValue;
	    } else {
	      console.error("Invalid storage key [%s]", key);
	    }
	
	    return null;
	  };
	
	  StorageController.saveCookie = function (name, value, daysUntilExpire) {
	    var options = {};
	    if (utils.isNumber(daysUntilExpire)) {
	      options.expires = daysUntilExpire;
	    }
	
	    _jsCookie2.default.set(name, value, { expires: daysUntilExpire });
	  };
	
	  StorageController.getCookie = function (name) {
	    return _jsCookie2.default.get(name);
	  };
	
	  StorageController.removeCookie = function (name) {
	    _jsCookie2.default.remove(name);
	  };
	
	  function storageKeyIsValid(key) {
	    for (var objKey in StorageController.keys) {
	      if (StorageController.keys.hasOwnProperty(objKey) && StorageController.keys[objKey] === key) {
	        return true;
	      }
	    }
	
	    return false;
	  }
	})(storageController);
	
	module.exports = storageController;

/***/ })

});


// WEBPACK FOOTER //
// js/commons.1bebbabf34ac93e4a3dd.js